import React, { useState, useEffect } from "react";
import logo from "../imgs/liblogo.png";

// Library Call Number Utility (mirrored from backend)
// Format: PREFIX.DDC-CUTTER-YEAR

// Cutter Sanborn Table for generating proper library call numbers
const CUTTER_TABLE = {
  'A': {
    'Aa': '111', 'Aal': '112', 'Aar': '113', 'Aars': '114', 'Aas': '115',
    'Aba': '116', 'Abal': '117', 'Abar': '118', 'Abat': '119', 'Abau': '121',
    'Abb': '122', 'Abbat': '123', 'Abbe': '124', 'Abbo': '125', 'Abbot': '126',
    'Abbot, J.': '127', 'Abbot, M': '128', 'Abbot, S.': '129', 'Abbott': '131',
    'Abbott, J.': '132', 'Abbott, M.': '133', 'Abbott, S.': '134', 'Abd': '135',
    'Abdul': '136', 'Abdy': '137', 'Abe': '138', 'Abel': '139', 'Abel, L.': '141',
    'Aben': '142', 'Aber': '143', 'Abercr': '144', 'Aberd': '145', 'Abern': '146',
    'Abert': '147', 'Abi': '148', 'Abing': '149', 'Abk': '151', 'Abl': '152',
    'Abn': '153', 'Abo': '154', 'Abou': '155', 'About': '156', 'Abov': '157',
    'Abr': '158', 'Abrah': '159', 'Abrai': '161', 'Abre': '162', 'Abri': '163',
    'Abru': '164', 'Abu': '165', 'Abul': '166', 'Abur': '167', 'Aca': '168',
    'Acc': '169', 'Acci': '171', 'Acco': '172', 'Ace': '173', 'Aces': '174',
    'Ach': '175', 'Achar': '176', 'Ache': '177', 'Achi': '178', 'Achm': '179',
    'Aci': '181', 'Ack': '182', 'Ackw': '183', 'Acl': '184', 'Aco': '185',
    'Acq': '186', 'Acr': '187', 'Act': '188', 'Acu': '189', 'Ada': '191',
    'Adal': '192', 'Adam': '193', 'Adam, J.': '194', 'Adam, M.': '195', 'Adam, S.': '196',
    'Adam, W.': '197', 'Adami': '198', 'Adamo': '199', 'Adams': '211', 'Adams, F.': '212',
    'Adams, G.': '213', 'Adams, J.': '214', 'Adams, M.': '215', 'Adams, N.': '216',
    'Adams, S.': '217', 'Adams, T.': '218', 'Adams, W.': '219', 'Adamson': '221',
    'Add': '222', 'Adde': '223', 'Addi': '224', 'Addison': '225', 'Addison, M.': '226',
    'Addison, S.': '227', 'Ade': '228', 'Adelh': '229', 'Adelo': '231', 'Aden': '232',
    'Adet': '233', 'Adh': '234', 'Adi': '235', 'Adk': '236', 'Adl': '237',
    'Adm': '238', 'Ado': '239', 'Ador': '241', 'Adr': '242', 'Adri': '243',
    'Ads': '244', 'Ady': '245', 'Ae': '246', 'Aeg': '247', 'Ael': '248',
    'Aem': '249', 'Aen': '251', 'Aer': '252', 'Aes': '253', 'Aeso': '254',
    'Aet': '255', 'Afa': '256', 'Affl': '257', 'Afr': '258', 'Aga': '259',
    'Agar': '261', 'Agas': '262', 'Agat': '263', 'Agay': '264', 'Age': '265',
    'Agg': '266', 'Agi': '267', 'Agis': '268', 'Agl': '269', 'Agn': '271',
    'Agnes': '272', 'Agnew': '273', 'Agno': '274', 'Ago': '275', 'Agou': '276',
    'Agr': '277', 'Agri': '278', 'Agrip': '279', 'Agro': '281', 'Agu': '282',
    'Aguil': '283', 'Aguir': '284', 'Ah': '285', 'Ahm': '286', 'Ahr': '287',
    'Ai': '288', 'Aig': '289', 'Aik': '291', 'Aiki': '292', 'Ail': '293',
    'Aim': '294', 'Ain': '295', 'Ains': '296', 'Ainsw': '297', 'Air': '298',
    'Ais': '299', 'Ait': '311', 'Aj': '312', 'Ak': '313', 'Aker': '314',
    'Akers': '315', 'Al': '316', 'Alain': '317', 'Alam': '318', 'Alan': '319',
    'Alar': '321', 'Alard': '322', 'Alary': '323', 'Alav': '324', 'Alb': '325',
    'Alban': '326', 'Albar': '327', 'Albe': '328', 'Alber': '329', 'Alberi': '331',
    'Albero': '332', 'Albert': '333', 'Alberti': '334', 'Albi': '335', 'Albini': '336',
    'Albinu': '337', 'Albiz': '338', 'Albo': '339', 'Albr': '341', 'Albri': '342',
    'Albriz': '343', 'Albro': '344', 'Albu': '345', 'Alc': '346', 'Alcan': '347',
    'Alcar': '348', 'Alcaz': '349', 'Alce': '351', 'Alci': '352', 'Alcip': '353',
    'Alco': '354', 'Alcot': '355', 'Alcu': '356', 'Ald': '357', 'Alden': '358',
    'Alden, S.': '359', 'Alder': '361', 'Alders': '362', 'Aldi': '363', 'Aldo': '364',
    'Aldr': '365', 'Ale': '366', 'Alem': '367', 'Alen': '368', 'Alep': '369',
    'Ales': '371', 'Alessi': '372', 'Alew': '373', 'Alex': '374', 'Alexander, C.': '375',
    'Alexander, J.': '376', 'Alexander, M.': '377', 'Alexander, S.': '378', 'Alexander, W.': '379',
    'Alexandre': '381', 'Alexandre, M.': '382', 'Alexandro': '383', 'Alexi': '384',
    'Alfa': '385', 'Alfe': '386', 'Alfi': '387', 'Alfo': '388', 'Alford': '389',
    'Alfr': '391', 'Alfred': '392', 'Alfri': '393', 'Alg': '394', 'Alger': '395',
    'Algh': '396', 'Alh': '397', 'Ali': '398', 'Alif': '399', 'Alig': '411',
    'Alip': '412', 'Alis': '413', 'Alison, M.': '414', 'Alk': '415', 'All': '416',
    'Allan': '417', 'Allan, M.': '418', 'Allard': '419', 'Allas': '421', 'Alle': '422',
    'Allein': '423', 'Allem': '424', 'Allen': '425', 'Allen, H.': '426', 'Allen, J.': '427',
    'Allen, N.': '428', 'Allen, S.': '429', 'Allen, T.': '431', 'Allen, W.': '432',
    'Allens': '433', 'Aller': '434', 'Alley': '435', 'Alli': '436', 'Alling': '437',
    'Allis': '438', 'Allison, M.': '439', 'Allo': '441', 'Alls': '442', 'Ally': '443',
    'Alm': '444', 'Alman': '445', 'Almas': '446', 'Alme': '447', 'Almen': '448',
    'Almi': '449', 'Almo': '451', 'Almon': '452', 'Alo': '453', 'Alon': '454',
    'Alos': '455', 'Alp': '456', 'Alpi': '457', 'Alq': '458', 'Alr': '459',
    'Als': '461', 'Alsop': '462', 'Alste': '463', 'Alsto': '464', 'Alt': '465',
    'Alte': '466', 'Alth': '467', 'Alti': '468', 'Alto': '469', 'Alu': '471',
    'Alv': '472', 'Alvare': '473', 'Alve': '474', 'Alvi': '475', 'Alvo': '476',
    'Alw': '477', 'Alz': '478', 'Ama': '479', 'Amad': '481', 'Amal': '482',
    'Amalt': '483', 'Aman': '484', 'Amar': '485', 'Amas': '486', 'Amat': '487',
    'Amato': '488', 'Amau': '489', 'Amb': '491', 'Ambi': '492', 'Ambl': '493',
    'Ambo': '494', 'Ambr': '495', 'Ambros': '496', 'Ambu': '497', 'Ame': '498',
    'Amelo': '499', 'Amen': '511', 'Amer': '512', 'Ames': '513', 'Ames, M.': '514',
    'Amh': '515', 'Ami': '516', 'Amin': '517', 'Amm': '518', 'Ammir': '519',
    'Ammo': '521', 'Amn': '522', 'Amo': '523', 'Amor': '524', 'Amos': '525',
    'Amp': '526', 'Amps': '527', 'Ams': '528', 'Amu': '529', 'Amy': '531',
    'Ana': '532', 'Anam': '533', 'Anas': '534', 'Anat': '535', 'Anax': '536',
    'Anb': '537', 'Anc': '538', 'Anch': '539', 'Anci': '541', 'Anco': '542',
    'And': '543', 'Anders': '544', 'Anderson': '545', 'Anderson, D.': '546', 'Anderson, J.': '547',
    'Anderson, M.': '548', 'Anderson, R.': '549', 'Anderson, T.': '551', 'Anderson, W.': '552',
    'Andr': '553', 'Andral': '554', 'Andre': '555', 'Andrea': '556', 'Andreas': '557',
    'Andree': '558', 'Andrei': '559', 'Andres': '561', 'Andrew': '562', 'Andrew, M.': '563',
    'Andrewe': '564', 'Andrews': '565', 'Andrews, E.': '566', 'Andrews, J.': '567', 'Andrews, M.': '568',
    'Andrews, R.': '569', 'Andrews, T.': '571', 'Andrews, W.': '572', 'Andri': '573', 'Andro': '574',
    'Andron': '575', 'Andros': '576', 'Andry': '577', 'Ane': '578', 'Aner': '579',
    'Ang': '581', 'Angeli': '582', 'Angell': '583', 'Angelo': '584', 'Angelu': '585',
    'Angen': '586', 'Anger': '587', 'Angi': '588', 'Angl': '589', 'Anglu': '591',
    'Ango': '592', 'Angou': '593', 'Angu': '594', 'Angus': '595', 'Anh': '596',
    'Ani': '597', 'Anim': '598', 'Anis': '599', 'Ank': '611', 'Anl': '612',
    'Ann': '613', 'Annes': '614', 'Anni': '615', 'Anq': '616', 'Ans': '617',
    'Ansel': '618', 'Ansi': '619', 'Ansl': '621', 'Anso': '622', 'Ansp': '623',
    'Anst': '624', 'Anstey': '625', 'Ansti': '626', 'Ant': '627', 'Antho': '628',
    'Anti': '629', 'Antim': '631', 'Antio': '632', 'Antip': '633', 'Anto': '634',
    'Antoni': '635', 'Antr': '636', 'Anv': '637', 'Ao': '638', 'Ap': '639',
    'Apel': '641', 'Api': '642', 'Apo': '643', 'Apollo': '644', 'Apos': '645',
    'App': '646', 'Appi': '647', 'Appl': '648', 'Appleton': '649', 'Appleton, J.': '651',
    'Appleton, T.': '652', 'Appu': '653', 'Apr': '654', 'Apt': '655', 'Aqu': '656',
    'Aquin': '657', 'Ara': '658', 'Arag': '659', 'Aram': '661', 'Aran': '662',
    'Arat': '663', 'Arb': '664', 'Arbl': '665', 'Arbo': '666', 'Arbu': '667',
    'Arc': '668', 'Arch': '669', 'Archer': '671', 'Archer, M.': '672', 'Archi': '673',
    'Arci': '674', 'Arco': '675', 'Ard': '676', 'Ardo': '677', 'Are': '678',
    'Areh': '679', 'Aren': '681', 'Aret': '682', 'Aretin': '683', 'Arez': '684',
    'Arf': '685', 'Arg': '686', 'Argel': '687', 'Argen': '688', 'Argent': '689',
    'Argenti': '691', 'Argi': '692', 'Argo': '693', 'Argu': '694', 'Argy': '695',
    'Ari': '696', 'Arib': '697', 'Arid': '698', 'Arig': '699', 'Arin': '711',
    'Ario': '712', 'Arip': '713', 'Aris': '714', 'Aristi': '715', 'Aristo': '716',
    'Aristop': '717', 'Ariu': '718', 'Ariz': '719', 'Ark': '721', 'Arkw': '722',
    'Arl': '723', 'Arling': '724', 'Arlo': '725', 'Arlu': '726', 'Arm': '727',
    'Arme': '728', 'Armi': '729', 'Armis': '731', 'Armit': '732', 'Armitage, M.': '733',
    'Arms': '734', 'Armstrong': '735', 'Armstrong, J.': '736', 'Armstrong, M.': '737', 'Armstrong, S.': '738',
    'Armstrong, W.': '739', 'Army': '741', 'Arn': '742', 'Arnal': '743', 'Arnau': '744',
    'Arnaul': '745', 'Arnay': '746', 'Arnd': '747', 'Arne': '748', 'Arni': '749',
    'Arno': '751', 'Arnold': '752', 'Arnold, D.': '753', 'Arnold, G.': '754', 'Arnold, H.': '755',
    'Arnold, J.': '756', 'Arnold, M.': '757', 'Arnold, R.': '758', 'Arnold, T.': '759', 'Arnold, W.': '761',
    'Arnoldi': '762', 'Arnon': '763', 'Arnot': '764', 'Arnou': '765', 'Arnoult': '766',
    'Arns': '767', 'Arnu': '768', 'Aro': '769', 'Arou': '771', 'Arp': '772',
    'Arr': '773', 'Arre': '774', 'Arri': '775', 'Arrig': '776', 'Arriv': '777',
    'Arro': '778', 'Arrows': '779', 'Ars': '781', 'Arsi': '782', 'Arsl': '783',
    'Art': '784', 'Artau': '785', 'Arte': '786', 'Arth': '787', 'Arthur': '788',
    'Arthur, M.': '789', 'Arthur, S.': '791', 'Arto': '792', 'Aru': '793', 'Arunt': '794',
    'Arv': '795', 'Arw': '796', 'Arz': '797', 'Asa': '798', 'Asb': '799',
    'Asc': '811', 'Asch': '812', 'Aschen': '813', 'Ascl': '814', 'Asco': '815',
    'Ase': '816', 'Asf': '817', 'Asg': '818', 'Ash': '819', 'Ashbu': '821',
    'Ashburt': '822', 'Ashby': '823', 'Ashe': '824', 'Asher': '825', 'Ashl': '826',
    'Ashm': '827', 'Asht': '828', 'Ashton, M.': '829', 'Ashw': '831', 'Asi': '832',
    'Asio': '833', 'Ask': '834', 'Askew': '835', 'Asm': '836', 'Aso': '837',
    'Asp': '838', 'Asper': '839', 'Aspi': '841', 'Aspl': '842', 'Aspr': '843',
    'Ass': '844', 'Assen': '845', 'Asser': '846', 'Assh': '847', 'Assi': '848',
    'Asso': '849', 'Assu': '851', 'Ast': '852', 'Aste': '853', 'Asti': '854',
    'Astl': '855', 'Asto': '856', 'Aston': '857', 'Astor': '858', 'Astr': '859',
    'Asu': '861', 'Ata': '862', 'Atch': '863', 'Ate': '864', 'Ath': '865',
    'Athe': '866', 'Athen': '867', 'Ather': '868', 'Atherton, M.': '869', 'Athi': '871',
    'Ati': '872', 'Atk': '873', 'Atkins, M.': '874', 'Atkinson': '875', 'Atkinson, J.': '876',
    'Atkinson, M.': '877', 'Atkinson, T.': '878', 'Atky': '879', 'Atl': '881',
    'Atr': '882', 'Att': '883', 'Atter': '884', 'Atti': '885', 'Attw': '886',
    'Atw': '887', 'Aub': '888', 'Aubert': '889', 'Aubery': '891', 'Aubes': '892',
    'Aubi': '893', 'Aubin': '894', 'Aubr': '895', 'Aubry': '896', 'Aubu': '897',
    'Auc': '898', 'Aud': '899', 'Audi': '911', 'Audin': '912', 'Audl': '913',
    'Audo': '914', 'Audr': '915', 'Audu': '916', 'Aue': '917', 'Auf': '918',
    'Aug': '919', 'Augi': '921', 'Augu': '922', 'Augus': '923', 'Aul': '924',
    'Aum': '925', 'Aun': '926', 'Aur': '927', 'Auri': '928', 'Auriv': '929',
    'Auro': '931', 'Aus': '932', 'Austen': '933', 'Austen, M.': '934', 'Austin': '935',
    'Austin, J.': '936', 'Austin, M.': '937', 'Austin, T.': '938', 'Aut': '939',
    'Autr': '941', 'Auv': '942', 'Aux': '943', 'Auz': '944', 'Ava': '945',
    'Avan': '946', 'Avau': '947', 'Ave': '948', 'Avell': '949', 'Aven': '951',
    'Aver': '952', 'Avero': '953', 'Avery': '954', 'Avery, M.': '955', 'Avez': '956',
    'Avi': '957', 'Avil': '958', 'Avit': '959', 'Avo': '961', 'Avos': '962',
    'Avr': '963', 'Awa': '964', 'Awb': '965', 'Awd': '966', 'Awi': '967',
    'Ax': '968', 'Axel': '969', 'Axo': '971', 'Axt': '972', 'Aya': '973',
    'Ayc': '974', 'Ayd': '975', 'Aye': '976', 'Ayers': '977', 'Ayl': '978',
    'Aylm': '979', 'Aylw': '981', 'Aym': '982', 'Ayn': '983', 'Ayr': '984',
    'Ayres': '985', 'Ayrt': '986', 'Ays': '987', 'Ayt': '988', 'Ayton': '989',
    'Aza': '991', 'Azar': '992', 'Aze': '993', 'Azev': '994', 'Azi': '995',
    'Azo': '996', 'Azr': '997', 'Azy': '998', 'Azz': '999'
  },
  'B': {
    'Ba': '111', 'Bab': '112', 'Babe': '113', 'Babi': '114', 'Babr': '115',
    'Bac': '116', 'Bacci': '117', 'Bach': '118', 'Bache': '119', 'Bachell': '121',
    'Bachet': '122', 'Bachi': '123', 'Bachm': '124', 'Baci': '125', 'Back': '126',
    'Bacm': '127', 'Baco': '128', 'Bacon, M.': '129', 'Bacr': '131', 'Bad': '132',
    'Bade': '133', 'Baden': '134', 'Badg': '135', 'Badi': '136', 'Bado': '137',
    'Badr': '138', 'Bae': '139', 'Baer': '141', 'Baert': '142', 'Baf': '143',
    'Bag': '144', 'Bagi': '145', 'Bagl': '146', 'Bagn': '147', 'Bago': '148',
    'Bags': '149', 'Bah': '151', 'Bai': '152', 'Bail': '153', 'Baile': '154',
    'Bailey, L.': '155', 'Bailey, S.': '156', 'Baill': '157', 'Baillo': '158',
    'Bails': '159', 'Baily': '161', 'Bain': '162', 'Bair': '163', 'Bait': '164',
    'Baj': '165', 'Bak': '166', 'Bake': '167', 'Baker, M.': '168', 'Baks': '169',
    'Bal': '171', 'Balb': '172', 'Balbo': '173', 'Balc': '174', 'Bald': '175',
    'Balder': '176', 'Baldi': '177', 'Baldo': '178', 'Baldu': '179', 'Baldw': '181',
    'Baldwin, M.': '182', 'Bale': '183', 'Bales': '184', 'Balf': '185', 'Bali': '186',
    'Ball': '187', 'Balla': '188', 'Ballar': '189', 'Balle': '191', 'Balli': '192',
    'Ballo': '193', 'Balm': '194', 'Balo': '195', 'Bals': '196', 'Balt': '197',
    'Balu': '198', 'Bam': '199', 'Bamp': '211', 'Ban': '212', 'Banc': '213',
    'Band': '214', 'Bane': '215', 'Bang': '216', 'Bani': '217', 'Bank': '218',
    'Bann': '219', 'Bao': '221', 'Bap': '222', 'Bar': '223', 'Barag': '224',
    'Baran': '225', 'Barat': '226', 'Barau': '227', 'Barb': '228', 'Barbar': '229',
    'Barbat': '231', 'Barbau': '232', 'Barbe': '233', 'Barber': '234', 'Barbet': '235',
    'Barbi': '236', 'Barbil': '237', 'Barbo': '238', 'Barbou': '239', 'Barbu': '241',
    'Barc': '242', 'Barch': '243', 'Barcl': '244', 'Bard': '245', 'Bardi': '246',
    'Bardo': '247', 'Bare': '248', 'Barf': '249', 'Barg': '251', 'Bari': '252',
    'Barin': '253', 'Bark': '254', 'Barker': '255', 'Barki': '256', 'Barl': '257',
    'Barlo': '258', 'Barn': '259', 'Barnes': '261', 'Barnh': '262', 'Barnu': '263',
    'Baro': '264', 'Baron': '265', 'Baroni': '266', 'Barot': '267', 'Barr': '268',
    'Barras': '269', 'Barre': '271', 'Barrer': '272', 'Barret': '273', 'Barrett': '274',
    'Barri': '275', 'Barrin': '276', 'Barro': '277', 'Barrow': '278', 'Barry': '279',
    'Barry, L.': '281', 'Bars': '282', 'Bart': '283', 'Barth': '284', 'Barthel': '285',
    'Bartho': '286', 'Bartholo': '287', 'Barti': '288', 'Bartl': '289', 'Bartlett, M.': '291',
    'Barto': '292', 'Barton': '293', 'Bartr': '294', 'Baru': '295', 'Barw': '296',
    'Bas': '297', 'Basc': '298', 'Base': '299', 'Basi': '311', 'Basili': '312',
    'Basin': '313', 'Basir': '314', 'Bask': '315', 'Basn': '316', 'Bass': '317',
    'Basse': '318', 'Basset': '319', 'Bassi': '321', 'Basso': '322', 'Bassu': '323',
    'Bast': '324', 'Baste': '325', 'Basti': '326', 'Basto': '327', 'Bat': '328',
    'Bates': '329', 'Bath': '331', 'Bathu': '332', 'Bati': '333', 'Bato': '334',
    'Batt': '335', 'Batti': '336', 'Bau': '337', 'Baud': '338', 'Baudio': '339',
    'Baudo': '341', 'Baudr': '342', 'Baudu': '343', 'Baue': '344', 'Bauf': '345',
    'Baug': '346', 'Baum': '347', 'Baumg': '348', 'Baun': '349', 'Baur': '351',
    'Baut': '352', 'Bav': '353', 'Bavi': '354', 'Bax': '355', 'Bay': '356',
    'Baye': '357', 'Bayl': '358', 'Bayly': '359', 'Bayn': '361', 'Baz': '362',
    'Bazi': '363', 'Bazo': '364', 'Be': '365', 'Beal': '366', 'Bean': '367',
    'Bear': '368', 'Beat': '369', 'Beau': '371', 'Beauch': '372', 'Beaucl': '373',
    'Beauf': '374', 'Beaug': '375', 'Beauh': '376', 'Beaul': '377', 'Beaum': '378',
    'Beaumo': '379', 'Beaun': '381', 'Beaup': '382', 'Beaur': '383', 'Beaus': '384',
    'Beauv': '385', 'Beauvo': '386', 'Beb': '387', 'Bec': '388', 'Bece': '389',
    'Bech': '391', 'Bechs': '392', 'Beck': '393', 'Becke': '394', 'Becker': '395',
    'Becker, P.': '396', 'Becki': '397', 'Becm': '398', 'Bed': '399', 'Bede': '411',
    'Bedi': '412', 'Bedr': '413', 'Bee': '414', 'Beer': '415', 'Beg': '416',
    'Begi': '417', 'Begu': '418', 'Beh': '419', 'Behr': '421', 'Bei': '422',
    'Beis': '423', 'Bek': '424', 'Bel': '425', 'Belan': '426', 'Belch': '427',
    'Bele': '428', 'Belg': '429', 'Beli': '431', 'Belk': '432', 'Bell': '433',
    'Bell, L.': '434', 'Bell, R.': '435', 'Bellan': '436', 'Bellav': '437', 'Belle': '438',
    'Belleg': '439', 'Bellen': '441', 'Beller': '442', 'Belli': '443', 'Bellin': '444',
    'Bellm': '445', 'Bello': '446', 'Bellon': '447', 'Bellow': '448', 'Bellu': '449',
    'Belm': '451', 'Belo': '452', 'Belt': '453', 'Belv': '454', 'Bem': '455',
    'Ben': '456', 'Benc': '457', 'Bend': '458', 'Bendo': '459', 'Bene': '461',
    'Benede': '462', 'Benedi': '463', 'Benef': '464', 'Benel': '465', 'Beng': '466',
    'Beni': '467', 'Benj': '468', 'Benn': '469', 'Bennett': '471', 'Bennett, M.': '472',
    'Beno': '473', 'Bens': '474', 'Bent': '475', 'Benth': '476', 'Bentl': '477',
    'Bento': '478', 'Benw': '479', 'Beo': '481', 'Ber': '482', 'Berar': '483',
    'Berau': '484', 'Berc': '485', 'Berck': '486', 'Bere': '487', 'Beren': '488',
    'Berens': '489', 'Beres': '491', 'Beret': '492', 'Berg': '493', 'Bergan': '494',
    'Berge': '495', 'Berger': '496', 'Bergi': '498', 'Bergm': '499', 'Berh': '497',
    'Beri': '511', 'Berk': '512', 'Berkl': '513', 'Berl': '514', 'Berlin': '515',
    'Berm': '516', 'Bern': '517', 'Bernar': '518', 'Bernard, J.': '519', 'Bernard, M.': '521',
    'Bernard, T.': '522', 'Bernardi': '523', 'Bernat': '524', 'Berne': '525', 'Bernet': '526',
    'Bernh': '527', 'Berni': '528', 'Berno': '529', 'Berns': '531', 'Bero': '532',
    'Berr': '533', 'Berry': '534', 'Bers': '535', 'Bert': '536', 'Berte': '537',
    'Berth': '538', 'Berthe': '539', 'Berthi': '541', 'Bertho': '542', 'Berti': '543',
    'Bertin': '544', 'Berto': '545', 'Bertol': '546', 'Berton': '547', 'Bertr': '548',
    'Bertrand, F.': '549', 'Bertrand, N.': '551', 'Bertu': '552', 'Berw': '553',
    'Bes': '554', 'Besl': '555', 'Beso': '556', 'Bess': '557', 'Bessem': '558',
    'Bessi': '559', 'Best': '561', 'Bet': '562', 'Bethm': '563', 'Beto': '564',
    'Bett': '565', 'Beu': '566', 'Beul': '567', 'Beus': '568', 'Beut': '569',
    'Bev': '571', 'Bew': '572', 'Bey': '573', 'Bez': '574', 'Bh': '575',
    'Bi': '576', 'Bian': '577', 'Bianco': '578', 'Biar': '579', 'Bib': '581',
    'Bibl': '582', 'Bic': '583', 'Bid': '584', 'Bide': '585', 'Bie': '586',
    'Biel': '587', 'Bien': '588', 'Bies': '589', 'Bif': '591', 'Big': '592',
    'Bigl': '593', 'Bigo': '594', 'Bil': '595', 'Bill': '596', 'Bille': '597',
    'Billi': '598', 'Billo': '599', 'Bim': '611', 'Bin': '612', 'Bing': '613',
    'Binn': '614', 'Bio': '615', 'Bior': '616', 'Bir': '617', 'Bird': '618',
    'Birk': '619', 'Bis': '621', 'Bish': '622', 'Biss': '623', 'Bit': '624',
    'Biz': '625', 'Bj': '626', 'Bl': '627', 'Blackb': '628', 'Blackm': '629',
    'Blacks': '631', 'Blackw': '632', 'Blag': '633', 'Blai': '634', 'Blair': '635',
    'Blak': '636', 'Blakes': '637', 'Blan': '638', 'Blanch': '639', 'Blanche': '641',
    'Bland': '642', 'Blanq': '643', 'Blas': '644', 'Blau': '645', 'Ble': '646',
    'Blen': '647', 'Bli': '648', 'Blis': '649', 'Blo': '651', 'Blod': '652',
    'Blom': '653', 'Blon': '654', 'Bloo': '655', 'Blos': '656', 'Blou': '657',
    'Blu': '658', 'Blunt': '659', 'Bly': '661', 'Bo': '662', 'Bob': '663',
    'Boc': '664', 'Bock': '665', 'Bod': '666', 'Bodi': '667', 'Bodl': '668',
    'Boe': '669', 'Boeh': '671', 'Boer': '672', 'Boet': '673', 'Bog': '674',
    'Bogi': '675', 'Boh': '676', 'Bohn': '677', 'Boi': '678', 'Boil': '679',
    'Boin': '681', 'Bois': '682', 'Boisg': '683', 'Boiss': '684', 'Boit': '685',
    'Bok': '686', 'Bol': '687', 'Bole': '688', 'Boli': '689', 'Boll': '691',
    'Bolli': '692', 'Bolo': '693', 'Bolt': '694', 'Bom': '695', 'Boml': '696',
    'Bon': '697', 'Bonap': '698', 'Bonar': '699', 'Bond': '711', 'Bone': '712',
    'Bonf': '713', 'Bonh': '714', 'Boni': '715', 'Bonn': '716', 'Bonnet': '717',
    'Bonni': '718', 'Bono': '719', 'Bons': '721', 'Bont': '722', 'Bonv': '723',
    'Boo': '724', 'Boot': '725', 'Bor': '726', 'Bord': '727', 'Borden': '728',
    'Bordi': '729', 'Bore': '731', 'Borg': '732', 'Borgi': '733', 'Borgo': '734',
    'Borl': '735', 'Born': '736', 'Borr': '737', 'Bors': '738', 'Bort': '739',
    'Bos': '741', 'Bosch': '742', 'Bose': '743', 'Boso': '744', 'Boss': '745',
    'Bossu': '746', 'Bost': '747', 'Bot': '748', 'Both': '749', 'Bott': '751',
    'Bou': '752', 'Bouche': '753', 'Bouchi': '754', 'Boucho': '755', 'Boud': '756',
    'Bouf': '757', 'Boug': '758', 'Bouh': '759', 'Boui': '761', 'Bouil': '762',
    'Boul': '763', 'Boull': '764', 'Boun': '765', 'Bour': '766', 'Bourc': '767',
    'Bourd': '768', 'Bourdi': '769', 'Boure': '771', 'Bourg': '772', 'Bourgo': '773',
    'Bouri': '774', 'Bourn': '775', 'Bourr': '776', 'Bous': '777', 'Bout': '778',
    'Bouth': '779', 'Bouto': '781', 'Bouv': '782', 'Bov': '783', 'Bow': '784',
    'Bowdi': '785', 'Bowe': '786', 'Bowl': '787', 'Bowr': '788', 'Boy': '789',
    'Boye': '791', 'Boyl': '792', 'Boys': '793', 'Br': '794', 'Brab': '795',
    'Brac': '796', 'Brack': '797', 'Brad': '798', 'Bradf': '799', 'Bradl': '811',
    'Brads': '812', 'Brag': '813', 'Brai': '814', 'Bram': '815', 'Bran': '816',
    'Brand': '817', 'Brandi': '818', 'Brando': '819', 'Brandt': '821', 'Brar': '822',
    'Bras': '823', 'Brat': '824', 'Brau': '825', 'Brav': '826', 'Bray': '827',
    'Bre': '828', 'Brec': '829', 'Bred': '831', 'Bree': '832', 'Breg': '833',
    'Breh': '834', 'Brei': '835', 'Brem': '836', 'Bren': '837', 'Brenn': '838',
    'Brent': '839', 'Brer': '841', 'Bres': '842', 'Bress': '843', 'Bret': '844',
    'Brett': '845', 'Breu': '846', 'Brew': '847', 'Brews': '848', 'Bri': '849',
    'Brid': '851', 'Bridgm': '852', 'Brie': '853', 'Brig': '854', 'Brigh': '855',
    'Brighto': '856', 'Bril': '857', 'Brin': '858', 'Bris': '859', 'Brist': '861',
    'Brit': '862', 'Bro': '863', 'Brock': '864', 'Broe': '865', 'Brog': '866',
    'Brok': '867', 'Brom': '868', 'Bron': '869', 'Broo': '871', 'Brooke': '872',
    'Brooks': '873', 'Bros': '874', 'Brou': '875', 'Brous': '876', 'Brow': '877',
    'Brown, H.': '878', 'Brown, M.': '879', 'Brown, T.': '881', 'Browne': '882',
    'Browne, M.': '883', 'Browne, S.': '884', 'Browni': '885', 'Bru': '886',
    'Bruce, J.': '887', 'Bruck': '888', 'Brue': '889', 'Brug': '891', 'Bruh': '892',
    'Brum': '893', 'Brun': '894', 'Brunet': '895', 'Bruni': '896', 'Brunn': '897',
    'Bruno': '898', 'Bruns': '899', 'Brunsw': '911', 'Brus': '912', 'Brut': '913',
    'Bruy': '914', 'Bry': '915', 'Bryc': '916', 'Bu': '917', 'Buc': '918',
    'Buche': '919', 'Bucho': '921', 'Buck': '922', 'Bucki': '923', 'Buckl': '924',
    'Buckm': '925', 'Bucks': '926', 'Bud': '927', 'Bue': '928', 'Buf': '929',
    'Bug': '931', 'Bui': '932', 'Bul': '933', 'Bulk': '934', 'Bull': '935',
    'Bulle': '936', 'Bulli': '937', 'Bullo': '938', 'Bulo': '939', 'Bulw': '941',
    'Bun': '942', 'Buo': '943', 'Buoni': '944', 'Bur': '945', 'Burb': '946',
    'Burc': '947', 'Burck': '948', 'Burd': '949', 'Burdet': '951', 'Bure': '952',
    'Burf': '953', 'Burg': '954', 'Burges': '955', 'Burgh': '956', 'Burgo': '957',
    'Burh': '958', 'Burk': '959', 'Burl': '961', 'Burm': '962', 'Burn': '963',
    'Burnet': '964', 'Burney': '965', 'Burnh': '966', 'Burns': '967', 'Burr': '968',
    'Burre': '969', 'Burri': '971', 'Burro': '972', 'Burt': '973', 'Burto': '974',
    'Bury': '975', 'Bus': '976', 'Busch': '977', 'Bush': '978', 'Bushn': '979',
    'Buss': '981', 'Bust': '982', 'But': '983', 'Buti': '984', 'Butl': '985',
    'Butler, M.': '986', 'Butler, T.': '987', 'Butt': '988', 'Butto': '989',
    'Bux': '991', 'Buy': '992', 'By': '993', 'Byn': '994', 'Byr': '995',
    'Byro': '996', 'Bys': '997', 'Byt': '998', 'Bz': '999'
  },
  'C': {
    'Ca': '111', 'Cab': '112', 'Cabas': '113', 'Cabe': '114', 'Cabi': '115',
    'Cabo': '116', 'Cabr': '117', 'Cac': '118', 'Cach': '119', 'Cad': '121',
    'Cade': '122', 'Cadet': '123', 'Cadi': '124', 'Cado': '125', 'Cadr': '126',
    'Cae': '127', 'Caes': '128', 'Caf': '129', 'Cag': '131', 'Cah': '132',
    'Cai': '133', 'Cail': '134', 'Cain': '135', 'Cair': '136', 'Cais': '137',
    'Caiu': '138', 'Caj': '139', 'Cal': '141', 'Calan': '142', 'Calas': '143',
    'Calc': '144', 'Cald': '145', 'Calde': '146', 'Caldw': '147', 'Cale': '148',
    'Calero': '149', 'Calen': '149', 'Calf': '151', 'Calh': '152', 'Cali': '153', 'Calin': '154',
    'Calk': '155', 'Call': '156', 'Calle': '157', 'Calli': '158', 'Callim': '159',
    'Callin': '161', 'Callis': '162', 'Callo': '163', 'Calm': '164', 'Calo': '165',
    'Calt': '166', 'Calv': '167', 'Calvi': '168', 'Calvo': '169', 'Calz': '171',
    'Cam': '172', 'Camas': '173', 'Camb': '174', 'Cambi': '175', 'Cambo': '176',
    'Cambr': '177', 'Cambri': '178', 'Camd': '179', 'Came': '181', 'Camer': '182',
    'Cami': '183', 'Camm': '184', 'Camo': '185', 'Camp': '186', 'Campbell': '187',
    'Campbell, H.': '188', 'Campbell, M.': '189', 'Campbell, S.': '191', 'Campbell, W.': '192',
    'Campe': '193', 'Campen': '194', 'Camper': '195', 'Campi': '196', 'Campis': '197',
    'Campo': '198', 'Campr': '199', 'Camu': '211', 'Can': '212', 'Canan': '213',
    'Canb': '214', 'Canc': '215', 'Cand': '216', 'Candi': '217', 'Candl': '218',
    'Cando': '219', 'Cane': '221', 'Canf': '222', 'Cani': '223', 'Cann': '224',
    'Canni': '225', 'Canno': '226', 'Cano': '227', 'Cans': '228', 'Cant': '229',
    'Canti': '231', 'Canto': '232', 'Cantr': '233', 'Cantw': '234', 'Canu': '235',
    'Cap': '236', 'Cape': '237', 'Capel': '238', 'Capen': '239', 'Capet': '241',
    'Capg': '242', 'Capi': '243', 'Capit': '244', 'Capo': '245', 'Capon': '246',
    'Capp': '247', 'Capper': '248', 'Cappo': '249', 'Capr': '251', 'Capre': '252',
    'Capri': '253', 'Capro': '254', 'Capu': '255', 'Caq': '256', 'Car': '257',
    'Caraf': '258', 'Caram': '259', 'Caran': '261', 'Carat': '262', 'Carb': '263',
    'Carbo': '264', 'Carc': '265', 'Card': '266', 'Cardi': '267', 'Cardo': '268',
    'Cardw': '269', 'Care': '271', 'Carew': '272', 'Carey': '273', 'Carey, H.': '274',
    'Carey, M.': '275', 'Carey, S.': '276', 'Cari': '277', 'Carl': '278', 'Carlet': '279',
    'Carleton': '281', 'Carli': '282', 'Carlis': '283', 'Carlo': '284', 'Carlt': '285',
    'Carly': '286', 'Carm': '287', 'Carn': '288', 'Carne': '289', 'Carno': '291',
    'Caro': '292', 'Caron': '293', 'Carp': '294', 'Carpenter': '295', 'Carpenter, L.': '296',
    'Carpenter, S.': '297', 'Carpi': '298', 'Carpo': '299', 'Carr': '311', 'Carr, M.': '312',
    'Carrar': '313', 'Carre': '314', 'Carret': '315', 'Carri': '316', 'Carril': '317',
    'Carrin': '318', 'Carro': '319', 'Cars': '321', 'Cart': '322', 'Carter': '323',
    'Carter, L.': '324', 'Carter, S.': '325', 'Carth': '326', 'Carti': '327', 'Carto': '328',
    'Cartw': '329', 'Carv': '331', 'Cary': '332', 'Cary, M.': '333', 'Cas': '334',
    'Casan': '335', 'Casat': '336', 'Case': '337', 'Casen': '338', 'Casi': '339',
    'Caso': '341', 'Casp': '342', 'Cass': '343', 'Casse': '344', 'Cassi': '345',
    'Cast': '346', 'Caste': '347', 'Castel': '348', 'Casteln': '349', 'Casti': '351',
    'Castil': '352', 'Castl': '353', 'Casto': '354', 'Castr': '355', 'Casw': '356',
    'Cat': '357', 'Catel': '358', 'Caten': '359', 'Cath': '361', 'Cathc': '362',
    'Cathe': '363', 'Cati': '364', 'Catl': '365', 'Cato': '366', 'Catr': '367',
    'Catt': '368', 'Catto': '369', 'Cau': '371', 'Caul': '372', 'Caum': '373',
    'Caus': '374', 'Caut': '375', 'Cav': '376', 'Cavall': '377', 'Cave': '378',
    'Caven': '379', 'Cavendish, L.': '381', 'Cavi': '382', 'Cavo': '383', 'Cax': '384',
    'Cay': '385', 'Caz': '386', 'Ce': '387', 'Ceci': '388', 'Ced': '389',
    'Cei': '391', 'Cel': '392', 'Cell': '393', 'Cels': '394', 'Cen': '395',
    'Cens': '396', 'Cent': '397', 'Ceo': '398', 'Cep': '399', 'Cer': '411',
    'Cerc': '412', 'Cerd': '413', 'Cere': '414', 'Ceri': '415', 'Cero': '416',
    'Cerr': '417', 'Cert': '418', 'Cerv': '419', 'Ces': '421', 'Ceso': '422',
    'Cet': '423', 'Cev': '424', 'Cey': '425', 'Ch': '426', 'Chabe': '427',
    'Chabo': '428', 'Chabr': '429', 'Chac': '431', 'Chad': '432', 'Chaf': '433',
    'Chai': '434', 'Chais': '435', 'Chal': '436', 'Chall': '437', 'Chalm': '438',
    'Chalo': '439', 'Chalt': '441', 'Cham': '442', 'Chamber': '443', 'Chambers': '444',
    'Chambers, M.': '445', 'Chambo': '446', 'Chambr': '447', 'Chami': '448', 'Champ': '449',
    'Champe': '451', 'Champi': '452', 'Champl': '453', 'Chan': '454', 'Chandl': '455',
    'Chandler, M.': '456', 'Chanl': '457', 'Chann': '458', 'Chant': '459', 'Chao': '461',
    'Chap': '462', 'Chapi': '463', 'Chapl': '464', 'Chapm': '465', 'Chapman': '466',
    'Chapp': '467', 'Chapu': '468', 'Char': '469', 'Chard': '471', 'Chare': '472',
    'Chari': '473', 'Charl': '474', 'Charles': '475', 'Charles, M.': '476', 'Charles, S.': '477',
    'Charlet': '478', 'Charlo': '479', 'Charlt': '481', 'Charm': '482', 'Charn': '483',
    'Charp': '484', 'Charr': '485', 'Chart': '486', 'Chas': '487', 'Chass': '488',
    'Chast': '489', 'Chastil': '491', 'Chat': '492', 'Chath': '493', 'Chathi': '494',
    'Chatt': '495', 'Chau': '496', 'Chaul': '497', 'Chaun': '498', 'Chaus': '499',
    'Chauv': '511', 'Chav': '512', 'Chaz': '513', 'Che': '514', 'Chee': '515',
    'Chel': '516', 'Chem': '517', 'Chen': '518', 'Chep': '519', 'Cher': '521',
    'Chero': '522', 'Cheru': '523', 'Ches': '524', 'Chest': '525', 'Chet': '526',
    'Chev': '527', 'Chevi': '528', 'Chevr': '529', 'Chey': '531', 'Chi': '532',
    'Chich': '533', 'Chif': '534', 'Chil': '535', 'Child': '536', 'Childs': '537',
    'Chill': '538', 'Chin': '539', 'Chip': '541', 'Chis': '542', 'Chit': '543',
    'Chla': '544', 'Cho': '545', 'Chois': '546', 'Chol': '547', 'Chom': '548',
    'Chop': '549', 'Chor': '551', 'Chou': '552', 'Chr': '553', 'Chri': '554',
    'Christi': '555', 'Christo': '556', 'Chro': '557', 'Chry': '558', 'Chu': '559',
    'Church': '561', 'Church, M.': '562', 'Churchill': '563', 'Chut': '564', 'Ci': '565',
    'Cian': '566', 'Cib': '567', 'Cic': '568', 'Cie': '569', 'Cig': '571',
    'Cil': '572', 'Cim': '573', 'Cin': '574', 'Cini': '575', 'Cio': '576',
    'Cip': '577', 'Cir': '578', 'Cis': '579', 'Cit': '581', 'Civ': '582',
    'Cl': '583', 'Clag': '584', 'Clai': '585', 'Clam': '586', 'Clan': '587',
    'Clap': '588', 'Clapp': '589', 'Clar': '591', 'Clark': '592', 'Clark, G.': '593',
    'Clark, M.': '594', 'Clark, S.': '595', 'Clark, W.': '596', 'Clarke': '597',
    'Clarke, G.': '598', 'Clarke, M.': '599', 'Clarke, S.': '611', 'Clarke, W.': '612',
    'Clarks': '613', 'Clary': '614', 'Clau': '615', 'Claus': '616', 'Clav': '617',
    'Clax': '618', 'Clay': '619', 'Clay, M.': '621', 'Clay, T.': '622', 'Cle': '623',
    'Clee': '624', 'Clem': '625', 'Clement': '626', 'Clen': '627', 'Cleo': '628',
    'Cler': '629', 'Clerk': '631', 'Clerke': '632', 'Clerm': '633', 'Cles': '634',
    'Clev': '635', 'Cli': '636', 'Clif': '637', 'Clifford, M.': '638', 'Clift': '639',
    'Clin': '641', 'Cliv': '642', 'Clo': '643', 'Clon': '644', 'Clos': '645',
    'Clot': '646', 'Clou': '647', 'Clow': '648', 'Clu': '649', 'Cn': '651',
    'Co': '652', 'Cobb': '653', 'Cobbet': '654', 'Cobd': '655', 'Cobh': '656',
    'Cobo': '657', 'Cobu': '658', 'Coc': '659', 'Coch': '661', 'Cochin': '662',
    'Cochr': '663', 'Cock': '664', 'Cockb': '665', 'Cocke': '666', 'Coco': '667',
    'Cocq': '668', 'Cod': '669', 'Codm': '671', 'Coe': '672', 'Coes': '673',
    'Cof': '674', 'Coffin': '675', 'Cog': '676', 'Cogs': '677', 'Coh': '678',
    'Coig': '679', 'Coit': '681', 'Cok': '682', 'Col': '683', 'Colb': '684',
    'Colbu': '685', 'Colby': '686', 'Colc': '687', 'Cold': '688', 'Cole': '689',
    'Coleb': '691', 'Colem': '692', 'Coler': '693', 'Colet': '694', 'Colev': '695',
    'Coli': '696', 'Coll': '697', 'Collet': '698', 'Colli': '699', 'Colling': '711',
    'Collins': '712', 'Collins, S.': '713', 'Collo': '714', 'Colly': '715', 'Colm': '716',
    'Coln': '717', 'Colo': '718', 'Colon': '719', 'Colp': '721', 'Colq': '722',
    'Cols': '723', 'Colt': '724', 'Colto': '725', 'Colu': '726', 'Colv': '727',
    'Com': '728', 'Comb': '729', 'Combes': '731', 'Come': '732', 'Comi': '733',
    'Comm': '734', 'Como': '735', 'Comp': '736', 'Compan': '737', 'Compt': '738',
    'Coms': '739', 'Comt': '741', 'Comy': '742', 'Con': '743', 'Conc': '744',
    'Cond': '745', 'Condo': '746', 'Cone': '747', 'Conf': '748', 'Cong': '749',
    'Coni': '751', 'Conk': '752', 'Cono': '753', 'Conr': '754', 'Cons': '755',
    'Const': '756', 'Constan': '757', 'Constanti': '758', 'Cont': '759', 'Conte': '761',
    'Conti': '762', 'Conto': '763', 'Contr': '764', 'Contu': '765', 'Conv': '766',
    'Conw': '767', 'Cony': '768', 'Coo': '769', 'Cook': '771', 'Cooke': '772',
    'Cooke, M.': '773', 'Cool': '774', 'Coom': '775', 'Coop': '776', 'Cooper, H.': '777',
    'Cooper, O.': '778', 'Coot': '779', 'Cop': '781', 'Cope': '782', 'Copi': '783',
    'Copl': '784', 'Copp': '785', 'Coq': '786', 'Cor': '787', 'Coran': '788',
    'Corb': '789', 'Corbin': '791', 'Corbo': '792', 'Corc': '793', 'Cord': '794',
    'Cordi': '795', 'Cordo': '796', 'Core': '797', 'Cori': '798', 'Cork': '799',
    'Corm': '811', 'Corn': '812', 'Corne': '813', 'Cornel': '814', 'Corner': '815',
    'Cornet': '816', 'Cornh': '817', 'Corni': '818', 'Corno': '819', 'Cornw': '821',
    'Coro': '822', 'Corr': '823', 'Corre': '824', 'Corri': '825', 'Cors': '826',
    'Cort': '827', 'Cortes': '828', 'Corti': '829', 'Corto': '831', 'Corv': '832',
    'Cory': '833', 'Cos': '834', 'Cosp': '835', 'Coss': '836', 'Cost': '837',
    'Costan': '838', 'Coste': '839', 'Costel': '841', 'Coster': '842', 'Cot': '843',
    'Coti': '844', 'Coto': '845', 'Cott': '846', 'Cotter': '847', 'Cotti': '848',
    'Cottl': '849', 'Cotto': '851', 'Coty': '852', 'Cou': '853', 'Coud': '854',
    'Coul': '855', 'Coup': '856', 'Coupl': '857', 'Cour': '858', 'Courc': '859',
    'Courl': '861', 'Court': '862', 'Courte': '863', 'Courti': '864', 'Courtn': '865',
    'Courto': '866', 'Cous': '867', 'Couss': '868', 'Coust': '869', 'Cout': '871',
    'Coutu': '872', 'Cov': '873', 'Cow': '874', 'Cowl': '875', 'Cowp': '876',
    'Cox': '877', 'Cox, R.': '878', 'Coxe': '879', 'Coy': '881', 'Coz': '882',
    'Cr': '883', 'Crad': '884', 'Craf': '885', 'Crai': '886', 'Craik': '887',
    'Crak': '888', 'Cram': '889', 'Cran': '891', 'Crao': '892', 'Crap': '893',
    'Cras': '894', 'Crat': '895', 'Crato': '896', 'Crau': '897', 'Crav': '898',
    'Craw': '899', 'Crawl': '911', 'Cre': '912', 'Cree': '913', 'Crei': '914',
    'Crel': '915', 'Creo': '916', 'Crep': '917', 'Creq': '918', 'Cres': '919',
    'Cresp': '921', 'Cress': '922', 'Cresw': '923', 'Cret': '924', 'Creu': '925',
    'Crev': '926', 'Crew': '927', 'Cri': '928', 'Cril': '929', 'Crin': '931',
    'Cris': '932', 'Crist': '933', 'Crit': '934', 'Critt': '935', 'Criv': '936',
    'Cro': '937', 'Crock': '938', 'Croe': '939', 'Crof': '941', 'Croi': '942',
    'Crok': '943', 'Crol': '944', 'Crom': '945', 'Cromw': '946', 'Cron': '947',
    'Croo': '948', 'Cros': '949', 'Cross': '951', 'Crou': '952', 'Crow': '953',
    'Croy': '954', 'Cru': '955', 'Crum': '956', 'Crus': '957', 'Cs': '958',
    'Ct': '959', 'Cu': '961', 'Cub': '962', 'Cuc': '963', 'Cud': '964',
    'Cue': '965', 'Cui': '966', 'Cul': '967', 'Culp': '968', 'Cum': '969',
    'Cumm': '971', 'Cun': '972', 'Cunn': '973', 'Cup': '974', 'Cur': '975',
    'Curr': '976', 'Curs': '977', 'Curt': '978', 'Curtis, J.': '979', 'Curtis, P.': '981',
    'Curw': '982', 'Curz': '983', 'Cus': '984', 'Cushing, M.': '985', 'Cushm': '986',
    'Cust': '987', 'Cut': '988', 'Cutl': '989', 'Cutt': '991', 'Cuv': '992',
    'Cuy': '993', 'Cy': '994', 'Cyc': '995', 'Cyl': '996', 'Cyr': '997',
    'Cz': '998', 'Czo': '999'
  },
  'D': {
    'Da': '111', 'Dabi': '112', 'Dabl': '113', 'Dabn': '114', 'Dabo': '115',
    'Dabr': '116', 'Dac': '117', 'Daci': '118', 'Dacr': '119', 'Dad': '121',
    'Dae': '122', 'Dael': '123', 'Daf': '124', 'Dag': '125', 'Dagi': '126',
    'Dago': '127', 'Dagu': '128', 'Dah': '129', 'Dahl': '131', 'Dai': '132',
    'Dail': '133', 'Dair': '134', 'Dak': '135', 'Dal': '136', 'Dalb': '137',
    'Dalc': '138', 'Dale': '139', 'Dales': '141', 'Dalg': '142', 'Dalh': '143',
    'Dall': '144', 'Dallas': '145', 'Dalle': '146', 'Dalli': '147', 'Dalm': '148',
    'Dalp': '149', 'Dalr': '151', 'Dalt': '152', 'Daly': '153', 'Dam': '154',
    'Damas': '155', 'Damb': '156', 'Dame': '157', 'Dami': '158', 'Damin': '159',
    'Damis': '161', 'Damm': '162', 'Damo': '163', 'Damop': '164', 'Damp': '165',
    'Dampi': '166', 'Dan': '167', 'Dana, H.': '168', 'Dana, M.': '169', 'Dana, S.': '171',
    'Danb': '172', 'Danc': '173', 'Danck': '174', 'Danco': '175', 'Dand': '176',
    'Dando': '177', 'Dandr': '178', 'Dane': '179', 'Danf': '181', 'Dang': '182',
    'Dani': '183', 'Daniel': '184', 'Daniell': '185', 'Daniels': '186', 'Dank': '187',
    'Dann': '188', 'Danp': '189', 'Dans': '191', 'Dant': '192', 'Danti': '193',
    'Danto': '194', 'Dantz': '195', 'Danv': '196', 'Danvi': '197', 'Dany': '198',
    'Danz': '199', 'Dao': '211', 'Dap': '212', 'Dar': '213', 'Darc': '214',
    'Dard': '215', 'Darde': '216', 'Dare': '217', 'Dari': '218', 'Dark': '219',
    'Darl': '221', 'Darm': '222', 'Darn': '223', 'Daro': '224', 'Darr': '225',
    'Dart': '226', 'Daru': '227', 'Darw': '228', 'Das': '229', 'Dass': '231',
    'Dat': '232', 'Dath': '233', 'Dati': '234', 'Dau': '235', 'Daubi': '236',
    'Dauc': '237', 'Daud': '238', 'Daul': '239', 'Daum': '241', 'Daun': '242',
    'Daur': '243', 'Daus': '244', 'Dav': '245', 'Dave': '246', 'Davenp': '247',
    'Daves': '248', 'Davi': '249', 'Davids': '251', 'Davidson': '252', 'Davidson, M.': '253',
    'Davie': '254', 'Davies': '255', 'Davies, J.': '256', 'Davies, P.': '257', 'Davig': '258',
    'Davil': '259', 'Davis': '261', 'Davis, H.': '262', 'Davis, M.': '263', 'Davis, S.': '264',
    'Davis, W.': '265', 'Davo': '266', 'Davr': '267', 'Davy': '268', 'Daw': '269',
    'Dawk': '271', 'Daws': '272', 'Day': '273', 'Day, J.': '274', 'Day, S.': '275',
    'Dayt': '276', 'Daz': '277', 'De': '278', 'Deal': '279', 'Dean': '281',
    'Dean, M.': '282', 'Deane': '283', 'Deane, M.': '284', 'Dear': '285', 'Deb': '286',
    'Debo': '287', 'Debr': '288', 'Debu': '289', 'Dec': '291', 'Dece': '292',
    'Dech': '293', 'Deci': '294', 'Deck': '295', 'Deco': '296', 'Decour': '297',
    'Decr': '298', 'Ded': '299', 'Dee': '311', 'Deer': '312', 'Def': '313',
    'Defo': '314', 'Defor': '315', 'Defr': '316', 'Deg': '317', 'Degl': '318',
    'Dego': '319', 'Degr': '321', 'Deh': '322', 'Deho': '323', 'Dei': '324',
    'Deis': '325', 'Dej': '326', 'Dejo': '327', 'Dek': '328', 'Dekr': '329',
    'Del': '331', 'Delac': '332', 'Delaf': '333', 'Delai': '334', 'Delal': '335',
    'Delam': '336', 'Delan': '337', 'Delap': '338', 'Delar': '339', 'Delat': '341',
    'Delau': '342', 'Delav': '343', 'Delb': '344', 'Delc': '345', 'Dele': '346',
    'Deles': '347', 'Deleu': '348', 'Delf': '349', 'Delfo': '351', 'Delg': '352',
    'Deli': '353', 'Delis': '354', 'Deliu': '355', 'Delk': '356', 'Dell': '357',
    'Dello': '358', 'Delm': '359', 'Delo': '361', 'Delor': '362', 'Delp': '363',
    'Delr': '364', 'Dels': '365', 'Delt': '366', 'Delv': '367', 'Delz': '368',
    'Dem': '369', 'Deman': '371', 'Demar': '372', 'Demau': '373', 'Demb': '374',
    'Dembo': '375', 'Deme': '376', 'Demet': '377', 'Demi': '378', 'Demid': '379',
    'Demil': '381', 'Demm': '382', 'Demo': '383', 'Demon': '384', 'Demop': '385',
    'Demor': '386', 'Demos': '387', 'Demou': '388', 'Demp': '389', 'Den': '391',
    'Dene': '392', 'Denh': '393', 'Deni': '394', 'Denis': '395', 'Denison': '396',
    'Denm': '397', 'Denn': '398', 'Denner': '399', 'Denni': '411', 'Denny': '412',
    'Deno': '413', 'Dent': '414', 'Denton': '415', 'Denv': '416', 'Deny': '417',
    'Deo': '418', 'Dep': '419', 'Depl': '421', 'Depo': '422', 'Depp': '423',
    'Depr': '424', 'Depu': '425', 'Deq': '426', 'Der': '427', 'Derby, M.': '428',
    'Derc': '429', 'Dere': '431', 'Derh': '432', 'Deri': '433', 'Derl': '434',
    'Derm': '435', 'Dern': '436', 'Dero': '437', 'Derr': '438', 'Derw': '439',
    'Des': '441', 'Desau': '442', 'Desb': '443', 'Desbo': '444', 'Desc': '445',
    'Desch': '446', 'Descl': '447', 'Desco': '448', 'Descr': '449', 'Dese': '451',
    'Deses': '452', 'Desf': '453', 'Desg': '454', 'Desgr': '455', 'Desh': '456',
    'Desi': '457', 'Desit': '458', 'Desj': '459', 'Desl': '461', 'Deslo': '462',
    'Desm': '463', 'Desmo': '464', 'Desmou': '465', 'Desn': '466', 'Deso': '467',
    'Desp': '468', 'Despl': '469', 'Despo': '471', 'Despor': '472', 'Despr': '473',
    'Desr': '474', 'Dess': '475', 'Dest': '476', 'Destr': '477', 'Desv': '478',
    'Det': '479', 'Deti': '481', 'Deto': '482', 'Detr': '483', 'Detz': '484',
    'Deu': '485', 'Deus': '486', 'Deux': '487', 'Dev': '488', 'Deve': '489',
    'Dever': '491', 'Devi': '492', 'Devig': '493', 'Devil': '494', 'Devin': '495',
    'Devis': '496', 'Devl': '497', 'Devo': '498', 'Devon': '499', 'Devons': '511',
    'Devos': '512', 'Devot': '513', 'Devr': '514', 'Dew': '515', 'Dewe': '516',
    'Dewes': '517', 'Dewet': '518', 'Dewey': '519', 'Dewi': '521', 'Dewitt': '522',
    'Dewitt, M.': '523', 'Dewl': '524', 'Dex': '525', 'Dext': '526', 'Dexter, M.': '527',
    'Dey': '528', 'Deyn': '529', 'Deys': '531', 'Dez': '532', 'Dh': '533',
    'Dhe': '534', 'Dho': '535', 'Di': '536', 'Diam': '537', 'Dian': '538',
    'Diap': '539', 'Dias': '541', 'Diaz': '542', 'Dib': '543', 'Dibd': '544',
    'Dic': '545', 'Dice': '546', 'Dick': '547', 'Dicke': '548', 'Dicker': '549',
    'Dickey': '551', 'Dicki': '552', 'Dickinso': '553', 'Dicks': '554', 'Did': '555',
    'Didi': '556', 'Dido': '557', 'Didr': '558', 'Die': '559', 'Diel': '561',
    'Dien': '562', 'Dier': '563', 'Dies': '564', 'Diet': '565', 'Dietr': '566',
    'Dieu': '567', 'Diez': '568', 'Dif': '569', 'Dig': '571', 'Dige': '572',
    'Digg': '573', 'Digh': '574', 'Dign': '575', 'Dil': '576', 'Dilk': '577',
    'Dill': '578', 'Dillo': '579', 'Dilw': '581', 'Dim': '582', 'Din': '583',
    'Ding': '584', 'Dini': '585', 'Dino': '586', 'Dins': '587', 'Dio': '588',
    'Diod': '589', 'Diog': '591', 'Dion': '592', 'Diop': '593', 'Dios': '594',
    'Diot': '595', 'Dip': '596', 'Dir': '597', 'Dirc': '598', 'Dirk': '599',
    'Dis': '611', 'Disn': '612', 'Disr': '613', 'Dist': '614', 'Dit': '615',
    'Dits': '616', 'Ditt': '617', 'Div': '618', 'Dix': '619', 'Dixo': '621',
    'Dixw': '622', 'Dj': '623', 'Dje': '624', 'Dji': '625', 'Djo': '626',
    'Dm': '627', 'Dmi': '628', 'Dmo': '629', 'Do': '631', 'Dob': '632',
    'Dobe': '633', 'Dobr': '634', 'Dobs': '635', 'Doc': '636', 'Doch': '637',
    'Dod': '638', 'Dodd': '639', 'Doddr': '641', 'Dodds': '642', 'Dode': '643',
    'Dodg': '644', 'Dodge, M.': '645', 'Dodi': '646', 'Dods': '647', 'Dodw': '648',
    'Doe': '649', 'Doel': '651', 'Doer': '652', 'Does': '653', 'Dog': '654',
    'Doh': '655', 'Dohn': '656', 'Doi': '657', 'Dois': '658', 'Dol': '659',
    'Dolb': '661', 'Dolc': '662', 'Dole': '663', 'Dolg': '664', 'Doll': '665',
    'Dom': '666', 'Domb': '667', 'Dome': '668', 'Domi': '669', 'Domin': '671',
    'Domit': '672', 'Domn': '673', 'Don': '674', 'Donal': '675', 'Donalds': '676',
    'Donat': '677', 'Donc': '678', 'Dond': '679', 'Done': '681', 'Dong': '682',
    'Doni': '683', 'Donk': '684', 'Donn': '685', 'Donner': '686', 'Dono': '687',
    'Dont': '688', 'Donz': '689', 'Doo': '691', 'Dop': '692', 'Dor': '693',
    'Dorat': '694', 'Dore': '695', 'Dori': '696', 'Dorig': '697', 'Dorio': '698',
    'Doris': '699', 'Dorl': '711', 'Dorm': '712', 'Dorn': '713', 'Dorni': '714',
    'Doro': '715', 'Dorr': '716', 'Dors': '717', 'Dorse': '718', 'Dort': '719',
    'Dorv': '721', 'Dos': '722', 'Dosi': '723', 'Doss': '724', 'Dot': '725',
    'Dou': '726', 'Doubl': '727', 'Douc': '728', 'Doue': '729', 'Doug': '731',
    'Dough': '732', 'Dougl': '733', 'Douglas, G.': '734', 'Douglas, M.': '735', 'Douglas, S.': '736',
    'Douglas, W.': '737', 'Doul': '738', 'Dour': '739', 'Dous': '741', 'Douv': '742',
    'Dov': '743', 'Dow': '744', 'Dowd': '745', 'Dowe': '746', 'Dowl': '747',
    'Down': '748', 'Downh': '749', 'Downi': '751', 'Dows': '752', 'Doy': '753',
    'Doyl': '754', 'Doz': '755', 'Dr': '756', 'Drac': '757', 'Drae': '758',
    'Drag': '759', 'Drak': '761', 'Drake, M.': '762', 'Drake, S.': '763', 'Dran': '764',
    'Drap': '765', 'Draper, M.': '766', 'Drapp': '767', 'Dray': '768', 'Drayt': '769',
    'Dre': '771', 'Drel': '772', 'Dres': '773', 'Dreu': '774', 'Drev': '775',
    'Drew': '776', 'Drex': '777', 'Drey': '778', 'Dri': '779', 'Drink': '781',
    'Driv': '782', 'Dro': '783', 'Drog': '784', 'Drol': '785', 'Drom': '786',
    'Dros': '787', 'Drou': '788', 'Drouo': '789', 'Drov': '791', 'Droy': '792',
    'Droz': '793', 'Dru': '794', 'Drum': '795', 'Drur': '796', 'Drus': '797',
    'Dry': '798', 'Dryd': '799', 'Drys': '811', 'Du': '812', 'Dub': '813',
    'Dube': '814', 'Dubo': '815', 'Dubois, M.': '816', 'Dubos': '817', 'Dubou': '818',
    'Dubr': '819', 'Dubu': '821', 'Duc': '822', 'Ducar': '823', 'Ducas': '824',
    'Duce': '825', 'Duch': '826', 'Duchat': '827', 'Duche': '828', 'Duches': '829',
    'Duchi': '831', 'Ducho': '832', 'Duci': '833', 'Duck': '834', 'Ducke': '835',
    'Duckw': '836', 'Ducl': '837', 'Duclo': '838', 'Duco': '839', 'Ducon': '841',
    'Ducr': '842', 'Ducro': '843', 'Dud': '844', 'Dude': '845', 'Dudi': '846',
    'Dudl': '847', 'Dudley, L.': '848', 'Dudley, S.': '849', 'Dudo': '851',
    'Due': '852', 'Duer': '853', 'Duf': '854', 'Duff': '855', 'Duffe': '856',
    'Duffi': '857', 'Duffy': '858', 'Dufl': '859', 'Dufo': '861', 'Dufourn': '862',
    'Dufr': '863', 'Dufres': '864', 'Dufu': '865', 'Dug': '866', 'Dugo': '867',
    'Dugu': '868', 'Duh': '869', 'Duhe': '871', 'Duho': '872', 'Dui': '873',
    'Duil': '874', 'Duis': '875', 'Duj': '876', 'Duk': '877', 'Dul': '878',
    'Dulau': '879', 'Dulc': '881', 'Duli': '882', 'Dull': '883', 'Dulo': '884',
    'Dum': '885', 'Dumas': '886', 'Dumay': '887', 'Dume': '888', 'Dumm': '889',
    'Dumo': '891', 'Dumon': '892', 'Dumont': '893', 'Dumor': '894', 'Dumou': '895',
    'Dumour': '896', 'Dun': '897', 'Dunb': '898', 'Dunbar, M.': '899', 'Dunc': '911',
    'Duncan, M.': '912', 'Dunco': '913', 'Dund': '914', 'Dundo': '915', 'Dung': '916',
    'Dunh': '917', 'Duni': '918', 'Dunk': '919', 'Dunl': '921', 'Dunlo': '922',
    'Dunn': '923', 'Dunni': '924', 'Duno': '925', 'Duns': '926', 'Dunt': '927',
    'Dunu': '928', 'Dup': '929', 'Dupar': '931', 'Dupe': '932', 'Duperr': '933',
    'Dupi': '934', 'Dupl': '935', 'Duples': '936', 'Dupo': '937', 'Dupont': '938',
    'Dupor': '939', 'Dupp': '941', 'Dupr': '942', 'Dupres': '943', 'Dupu': '944',
    'Dupuy': '945', 'Duq': '946', 'Dur': '947', 'Duran': '948', 'Durand, M.': '949',
    'Durant': '951', 'Duras': '952', 'Duraz': '953', 'Durd': '954', 'Dure': '955',
    'Duret': '956', 'Durey': '957', 'Durf': '958', 'Durfo': '959', 'Durh': '961',
    'Duri': '962', 'Duriv': '963', 'Duro': '964', 'Durr': '965', 'Durs': '966',
    'Duru': '967', 'Duruy': '968', 'Dury': '969', 'Dus': '971', 'Duse': '972',
    'Dusi': '973', 'Duss': '974', 'Dut': '975', 'Duti': '976', 'Duto': '977',
    'Dutr': '978', 'Dutt': '979', 'Dutton': '981', 'Duv': '982', 'Duval': '983',
    'Duvau': '984', 'Duve': '985', 'Duvet': '986', 'Duvi': '987', 'Duy': '988',
    'Dw': '989', 'Dwi': '991', 'Dwight, J.': '992', 'Dwight, S.': '993', 'Dy': '994',
    'Dye': '995', 'Dyer': '996', 'Dym': '997', 'Dyr': '998', 'Dz': '999'
  },
  'E': {
    'Ea': '11', 'Eam': '12', 'Eas': '13', 'Eat': '14', 'Eb': '15',
    'Eber': '16', 'Ec': '17', 'Ech': '18', 'Eck': '19', 'Ed': '21',
    'Ede': '22', 'Edg': '23', 'Edm': '24', 'Edw': '25', 'Edwards': '26',
    'Ef': '27', 'Eg': '28', 'Ege': '29', 'Egl': '31', 'Egr': '32',
    'Eh': '33', 'Ei': '34', 'Ein': '35', 'Eis': '36', 'El': '37',
    'Elea': '38', 'Elen': '39', 'Elg': '41', 'Eli': '42', 'Elis': '43',
    'Ell': '44', 'Elle': '45', 'Elli': '46', 'Ellis': '47', 'Elm': '48',
    'Els': '49', 'Elt': '51', 'Elw': '52', 'Em': '53', 'Emm': '54',
    'Emp': '55', 'En': '56', 'Eng': '57', 'Engl': '58', 'Enn': '59',
    'Ent': '61', 'Eo': '62', 'Ep': '63', 'Epi': '64', 'Er': '65',
    'Erd': '66', 'Ere': '67', 'Eri': '68', 'Erl': '69', 'Erm': '71',
    'Err': '72', 'Ers': '73', 'Es': '74', 'Esd': '75', 'Esl': '76',
    'Esp': '77', 'Ess': '78', 'Est': '79', 'Esti': '81', 'Estr': '82',
    'Et': '83', 'Eth': '84', 'Eto': '85', 'Eu': '86', 'Eug': '87',
    'Eul': '88', 'Eup': '89', 'Eus': '91', 'Ev': '92', 'Eve': '93',
    'Ew': '94', 'Ewi': '95', 'Ex': '96', 'Ey': '97', 'Eyr': '98',
    'Ez': '99'
  },
  'F': {
    'Fa': '111', 'Fab': '112', 'Fabb': '113', 'Fabe': '114', 'Faber': '115',
    'Faberi': '116', 'Fabert': '117', 'Fabi': '118', 'Fabil': '119', 'Fabiu': '121',
    'Fabr': '122', 'Fabre': '123', 'Fabri': '124', 'Fabrian': '125', 'Fabric': '126',
    'Fabrin': '127', 'Fabris': '128', 'Fabriz': '129', 'Fabro': '131', 'Fabrot': '132',
    'Fabry': '133', 'Fabu': '134', 'Fabv': '135', 'Faby': '136', 'Fac': '137',
    'Faccio': '138', 'Fach': '139', 'Faci': '141', 'Facis': '142', 'Facu': '143',
    'Fad': '144', 'Fadi': '145', 'Fadl': '146', 'Fae': '147', 'Faen': '148',
    'Faes': '149', 'Fag': '151', 'Fage': '152', 'Fagel': '153', 'Fagg': '154',
    'Fagi': '155', 'Fagn': '156', 'Fah': '157', 'Fahr': '158', 'Fai': '159',
    'Fail': '161', 'Fain': '162', 'Fair': '163', 'Fairban': '164', 'Fairc': '165',
    'Fairf': '166', 'Fairfax, M.': '167', 'Fairfie': '168', 'Fairfield, M.': '169', 'Fairh': '171',
    'Fairl': '172', 'Fais': '173', 'Fait': '174', 'Faiv': '175', 'Fak': '176',
    'Fal': '177', 'Falc': '178', 'Falck': '179', 'Falco': '181', 'Falcone': '182',
    'Falconer, M.': '183', 'Falconet': '184', 'Falcu': '185', 'Fald': '186', 'Fale': '187',
    'Falg': '188', 'Fali': '189', 'Falk': '191', 'Falken': '192', 'Falkn': '193',
    'Fall': '194', 'Fallet': '195', 'Fallo': '196', 'Fals': '197', 'Fam': '198',
    'Fan': '199', 'Fane': '211', 'Fani': '212', 'Fann': '213', 'Fano': '214',
    'Fans': '215', 'Fant': '216', 'Fanto': '217', 'Fantu': '218', 'Far': '219',
    'Farc': '221', 'Fare': '222', 'Farg': '223', 'Fari': '224', 'Farin': '225',
    'Faring': '226', 'Farini': '227', 'Faris': '228', 'Farj': '229', 'Farl': '231',
    'Farley, M.': '232', 'Farm': '233', 'Farmer, M.': '234', 'Farn': '235', 'Farnh': '236',
    'Faro': '237', 'Farq': '238', 'Farr': '239', 'Farran': '241', 'Farrar': '242',
    'Farrar, J.': '243', 'Farrar, S.': '244', 'Farre': '245', 'Farri': '246', 'Fars': '247',
    'Fas': '248', 'Fass': '249', 'Fast': '251', 'Fat': '252', 'Fati': '253',
    'Fato': '254', 'Fau': '255', 'Fauch': '256', 'Fauci': '257', 'Faud': '258',
    'Faug': '259', 'Faul': '261', 'Faulh': '262', 'Faulk': '263', 'Faun': '264',
    'Faur': '265', 'Fauri': '266', 'Faus': '267', 'Fausti': '268', 'Faustu': '269',
    'Fauv': '271', 'Fav': '272', 'Fave': '273', 'Favi': '274', 'Favo': '275',
    'Favr': '276', 'Favre': '277', 'Faw': '278', 'Fawe': '279', 'Fawk': '281',
    'Fay': '282', 'Faye': '283', 'Fayet': '284', 'Fayo': '285', 'Fayt': '286',
    'Faz': '287', 'Fe': '288', 'Feb': '289', 'Fec': '291', 'Fed': '292',
    'Feder': '293', 'Fedo': '294', 'Fee': '295', 'Feh': '296', 'Fei': '297',
    'Feildi': '298', 'Fein': '299', 'Feit': '311', 'Fel': '312', 'Feld': '313',
    'Feli': '314', 'Felic': '315', 'Felin': '316', 'Felix': '317', 'Fell': '318',
    'Felle': '319', 'Felli': '321', 'Fello': '322', 'Fellow': '323', 'Felo': '324',
    'Fels': '325', 'Felt': '326', 'Felto': '327', 'Felton, M.': '328', 'Feltr': '329',
    'Felv': '331', 'Fen': '332', 'Fene': '333', 'Feni': '334', 'Fenn': '335',
    'Fennel': '336', 'Fenner': '337', 'Fenni': '338', 'Fenno': '339', 'Feno': '341',
    'Fens': '342', 'Fent': '343', 'Fenw': '344', 'Feo': '345', 'Fer': '346',
    'Ferb': '347', 'Ferd': '348', 'Ferdo': '349', 'Fere': '351', 'Ferg': '352',
    'Fergu': '353', 'Ferguson, M.': '354', 'Ferguss': '355', 'Ferh': '356', 'Feri': '357',
    'Ferl': '358', 'Ferm': '359', 'Ferme': '361', 'Fermo': '362', 'Fern': '363',
    'Fernand': '364', 'Ferne': '365', 'Ferni': '366', 'Ferno': '367', 'Fero': '368',
    'Ferr': '369', 'Ferral': '371', 'Ferram': '372', 'Ferran': '373', 'Ferrant': '374',
    'Ferrar': '375', 'Ferrari': '376', 'Ferraro': '377', 'Ferrars': '378', 'Ferrary': '379',
    'Ferrat': '381', 'Ferrau': '382', 'Ferre': '383', 'Ferrei': '384', 'Ferreo': '385',
    'Ferrer': '386', 'Ferrero': '387', 'Ferret': '388', 'Ferri': '389', 'Ferrib': '391',
    'Ferrie': '392', 'Ferrin': '393', 'Ferrio': '394', 'Ferris': '395', 'Ferro': '396',
    'Ferron': '397', 'Ferrou': '398', 'Ferru': '399', 'Ferry': '411', 'Fert': '412',
    'Feru': '413', 'Fes': '414', 'Fessen': '415', 'Fessenden, M.': '416', 'Fessi': '417',
    'Fessl': '418', 'Fest': '419', 'Fet': '421', 'Fett': '422', 'Feu': '423',
    'Feuer': '424', 'Feug': '425', 'Feui': '426', 'Feuill': '427', 'Feut': '428',
    'Fev': '429', 'Fevr': '431', 'Fevret': '432', 'Few': '433', 'Fey': '434',
    'Feyer': '435', 'Feyn': '436', 'Ffa': '437', 'Ffo': '438', 'Fi': '439',
    'Fiam': '441', 'Fian': '442', 'Fias': '443', 'Fib': '444', 'Fic': '445',
    'Fich': '446', 'Fici': '447', 'Fick': '448', 'Fico': '449', 'Fid': '451',
    'Fide': '452', 'Fie': '453', 'Field': '454', 'Field, H.': '455', 'Field, M.': '456',
    'Field, S.': '457', 'Field, W.': '458', 'Fielde': '459', 'Fieldi': '461', 'Fields': '462',
    'Fields, J.': '463', 'Fields, S.': '464', 'Fien': '465', 'Fier': '466', 'Fies': '467',
    'Fiesco': '468', 'Fieso': '469', 'Fif': '471', 'Fig': '472', 'Figi': '473',
    'Figo': '474', 'Figr': '475', 'Figu': '476', 'Figui': '477', 'Figul': '478',
    'Fil': '479', 'Filas': '481', 'File': '482', 'Fili': '483', 'Filip': '484',
    'Fill': '485', 'Fille': '486', 'Filli': '487', 'Fillm': '488', 'Filo': '489',
    'Fils': '491', 'Fin': '492', 'Finch': '493', 'Finck': '494', 'Find': '495',
    'Fine': '496', 'Finet': '497', 'Fing': '498', 'Fini': '499', 'Fink': '511',
    'Finl': '512', 'Finlays': '513', 'Finley': '514', 'Finn': '515', 'Fino': '516',
    'Fins': '517', 'Fio': '518', 'Fiore': '519', 'Fiori': '521', 'Fiorin': '522',
    'Fir': '523', 'Fire': '524', 'Firm': '525', 'Firmin': '526', 'Firn': '527',
    'Firo': '528', 'Fis': '529', 'Fische': '531', 'Fise': '532', 'Fish': '533',
    'Fisher': '534', 'Fisher, J.': '535', 'Fisher, M.': '536', 'Fisher, S.': '537', 'Fisher, W.': '538',
    'Fisk': '539', 'Fisk, M.': '541', 'Fiske': '542', 'Fiske, M.': '543', 'Fiss': '544',
    'Fit': '545', 'Fitch, J.': '546', 'Fitch, S.': '547', 'Fitt': '548', 'Fitz': '549',
    'Fitza': '551', 'Fitzb': '552', 'Fitzc': '553', 'Fitzg': '554', 'Fitzgerald, M.': '555',
    'Fitzh': '556', 'Fitzj': '557', 'Fitzm': '558', 'Fitzn': '559', 'Fitzp': '561',
    'Fitzr': '562', 'Fitzs': '563', 'Fitzt': '564', 'Fitzw': '565', 'Fiu': '566',
    'Fix': '567', 'Fiz': '568', 'Fl': '569', 'Flac': '571', 'Flach': '572',
    'Flaco': '573', 'Flad': '574', 'Flag': '575', 'Flah': '576', 'Flai': '577',
    'Flam': '578', 'Flamen': '579', 'Flami': '581', 'Flamm': '582', 'Flams': '583',
    'Flan': '584', 'Fland': '585', 'Flandr': '586', 'Flat': '587', 'Flau': '588',
    'Flav': '589', 'Flavi': '591', 'Flavu': '592', 'Flax': '593', 'Fle': '594',
    'Flee': '595', 'Fleetw': '596', 'Flei': '597', 'Flem': '598', 'Fleming, M.': '599',
    'Flemm': '611', 'Fles': '612', 'Flet': '613', 'Fletcher, J.': '614', 'Fletcher, P.': '615',
    'Fletcher, S.': '616', 'Fleu': '617', 'Fleuri': '618', 'Fleury': '619', 'Flex': '621',
    'Fli': '622', 'Flin': '623', 'Flint': '624', 'Flint, J.': '625', 'Flint, S.': '626',
    'Flip': '627', 'Flit': '628', 'Flo': '629', 'Flog': '631', 'Floo': '632',
    'Flor': '633', 'Florent': '634', 'Flores': '635', 'Flori': '636', 'Florid': '637',
    'Florin': '638', 'Florio': '639', 'Floris': '641', 'Floru': '642', 'Flot': '643',
    'Flott': '644', 'Flow': '645', 'Floy': '646', 'Flu': '647', 'Flur': '648',
    'Fly': '649', 'Fo': '651', 'Fob': '652', 'Foc': '653', 'Fod': '654',
    'Foe': '655', 'Fog': '656', 'Fogl': '657', 'Foh': '658', 'Foi': '659',
    'Foin': '661', 'Foix': '662', 'Fok': '663', 'Fol': '664', 'Folg': '665',
    'Foli': '666', 'Folk': '667', 'Foll': '668', 'Folli': '669', 'Folq': '671',
    'Fols': '672', 'Fom': '673', 'Fon': '674', 'Fonf': '675', 'Fonn': '676',
    'Fons': '677', 'Font': '678', 'Fontai': '679', 'Fontan': '681', 'Fontani': '682',
    'Fonte': '683', 'Fonten': '684', 'Fonti': '685', 'Fontr': '686', 'Foo': '687',
    'Foot': '688', 'Foote': '689', 'Foote, M.': '691', 'Fop': '692', 'For': '693',
    'Forbes, H.': '694', 'Forbes, M.': '695', 'Forbes, S.': '696', 'Forbi': '697', 'Forc': '698',
    'Forch': '699', 'Ford': '711', 'Ford, M.': '712', 'Fordh': '713', 'Fordy': '714',
    'Fore': '715', 'Forem': '716', 'Fores': '717', 'Forester': '718', 'Foresti': '719',
    'Forf': '721', 'Forg': '722', 'Forl': '723', 'Form': '724', 'Forman': '725',
    'Forme': '726', 'Formo': '727', 'Forn': '728', 'Forr': '729', 'Forrest, M.': '731',
    'Forrester': '732', 'Fors': '733', 'Forst': '734', 'Forster, M.': '735', 'Forsy': '736',
    'Fort': '737', 'Forte': '738', 'Fortes': '739', 'Forth': '741', 'Forti': '742',
    'Fortin': '743', 'Fortis': '744', 'Forto': '745', 'Fortu': '746', 'Fos': '747',
    'Fosc': '748', 'Fosd': '749', 'Fosg': '751', 'Foss': '752', 'Fosse': '753',
    'Fost': '754', 'Foster': '755', 'Foster, H.': '756', 'Foster, M.': '757', 'Foster, S.': '758',
    'Foster, W.': '759', 'Fot': '761', 'Fother': '762', 'Fou': '763', 'Fouch': '764',
    'Foud': '765', 'Foug': '766', 'Foui': '767', 'Foul': '768', 'Foulo': '769',
    'Foulq': '771', 'Foun': '772', 'Fouq': '773', 'Four': '774', 'Fourcr': '775',
    'Fouri': '776', 'Fourm': '777', 'Fourn': '778', 'Fourni': '779', 'Fourniv': '781',
    'Fourq': '782', 'Fout': '783', 'Fov': '784', 'Fow': '785', 'Fowl': '786',
    'Fowler, H.': '787', 'Fowler, M.': '788', 'Fowler, S.': '789', 'Fowler, W.': '791',
    'Fox': '792', 'Fox, H.': '793', 'Fox, M.': '794', 'Fox, S.': '795',
    'Foxe': '796', 'Foy': '797', 'Fr': '798', 'Frach': '799', 'Frad': '811',
    'Frag': '812', 'Frai': '813', 'Fram': '814', 'Fran': '815', 'France': '816',
    'Franch': '817', 'Franci': '818', 'Francis': '819', 'Francis, M.': '821', 'Franciu': '822',
    'Franck': '823', 'Francke': '824', 'Franckl': '825', 'Franco': '826', 'Francon': '827',
    'Frang': '828', 'Frank': '829', 'Franke': '831', 'Frankl': '832', 'Franklin, H.': '833',
    'Franklin, M.': '834', 'Franklin, S.': '835', 'Franq': '836', 'Frant': '837', 'Franz': '838',
    'Frap': '839', 'Frar': '841', 'Fras': '842', 'Fraser, M.': '843', 'Frass': '844',
    'Frat': '845', 'Frau': '846', 'Frav': '847', 'Fray': '848', 'Fraz': '849',
    'Fre': '851', 'Frec': '852', 'Fred': '853', 'Free': '854', 'Freel': '855',
    'Freem': '856', 'Freer': '857', 'Frees': '858', 'Freg': '859', 'Frego': '861',
    'Freh': '862', 'Frei': '863', 'Freig': '864', 'Freil': '865', 'Freim': '866',
    'Freir': '867', 'Frek': '868', 'Frel': '869', 'Frem': '871', 'Fremi': '872',
    'Fremo': '873', 'Fren': '874', 'French, H.': '875', 'French, M.': '876', 'French, S.': '877',
    'French, W.': '878', 'Frend': '879', 'Freni': '881', 'Frer': '882', 'Freret': '883',
    'Frero': '884', 'Fres': '885', 'Fresh': '886', 'Fresn': '887', 'Fress': '888',
    'Fret': '889', 'Freu': '891', 'Frev': '892', 'Frew': '893', 'Frey': '894',
    'Freyl': '895', 'Freyt': '896', 'Frez': '897', 'Fri': '898', 'Frid': '899',
    'Frie': '911', 'Friedl': '912', 'Fries': '913', 'Fril': '914', 'Frin': '915',
    'Frip': '916', 'Frir': '917', 'Fris': '918', 'Frisw': '919', 'Frit': '921',
    'Friz': '922', 'Fro': '923', 'Frobi': '924', 'Froc': '925', 'Froe': '926',
    'Froel': '927', 'Frog': '928', 'Froh': '929', 'Froi': '931', 'From': '932',
    'Fromm': '933', 'Fron': '934', 'Frons': '935', 'Front': '936', 'Fronto': '937',
    'Fror': '938', 'Fros': '939', 'Frost': '941', 'Frot': '942', 'Frou': '943',
    'Frow': '944', 'Fru': '945', 'Frun': '946', 'Fry': '947', 'Fry, M.': '948',
    'Frye': '949', 'Fu': '951', 'Fuchs': '952', 'Fud': '953', 'Fue': '954',
    'Fuen': '955', 'Fues': '956', 'Fuf': '957', 'Fug': '958', 'Fugg': '959',
    'Fuh': '961', 'Fui': '962', 'Ful': '963', 'Fulg': '964', 'Fulk': '965',
    'Full': '966', 'Fuller, H.': '967', 'Fuller, M.': '968', 'Fuller, S.': '969', 'Fuller, W.': '971',
    'Fullert': '972', 'Fullo': '973', 'Fulm': '974', 'Fult': '975', 'Fulv': '976',
    'Fum': '977', 'Fume': '978', 'Fumi': '979', 'Fun': '981', 'Fund': '982',
    'Funk': '983', 'Funn': '984', 'Fur': '985', 'Furi': '986', 'Furl': '987',
    'Furm': '988', 'Furn': '989', 'Furnes': '991', 'Furni': '992', 'Furs': '993',
    'Furt': '994', 'Fus': '995', 'Fuss': '996', 'Fust': '997', 'Fusu': '998',
    'Fy': '999'
  },
  'G': {
    'Ga': '111', 'Gab': '112', 'Gabi': '113', 'Gabio': '114', 'Gabl': '115',
    'Gabo': '116', 'Gabr': '117', 'Gabriel': '118', 'Gabro': '119', 'Gac': '121',
    'Gaco': '122', 'Gad': '123', 'Gade': '124', 'Gado': '125', 'Gads': '126',
    'Gae': '127', 'Gaer': '128', 'Gaet': '129', 'Gaf': '131', 'Gag': '132',
    'Gage, M.': '133', 'Gagi': '134', 'Gagl': '135', 'Gago': '136', 'Gai': '137',
    'Gail': '138', 'Gaill': '139', 'Gaim': '141', 'Gain': '142', 'Gains': '143',
    'Gair': '144', 'Gaj': '145', 'Gal': '146', 'Galau': '147', 'Galb': '148',
    'Gald': '149', 'Gale': '151', 'Gale, M.': '152', 'Galen': '153', 'Galer': '154',
    'Galf': '155', 'Gali': '156', 'Galig': '157', 'Galil': '158', 'Galit': '159',
    'Galitz': '161', 'Gall': '162', 'Gallan': '163', 'Gallat': '164', 'Gallau': '165',
    'Galle': '166', 'Gallet': '167', 'Galli': '168', 'Gallim': '169', 'Gallio': '171',
    'Gallo': '172', 'Gallois': '173', 'Gallow': '174', 'Gallu': '175', 'Gallus': '176',
    'Gallw': '177', 'Galo': '178', 'Galt': '179', 'Galto': '181', 'Galv': '182',
    'Galw': '183', 'Gam': '184', 'Gamai': '185', 'Gamal': '186', 'Gamb': '187',
    'Gambar': '188', 'Gambe': '189', 'Gambi': '191', 'Gambo': '192', 'Gamm': '193',
    'Gamo': '194', 'Gan': '195', 'Gando': '196', 'Gang': '197', 'Gann': '198',
    'Gans': '199', 'Gant': '211', 'Gar': '212', 'Garb': '213', 'Garbo': '214',
    'Garc': '215', 'Garci': '216', 'Gard': '217', 'Garde': '218', 'Gardi': '219',
    'Gardiner': '221', 'Gardiner, H.': '222', 'Gardiner, M.': '223', 'Gardiner, S.': '224', 'Gardn': '225',
    'Gardner': '226', 'Gardner, H.': '227', 'Gardner, P.': '228', 'Gare': '229',
    'Garf': '231', 'Gari': '232', 'Garl': '233', 'Garn': '234', 'Garnet': '235',
    'Garni': '236', 'Garo': '237', 'Garr': '238', 'Garre': '239', 'Garri': '241',
    'Garris': '242', 'Garro': '243', 'Gart': '244', 'Garz': '245', 'Gas': '246',
    'Gasco': '247', 'Gask': '248', 'Gasp': '249', 'Gass': '251', 'Gasset': '252',
    'Gassi': '253', 'Gasso': '254', 'Gast': '255', 'Gaston': '256', 'Gastr': '257',
    'Gat': '258', 'Gates': '259', 'Gati': '261', 'Gatt': '262', 'Gatti': '263',
    'Gau': '264', 'Gauc': '265', 'Gaud': '266', 'Gaudi': '267', 'Gauf': '268',
    'Gaul': '269', 'Gault': '271', 'Gaun': '272', 'Gaur': '273', 'Gaus': '274',
    'Gaut': '275', 'Gauth': '276', 'Gauti': '277', 'Gauz': '278', 'Gav': '279',
    'Gavau': '281', 'Gave': '282', 'Gavi': '283', 'Gaw': '284', 'Gay': '285',
    'Gaye': '286', 'Gayl': '287', 'Gayo': '288', 'Gaz': '289', 'Gazo': '291',
    'Ge': '292', 'Geb': '293', 'Gec': '294', 'Ged': '295', 'Gedi': '296',
    'Gee': '297', 'Geer': '298', 'Gef': '299', 'Geh': '311', 'Gei': '312',
    'Geis': '313', 'Gel': '314', 'Geld': '315', 'Gele': '316', 'Geli': '317',
    'Gell': '318', 'Gelli': '319', 'Gelo': '321', 'Gem': '322', 'Gemm': '323',
    'Gen': '324', 'Gend': '325', 'Gene': '326', 'Genes': '327', 'Genet': '328',
    'Geng': '329', 'Geni': '331', 'Genl': '332', 'Genn': '333', 'Genne': '334',
    'Geno': '335', 'Gens': '336', 'Gent': '337', 'Gentil': '338', 'Gentr': '339',
    'Genu': '341', 'Geo': '342', 'Geof': '343', 'Geoffri': '344', 'Geoffro': '345',
    'Geor': '346', 'George': '347', 'George, H.': '348', 'George, S.': '349', 'Georges': '351',
    'Georgi': '352', 'Gep': '353', 'Ger': '354', 'Geran': '355', 'Gerar': '356',
    'Gerard, M.': '357', 'Gerardi': '358', 'Gerau': '359', 'Gerb': '361',
    'Gerber': '362', 'Gerbi': '363', 'Gerbo': '364', 'Gerc': '365', 'Gerd': '366',
    'Gere': '367', 'Gerh': '368', 'Geri': '369', 'Gerl': '371', 'Germ': '372',
    'German': '373', 'Germi': '374', 'Germo': '375', 'Gern': '376', 'Gero': '377',
    'Gerr': '378', 'Gerry': '379', 'Gers': '381', 'Gerso': '382', 'Gerst': '383',
    'Gert': '384', 'Gerv': '385', 'Gervas': '386', 'Gervi': '387', 'Gery': '388',
    'Ges': '389', 'Gesn': '391', 'Gess': '392', 'Gest': '393', 'Get': '394',
    'Geu': '395', 'Gev': '396', 'Gey': '397', 'Gez': '398', 'Gf': '399',
    'Gh': '411', 'Ghei': '412', 'Gher': '413', 'Gherard': '414', 'Gherardi': '415',
    'Gherardo': '416', 'Ghert': '417', 'Ghes': '418', 'Ghey': '419', 'Ghez': '421',
    'Ghi': '422', 'Ghid': '423', 'Ghil': '424', 'Ghir': '425', 'Ghis': '426',
    'Ghisli': '427', 'Gi': '428', 'Giac': '429', 'Gial': '431', 'Giam': '432',
    'Gian': '433', 'Gianno': '434', 'Giar': '435', 'Giat': '436', 'Gib': '437',
    'Gibbe': '438', 'Gibbo': '439', 'Gibbons': '441', 'Gibbs': '442', 'Gibbs, H.': '443',
    'Gibbs, S.': '444', 'Gibe': '445', 'Gibi': '446', 'Gibn': '447', 'Gibs': '448',
    'Gibson, H.': '449', 'Gibson, S.': '451', 'Gic': '452', 'Gid': '453',
    'Gie': '454', 'Gies': '455', 'Gif': '456', 'Giffe': '457', 'Giffo': '458',
    'Gig': '459', 'Gigo': '461', 'Gih': '462', 'Gil': '463', 'Gilbert': '464',
    'Gilbert, J.': '465', 'Gilbert, S.': '466', 'Gilc': '467', 'Gild': '468',
    'Gildo': '469', 'Gile': '471', 'Giles': '472', 'Gilf': '473', 'Gili': '474',
    'Gill': '475', 'Gille': '476', 'Gilles': '477', 'Gillesp': '478', 'Gillet': '479',
    'Gilli': '481', 'Gillm': '482', 'Gillo': '483', 'Gills': '484', 'Gilly': '485',
    'Gilm': '486', 'Gilman': '487', 'Gilmo': '488', 'Gilp': '489', 'Gim': '491',
    'Gin': '492', 'Gino': '493', 'Gio': '494', 'Giof': '495', 'Giol': '496',
    'Gior': '497', 'Giorg': '498', 'Giorgio': '499', 'Giot': '511', 'Giov': '512',
    'Giove': '513', 'Giovi': '514', 'Gir': '515', 'Giral': '516', 'Girar': '517',
    'Girard, M.': '518', 'Girarde': '519', 'Girardi': '521', 'Girau': '522',
    'Giraul': '523', 'Gird': '524', 'Giri': '525', 'Giro': '526', 'Giron': '527',
    'Girou': '528', 'Girt': '529', 'Gis': '531', 'Gise': '532', 'Gisl': '533',
    'Gism': '534', 'Giso': '535', 'Git': '536', 'Giu': '537', 'Gius': '538',
    'Giv': '539', 'Gl': '541', 'Glad': '542', 'Glads': '543', 'Glai': '544',
    'Glan': '545', 'Glanv': '546', 'Glap': '547', 'Glas': '548', 'Glass': '549',
    'Glau': '551', 'Glauc': '552', 'Glaz': '553', 'Gle': '554', 'Gled': '555',
    'Glei': '556', 'Gleig': '557', 'Glen': '558', 'Gli': '559', 'Glin': '561',
    'Glo': '562', 'Glos': '563', 'Glou': '564', 'Glov': '565', 'Glover': '566',
    'Glu': '567', 'Gly': '568', 'Gm': '569', 'Gn': '571', 'Gni': '572',
    'Go': '573', 'Gob': '574', 'Gobi': '575', 'Goc': '576', 'God': '577',
    'Godd': '578', 'Gode': '579', 'Godef': '581', 'Godes': '582', 'Godf': '583',
    'Godi': '584', 'Godin': '585', 'Godk': '586', 'Godm': '587', 'Godo': '588',
    'Godon': '589', 'Godw': '591', 'Godwin, M.': '592', 'Goe': '593', 'Goed': '594',
    'Goel': '595', 'Goep': '596', 'Goer': '597', 'Goes': '598', 'Goest': '599',
    'Goetz': '611', 'Gof': '612', 'Gog': '613', 'Goh': '614', 'Goi': '615',
    'Gois': '616', 'Gol': '617', 'Gold': '618', 'Goldi': '619', 'Goldo': '621',
    'Golds': '622', 'Goldsc': '623', 'Goldsm': '624', 'Gole': '625', 'Goli': '626',
    'Golo': '627', 'Golov': '628', 'Golt': '629', 'Gom': '631', 'Gombe': '632',
    'Gome': '633', 'Gomm': '634', 'Gon': '635', 'Gond': '636', 'Gondi': '637',
    'Gone': '638', 'Gonn': '639', 'Gont': '641', 'Gonz': '642', 'Gonzal': '643',
    'Goo': '644', 'Gooc': '645', 'Good': '646', 'Goode': '647', 'Goodel': '648',
    'Gooden': '649', 'Goodf': '651', 'Goodh': '652', 'Goodm': '653', 'Goodr': '654',
    'Goodrich, M.': '655', 'Goodw': '656', 'Goodwin, M.': '657', 'Goody': '658',
    'Gook': '659', 'Gor': '661', 'Gordon': '662', 'Gordon, G.': '663', 'Gordon, M.': '664',
    'Gordon, S.': '665', 'Gore': '666', 'Gorg': '667', 'Gorh': '668', 'Gori': '669',
    'Gorm': '671', 'Goro': '672', 'Gorr': '673', 'Gors': '674', 'Gort': '675',
    'Gos': '676', 'Goss': '677', 'Gosse': '678', 'Gossel': '679', 'Gosso': '681',
    'Gost': '682', 'Got': '683', 'Goth': '684', 'Gott': '685', 'Gotti': '686',
    'Gotts': '687', 'Gou': '688', 'Gouf': '689', 'Goug': '691', 'Gough': '692',
    'Gouj': '693', 'Goul': '694', 'Goulb': '695', 'Gould': '696', 'Gould, J.': '697',
    'Gould, S.': '698', 'Gouls': '699', 'Goun': '711', 'Goup': '712', 'Gour': '713',
    'Gourd': '714', 'Gourg': '715', 'Gouri': '716', 'Gous': '717', 'Gout': '718',
    'Gouv': '719', 'Gov': '721', 'Gow': '722', 'Gower': '723', 'Goy': '724',
    'Goz': '725', 'Gr': '726', 'Grab': '727', 'Graber': '728', 'Grac': '729',
    'Graci': '731', 'Grad': '732', 'Grado': '733', 'Grae': '734', 'Graes': '735',
    'Graf': '736', 'Graft': '737', 'Grah': '738', 'Graham, G.': '739', 'Graham, M.': '741',
    'Graham, S.': '742', 'Grai': '743', 'Gral': '744', 'Gram': '745', 'Grammo': '746',
    'Gramo': '747', 'Gran': '748', 'Granc': '749', 'Grand': '751', 'Grandes': '752',
    'Grandi': '753', 'Grandm': '754', 'Grandv': '755', 'Grane': '756', 'Grang': '757',
    'Granger': '758', 'Grani': '759', 'Grant': '761', 'Grant, H.': '762', 'Grant, S.': '763',
    'Grantl': '764', 'Granv': '765', 'Grap': '766', 'Gras': '767', 'Grass': '768',
    'Grassi': '769', 'Grat': '771', 'Grati': '772', 'Gratt': '773', 'Grau': '774',
    'Grav': '775', 'Graves': '776', 'Gravi': '777', 'Gray': '778', 'Gray, G.': '779',
    'Gray, M.': '781', 'Gray, S.': '782', 'Gray, W.': '783', 'Grays': '784',
    'Graz': '785', 'Gre': '786', 'Greav': '787', 'Greb': '788', 'Grec': '789',
    'Greco': '791', 'Gred': '792', 'Gree': '793', 'Greel': '794', 'Green': '795',
    'Green, G.': '796', 'Green, M.': '797', 'Green, S.': '798', 'Greene': '799',
    'Greene, J.': '811', 'Greene, S.': '812', 'Greenh': '813', 'Greenl': '814',
    'Greeno': '815', 'Greenw': '816', 'Gref': '817', 'Greg': '818', 'Gregg': '819',
    'Gregori': '821', 'Gregory': '822', 'Gregory, M.': '823', 'Grei': '824',
    'Grel': '825', 'Gren': '826', 'Greni': '827', 'Grenv': '828', 'Grep': '829',
    'Gres': '831', 'Gress': '832', 'Gresw': '833', 'Gret': '834', 'Gretto': '835',
    'Greu': '836', 'Grev': '837', 'Grevi': '838', 'Grevy': '839', 'Grew': '841',
    'Grey': '842', 'Grey, G.': '843', 'Grey, M.': '844', 'Grey, S.': '845',
    'Gri': '846', 'Grid': '847', 'Grie': '848', 'Grif': '849', 'Griffin': '851',
    'Griffin, M.': '852', 'Griffith': '853', 'Griffith, M.': '854', 'Griffiths': '855',
    'Griffo': '856', 'Grig': '857', 'Gril': '858', 'Grillo': '859', 'Grim': '861',
    'Grime': '862', 'Grimk': '863', 'Grimm': '864', 'Grimo': '865', 'Grin': '866',
    'Grinf': '867', 'Grinn': '868', 'Gris': '869', 'Grisw': '871', 'Griv': '872',
    'Gro': '873', 'Groe': '874', 'Grol': '875', 'Gron': '876', 'Gros': '877',
    'Gross': '878', 'Grosv': '879', 'Grot': '881', 'Grou': '882', 'Grov': '883',
    'Groves': '884', 'Gru': '885', 'Grue': '886', 'Grul': '887', 'Grun': '888',
    'Grund': '889', 'Grune': '891', 'Grup': '892', 'Grut': '893', 'Gry': '894',
    'Gryp': '895', 'Gu': '896', 'Guad': '897', 'Guai': '898', 'Gual': '899',
    'Guald': '911', 'Gualt': '912', 'Guan': '913', 'Guar': '914', 'Guari': '915',
    'Guarn': '916', 'Guas': '917', 'Guat': '918', 'Guaz': '919', 'Gub': '921',
    'Gud': '922', 'Gudm': '923', 'Gue': '924', 'Guel': '925', 'Guen': '926',
    'Gueno': '927', 'Guep': '928', 'Guer': '929', 'Guere': '931', 'Gueri': '932',
    'Guern': '933', 'Guerr': '934', 'Guerri': '935', 'Gues': '936', 'Guet': '937',
    'Gueu': '938', 'Guev': '939', 'Guf': '941', 'Gug': '942', 'Gui': '943',
    'Guib': '944', 'Guic': '945', 'Guid': '946', 'Guidi': '947', 'Guido': '948',
    'Guie': '949', 'Guig': '951', 'Guij': '952', 'Guil': '953', 'Guild': '954',
    'Guild, M.': '955', 'Guile': '956', 'Guill': '957', 'Guille': '958', 'Guilli': '959',
    'Guillo': '961', 'Guillot': '962', 'Guim': '963', 'Guin': '964', 'Guir': '965',
    'Guis': '966', 'Guise': '967', 'Guit': '968', 'Guiz': '969', 'Gul': '971',
    'Gulg': '972', 'Gull': '973', 'Gum': '974', 'Gun': '975', 'Gunn': '976',
    'Gunt': '977', 'Gur': '978', 'Gure': '979', 'Gurn': '981', 'Gus': '982',
    'Gut': '983', 'Guth': '984', 'Gutt': '985', 'Guy': '986', 'Guyar': '987',
    'Guye': '988', 'Guyo': '989', 'Guys': '991', 'Guyt': '992', 'Guz': '993',
    'Gw': '994', 'Gwy': '995', 'Gy': '996', 'Gyll': '997', 'Gys': '998',
    'Gyz': '999'
  },
  'H': {
    'Ha': '111', 'Haas': '112', 'Hab': '113', 'Haber': '114', 'Habert': '115',
    'Habi': '116', 'Hac': '117', 'Hack': '118', 'Hacket': '119', 'Hackett': '121',
    'Hackl': '122', 'Hackm': '123', 'Haco': '124', 'Had': '125', 'Hadd': '126',
    'Haddo': '127', 'Hade': '128', 'Hadf': '129', 'Hadl': '131', 'Hadr': '132',
    'Hae': '133', 'Hael': '134', 'Haen': '135', 'Haer': '136', 'Haeu': '137',
    'Haf': '138', 'Hafi': '139', 'Hag': '141', 'Hagem': '142', 'Hagen': '143',
    'Hager': '144', 'Hagg': '145', 'Hags': '146', 'Hagu': '147', 'Hah': '148',
    'Hai': '149', 'Hail': '151', 'Hain': '152', 'Haines': '153', 'Haj': '154',
    'Hak': '155', 'Hakl': '156', 'Hal': '157', 'Hald': '158', 'Halde': '159',
    'Hale': '161', 'Hale, G.': '162', 'Hale, M.': '163', 'Hale, S.': '164', 'Hale, W.': '165',
    'Halen': '166', 'Hales': '167', 'Halet': '168', 'Half': '169', 'Halh': '171',
    'Hali': '172', 'Halif': '173', 'Hall': '174', 'Hall, D.': '175', 'Hall, G.': '176',
    'Hall, J.': '177', 'Hall, M.': '178', 'Hall, S.': '179', 'Hall, W.': '181',
    'Hallam': '182', 'Halle': '183', 'Hallec': '184', 'Haller': '185', 'Hallet': '186',
    'Halley': '187', 'Halli': '188', 'Hallig': '189', 'Halliw': '191', 'Hallo': '192',
    'Hallow': '193', 'Halm': '194', 'Halp': '195', 'Hals': '196', 'Halt': '197',
    'Ham': '198', 'Hamb': '199', 'Hamd': '211', 'Hame': '212', 'Hameli': '213',
    'Hamer': '214', 'Hamert': '215', 'Hami': '216', 'Hamil': '217', 'Hamilton, G.': '218',
    'Hamilton, M.': '219', 'Hamilton, S.': '221', 'Hamilton, W.': '222', 'Haml': '223',
    'Hamm': '224', 'Hammo': '225', 'Hammond, G.': '226', 'Hammond, M.': '227', 'Hamo': '228',
    'Hamp': '229', 'Hamps': '231', 'Hampt': '232', 'Han': '233', 'Hanc': '234',
    'Hancock, M.': '235', 'Hand': '236', 'Hane': '237', 'Hanf': '238', 'Hang': '239',
    'Hank': '241', 'Hanm': '242', 'Hann': '243', 'Hanne': '244', 'Hanni': '245',
    'Hanno': '246', 'Hano': '247', 'Hanr': '248', 'Hans': '249', 'Hanso': '251',
    'Hanw': '252', 'Haq': '253', 'Har': '254', 'Harb': '255', 'Harc': '256',
    'Harcou': '257', 'Hard': '258', 'Harden': '259', 'Hardi': '261', 'Hardie': '262',
    'Harding': '263', 'Hardinge': '264', 'Hardo': '265', 'Hardt': '266', 'Hardw': '267',
    'Hardy': '268', 'Hardy, G.': '269', 'Hardy, M.': '271', 'Hardy, S.': '272',
    'Hardy, W.': '273', 'Hare': '274', 'Hare, M.': '275', 'Haren': '276', 'Harew': '277',
    'Harf': '278', 'Harg': '279', 'Hari': '281', 'Hario': '282', 'Harl': '283',
    'Harle': '284', 'Harley': '285', 'Harlo': '286', 'Harm': '287', 'Harmo': '288',
    'Harn': '289', 'Harni': '291', 'Haro': '292', 'Harp': '293', 'Harper, G.': '294',
    'Harper, W.': '295', 'Harr': '296', 'Harri': '297', 'Harriman, M.': '298', 'Harrin': '299',
    'Harrington, M.': '311', 'Harrio': '312', 'Harris': '313', 'Harris, F.': '314',
    'Harris, M.': '315', 'Harris, S.': '316', 'Harris, W.': '317', 'Harrison': '318',
    'Harrison, F.': '319', 'Harrison, M.': '321', 'Harrison, S.': '322', 'Harrison, W.': '323',
    'Hars': '324', 'Hart': '325', 'Hart, M.': '326', 'Harte': '327', 'Harte, M.': '328',
    'Harti': '329', 'Hartl': '331', 'Hartley': '332', 'Hartm': '333', 'Harto': '334',
    'Harts': '335', 'Hartu': '336', 'Hartw': '337', 'Hartz': '338', 'Harv': '339',
    'Harvey': '341', 'Harvey, M.': '342', 'Harw': '343', 'Has': '344', 'Hasd': '345',
    'Hase': '346', 'Hasel': '347', 'Hasen': '348', 'Hask': '349', 'Haski': '351',
    'Hasl': '352', 'Hass': '353', 'Hasse': '354', 'Hassel': '355', 'Hast': '356',
    'Hastings': '357', 'Hastings, M.': '358', 'Hasw': '359', 'Hat': '361',
    'Hatf': '362', 'Hath': '363', 'Hathert': '364', 'Hats': '365', 'Hatt': '366',
    'Hatz': '367', 'Hau': '368', 'Hauf': '369', 'Haug': '371', 'Haul': '372',
    'Haun': '373', 'Haup': '374', 'Haur': '375', 'Haus': '376', 'Hauss': '377',
    'Hausso': '378', 'Haut': '379', 'Hautem': '381', 'Hautp': '382', 'Hav': '383',
    'Havel': '384', 'Haven': '385', 'Haven, M.': '386', 'Haver': '387', 'Havi': '388',
    'Haw': '389', 'Hawes': '391', 'Hawk': '392', 'Hawkins': '393', 'Hawkins, M.': '394',
    'Hawks': '395', 'Hawl': '396', 'Hawo': '397', 'Haws': '398', 'Hawt': '399',
    'Hax': '411', 'Hay': '412', 'Hay, M.': '413', 'Hayden': '414', 'Hayden, M.': '415',
    'Haydon': '416', 'Haye': '417', 'Hayes, M.': '418', 'Hayg': '419', 'Hayl': '421',
    'Haym': '422', 'Hayn': '423', 'Haynes': '424', 'Hays': '425', 'Hayt': '426',
    'Hayw': '427', 'Haz': '428', 'Haze': '429', 'Hazl': '431', 'He': '432',
    'Headl': '433', 'Heal': '434', 'Hear': '435', 'Hearn': '436', 'Heat': '437',
    'Heath, M.': '438', 'Heathc': '439', 'Heathe': '441', 'Heato': '442', 'Heb': '443',
    'Heben': '444', 'Heber': '445', 'Hebert': '446', 'Hec': '447', 'Heck': '448',
    'Hecker': '449', 'Hect': '451', 'Hed': '452', 'Hedg': '453', 'Hedi': '454',
    'Hedl': '455', 'Hedo': '456', 'Hedw': '457', 'Hee': '458', 'Heer': '459',
    'Hef': '461', 'Heg': '462', 'Heges': '463', 'Hegh': '464', 'Hei': '465',
    'Heil': '466', 'Heim': '467', 'Hein': '468', 'Heinr': '469', 'Heins': '471',
    'Heinz': '472', 'Heis': '473', 'Hel': '474', 'Heli': '475', 'Hell': '476',
    'Helle': '477', 'Helm': '478', 'Helmh': '479', 'Helmo': '481', 'Helo': '482',
    'Help': '483', 'Helps': '484', 'Helv': '485', 'Helw': '486', 'Hem': '487',
    'Heme': '488', 'Hemm': '489', 'Hemp': '491', 'Hems': '492', 'Hen': '493',
    'Henc': '494', 'Hend': '495', 'Henderson': '496', 'Henderson, M.': '497', 'Hendr': '498',
    'Henf': '499', 'Heng': '511', 'Henk': '512', 'Henkel': '513', 'Henl': '514',
    'Henn': '515', 'Henni': '516', 'Hennin': '517', 'Henr': '518', 'Henrio': '519',
    'Henry': '521', 'Henry. G.': '522', 'Henry, M.': '523', 'Henry, S.': '524',
    'Henry, W.': '525', 'Hens': '526', 'Hent': '527', 'Hentz': '528', 'Hep': '529',
    'Her': '531', 'Herar': '532', 'Herau': '533', 'Herb': '534', 'Herber': '535',
    'Herbert': '536', 'Herbert, M.': '537', 'Herbi': '538', 'Herc': '539', 'Herd': '541',
    'Here': '542', 'Hereu': '543', 'Herf': '544', 'Herg': '545', 'Heri': '546',
    'Herio': '547', 'Heris': '548', 'Herl': '549', 'Herm': '551', 'Hermann': '552',
    'Herme': '553', 'Hermi': '554', 'Hermo': '555', 'Hermon': '556', 'Hern': '557',
    'Hernd': '558', 'Hero': '559', 'Herol': '561', 'Heron': '562', 'Herp': '563',
    'Herr': '564', 'Herrer': '565', 'Herri': '566', 'Herrin': '567', 'Herrm': '568',
    'Hers': '569', 'Hersc': '571', 'Herse': '572', 'Hert': '573', 'Hertf': '574',
    'Herts': '575', 'Hertz': '576', 'Herv': '577', 'Hervey': '578', 'Hervey, M.': '579',
    'Herw': '581', 'Herz': '582', 'Hes': '583', 'Hese': '584', 'Hesm': '585',
    'Hess': '586', 'Hesse': '587', 'Hest': '588', 'Het': '589', 'Hett': '591',
    'Heu': '592', 'Heum': '593', 'Heur': '594', 'Heus': '595', 'Hev': '596',
    'Hew': '597', 'Hewe': '598', 'Hewi': '599', 'Hewit': '611', 'Hewl': '612',
    'Hews': '613', 'Hex': '614', 'Hey': '615', 'Heyf': '616', 'Heyl': '617',
    'Heym': '618', 'Heyn': '619', 'Heys': '621', 'Heyw': '622', 'Hi': '623',
    'Hib': '624', 'Hibo': '625', 'Hic': '626', 'Hick': '627', 'Hicke': '628',
    'Hicko': '629', 'Hicks': '631', 'Hid': '632', 'Hie': '633', 'Hig': '634',
    'Higg': '635', 'Higgins': '636', 'Higginson': '637', 'High': '638', 'Hij': '639',
    'Hil': '641', 'Hild': '642', 'Hilder': '643', 'Hildr': '644', 'Hill': '645',
    'Hill, G.': '646', 'Hill, M.': '647', 'Hill, S.': '648', 'Hilla': '649',
    'Hille': '651', 'Hiller': '652', 'Hillh': '653', 'Hilli': '654', 'Hills': '655',
    'Hilt': '656', 'Him': '657', 'Himi': '658', 'Hin': '659', 'Hincks': '661',
    'Hind': '662', 'Hing': '663', 'Hinr': '664', 'Hins': '665', 'Hint': '666',
    'Hip': '667', 'Hir': '668', 'Hirs': '669', 'Hirt': '671', 'Hirz': '672',
    'His': '673', 'Hit': '674', 'Hitchi': '675', 'Hitt': '676', 'Hj': '677',
    'Ho': '678', 'Hoar': '679', 'Hob': '681', 'Hobb': '682', 'Hobh': '683',
    'Hobs': '684', 'Hoc': '685', 'Hocq': '686', 'Hod': '687', 'Hodg': '688',
    'Hodges, M.': '689', 'Hodgs': '691', 'Hods': '692', 'Hoe': '693', 'Hoel': '694',
    'Hoes': '695', 'Hoey': '696', 'Hof': '697', 'Hoff': '698', 'Hoffm': '699',
    'Hoffman, M.': '711', 'Hofl': '712', 'Hofm': '713', 'Hog': '714', 'Hogar': '715',
    'Hogg': '716', 'Hoh': '717', 'Hohenl': '718', 'Hohenz': '719', 'Hok': '721',
    'Hol': '722', 'Holb': '723', 'Holbr': '724', 'Holc': '725', 'Hold': '726',
    'Holder': '727', 'Holds': '728', 'Hole': '729', 'Holg': '731', 'Holi': '732',
    'Holl': '733', 'Holland': '734', 'Holland, G.': '735', 'Holland, M.': '736',
    'Holland, S.': '737', 'Holley': '738', 'Holli': '739', 'Hollin': '741', 'Hollis': '742',
    'Hollis, M.': '743', 'Hollist': '744', 'Hollo': '745', 'Holly': '746', 'Holm': '747',
    'Holme': '748', 'Holmes': '749', 'Holmes, G.': '751', 'Holmes, M.': '752',
    'Holmes, S.': '753', 'Holo': '754', 'Holr': '755', 'Hols': '756', 'Holste': '757',
    'Holt': '758', 'Holw': '759', 'Holy': '761', 'Holz': '762', 'Hom': '763',
    'Homb': '764', 'Home': '765', 'Homer': '766', 'Homes': '767', 'Homm': '768',
    'Hon': '769', 'Hond': '771', 'Hone': '772', 'Honi': '773', 'Hono': '774',
    'Hont': '775', 'Hoo': '776', 'Hood, M.': '777', 'Hoof': '778', 'Hoog': '779',
    'Hook': '781', 'Hooke': '782', 'Hooker': '783', 'Hooker, M.': '784', 'Hoop': '785',
    'Hooper, G.': '786', 'Hooper, M.': '787', 'Hooper, S.': '788', 'Hoor': '789',
    'Hop': '791', 'Hopf': '792', 'Hopk': '793', 'Hopkins, G.': '794', 'Hopkins, M.': '795',
    'Hopkins, S.': '796', 'Hopkinson': '797', 'Hopp': '798', 'Hopt': '799', 'Hor': '811',
    'Horl': '812', 'Horn': '813', 'Hornb': '814', 'Horne': '815', 'Horner': '816',
    'Hors': '817', 'Horsl': '818', 'Horst': '819', 'Hort': '821', 'Horten': '822',
    'Horto': '823', 'Horw': '824', 'Hos': '825', 'Hosk': '826', 'Hosm': '827',
    'Hosp': '828', 'Hoss': '829', 'Host': '831', 'Hot': '832', 'Hotm': '833',
    'Hott': '834', 'Hou': '835', 'Houd': '836', 'Houe': '837', 'Houg': '838',
    'Houn': '839', 'Hour': '841', 'Hous': '842', 'Houst': '843', 'Hout': '844',
    'Hov': '845', 'Hovey': '846', 'How': '847', 'Howard': '848', 'Howard, G.': '849',
    'Howard, M.': '851', 'Howard, S.': '852', 'Howard, W.': '853', 'Howd': '854',
    'Howe': '855', 'Howe, G.': '856', 'Howe, M.': '857', 'Howe, S.': '858',
    'Howel': '859', 'Howi': '861', 'Howis': '862', 'Howit': '863', 'Howl': '864',
    'Howle': '865', 'Hows': '866', 'Hoy': '867', 'Hoyt': '868', 'Hoyt, M.': '869',
    'Hoz': '872', 'Hr': '873', 'Hu': '874', 'Hub': '875', 'Hubbard, M.': '876',
    'Hube': '877', 'Hubert': '878', 'Hubn': '879', 'Hubs': '881', 'Huc': '882',
    'Hud': '883', 'Huddl': '884', 'Huds': '885', 'Hudson, M.': '886', 'Hue': '887',
    'Huet': '888', 'Huf': '889', 'Hug': '891', 'Hugh': '892', 'Hughes': '893',
    'Hughes, M.': '894', 'Hugo': '895', 'Hugon': '896', 'Hugu': '897', 'Hugui': '898',
    'Hui': '899', 'Huit': '911', 'Hul': '912', 'Hull': '913', 'Hulli': '914',
    'Hulm': '915', 'Hulo': '916', 'Huls': '917', 'Hum': '918', 'Humb': '919',
    'Hume': '921', 'Hume, M.': '922', 'Humf': '923', 'Humi': '924', 'Humm': '925',
    'Hump': '926', 'Humphreys': '927', 'Humphri': '928', 'Humps': '929', 'Hun': '931',
    'Hunc': '932', 'Hund': '933', 'Hune': '934', 'Hunf': '935', 'Hung': '936',
    'Huni': '937', 'Hunn': '938', 'Hunt': '939', 'Hunt, G.': '941', 'Hunt, M.': '942',
    'Hunt, S.': '943', 'Hunte': '944', 'Hunter': '945', 'Hunter, M.': '946', 'Hunter, S.': '947',
    'Hunting': '948', 'Huntington': '949', 'Huntington, G.': '951', 'Huntington, M.': '952',
    'Huntington, S.': '953', 'Huntl': '954', 'Hunto': '955', 'Hunts': '956', 'Huo': '957',
    'Hup': '958', 'Hur': '959', 'Hurd, M.': '961', 'Hurdi': '962', 'Hure': '963',
    'Huri': '964', 'Hurl': '965', 'Hurls': '966', 'Hurt': '967', 'Hus': '968',
    'Huse': '969', 'Husk': '971', 'Huss': '972', 'Hut': '973', 'Hutchins': '974',
    'Hutchinson': '975', 'Hutchinson, G.': '976', 'Hutchinson, M.': '977', 'Hutchinson, S.': '978',
    'Huth': '979', 'Huti': '981', 'Hutt': '982', 'Hutter': '983', 'Hutto': '984',
    'Hutton, M.': '985', 'Hux': '986', 'Huy': '987', 'Huys': '988', 'Huz': '989',
    'Hw': '991', 'Hy': '992', 'Hyde': '993', 'Hyde, H.': '994', 'Hyde, P.': '995',
    'Hyl': '996', 'Hyn': '997', 'Hyp': '998', 'Hyr': '999'
  },
  'I': {
    'Ia': '11', 'Ib': '12', 'Ibn': '13', 'Ibr': '14', 'Ic': '15',
    'Ich': '16', 'Ick': '17', 'Id': '18', 'Ide': '19', 'Ido': '21',
    'Ie': '22', 'If': '23', 'Ig': '24', 'Ih': '25', 'Ik': '26',
    'Il': '27', 'Ili': '28', 'Ill': '29', 'Im': '31', 'Imb': '32',
    'Iml': '33', 'Imp': '34', 'In': '35', 'Inc': '36', 'Inch': '37',
    'Ind': '38', 'Indi': '39', 'Indo': '41', 'Indu': '42', 'Inf': '43',
    'Ing': '44', 'Inge': '45', 'Ingel': '46', 'Inger': '47', 'Ingh': '48',
    'Ingi': '49', 'Ingl': '51', 'Ingli': '52', 'Ingo': '53', 'Ingr': '54',
    'Ingre': '55', 'Ini': '56', 'Inm': '57', 'Inn': '58', 'Ins': '59',
    'Int': '61', 'Inv': '62', 'Inw': '63', 'Io': '64', 'Ir': '65',
    'Iren': '66', 'Iret': '67', 'Iri': '68', 'Irl': '69', 'Iro': '71',
    'Irv': '72', 'Is': '73', 'Isab': '74', 'Isam': '75', 'Isar': '76',
    'Isc': '77', 'Ise': '78', 'Ish': '79', 'Isi': '81', 'Isl': '82',
    'Ism': '83', 'Isn': '84', 'Iso': '85', 'Iss': '86', 'Ist': '87',
    'It': '88', 'Ith': '89', 'Itt': '91', 'Iu': '92', 'Iv': '93',
    'Ive': '94', 'Ives': '95', 'Ivo': '96', 'Ix': '97', 'Iz': '98',
    'Izm': '99'
  },
  'J': {
    'Ja': '11', 'Jac': '12', 'Jackson, J.': '13', 'Jackson, S.': '14', 'Jaco': '15',
    'Jacobi': '16', 'Jacobs': '17', 'Jacop': '18', 'Jacq': '19', 'Jacqui': '21',
    'Jae': '22', 'Jaf': '23', 'Jag': '24', 'Jah': '25', 'Jal': '26',
    'Jam': '27', 'James, M.': '28', 'James, S.': '29', 'Jameso': '31', 'Jami': '32',
    'Jan': '33', 'Jann': '34', 'Jans': '35', 'Jaq': '36', 'Jar': '37',
    'Jarv': '38', 'Jas': '39', 'Jau': '41', 'Jay': '42', 'Je': '43',
    'Jeb': '44', 'Jef': '45', 'Jeffre': '46', 'Jeffri': '47', 'Jem': '49',
    'Jen': '51', 'Jenk': '52', 'Jenks': '53', 'Jenn': '54', 'Jer': '55',
    'Jero': '56', 'Jerv': '57', 'Jes': '58', 'Jew': '59', 'Ji': '61',
    'Jo': '62', 'Joc': '63', 'Joe': '64', 'Joh': '65', 'Johnso': '66',
    'Johnson, G.': '67', 'Johnson, M.': '68', 'Johnson, S.': '69', 'Johnson, W.': '71', 'Johnst': '72',
    'Johnston, M.': '73', 'Joi': '74', 'Jol': '75', 'Jon': '76', 'Jones, G.': '77',
    'Jones, M.': '78', 'Jones, S.': '79', 'Jons': '81', 'Jor': '82', 'Jos': '83',
    'Joss': '84', 'Jot': '85', 'Jou': '86', 'Jow': '87', 'Joy': '88',
    'Joyc': '89', 'Ju': '91', 'Jud': '92', 'Juds': '93', 'Jul': '94',
    'Jun': '95', 'Jus': '96', 'Juv': '97', 'Jux': '98', 'Jy': '99'
  },
  'K': {
    'Ka': '11', 'Kah': '12', 'Kai': '13', 'Kal': '14', 'Kam': '15',
    'Kan': '16', 'Kap': '17', 'Kar': '18', 'Kas': '19', 'Kau': '21',
    'Kaw': '22', 'Kay': '23', 'Ke': '24', 'Keat': '25', 'Kee': '26',
    'Kei': '27', 'Keith': '28', 'Kel': '29', 'Kem': '31', 'Kemp': '32',
    'Ken': '33', 'Kenn': '34', 'Kennedy': '35', 'Kennedy, M.': '36', 'Kenny': '36', 'Kent': '37',
    'Kep': '38', 'Ker': '39', 'Kerr': '41', 'Kes': '42', 'Ket': '43',
    'Key': '44', 'Kh': '45', 'Ki': '46', 'Kie': '47', 'Kil': '48',
    'Kim': '49', 'Kin': '51', 'King': '52', 'King, J.': '53', 'King, P.': '54',
    'Kings': '55', 'Kins': '56', 'Kip': '57', 'Kir': '58', 'Kirk': '59',
    'Kirs': '61', 'Kit': '62', 'Kl': '63', 'Klein': '64', 'Kli': '65',
    'Klo': '66', 'Kn': '67', 'Kne': '68', 'Kni': '69', 'Knight, M.': '71',
    'Kno': '72', 'Know': '73', 'Knox': '74', 'Ko': '75', 'Koc': '76',
    'Koe': '77', 'Koen': '78', 'Koh': '79', 'Kol': '81', 'Kon': '82',
    'Kop': '83', 'Kor': '84', 'Kort': '85', 'Kos': '86', 'Kot': '87',
    'Kou': '88', 'Kr': '89', 'Krau': '91', 'Kre': '92', 'Kro': '93',
    'Kru': '94', 'Ku': '95', 'Kuh': '96', 'Kus': '97', 'Kw': '98',
    'Ky': '99'
  },
  'L': {
    'La': '111', 'Lab': '112', 'Labar': '113', 'Labat': '114', 'Labbe': '115',
    'Labe': '116', 'Labeo': '117', 'Labi': '118', 'Labil': '119', 'Labl': '121',
    'Labo': '122', 'Labor': '123', 'Labou': '124', 'Labour': '125', 'Labr': '126',
    'Labru': '127', 'Lac': '128', 'Lacam': '129', 'Lace': '131', 'Lach': '132',
    'Lachap': '133', 'Lachas': '134', 'Lachat': '135', 'Lachau': '136', 'Lache': '137',
    'Lachm': '138', 'Laci': '139', 'Lack': '141', 'Laco': '142', 'Lacor': '143',
    'Lacos': '144', 'Lacou': '145', 'Lacr': '146', 'Lacro': '147', 'Lacros': '148',
    'Lacru': '149', 'Lact': '151', 'Lacy': '152', 'Lad': '153', 'Ladd': '154',
    'Ladi': '155', 'Lado': '156', 'Ladr': '157', 'Lae': '158', 'Laf': '159',
    'Lafay': '161', 'Lafe': '162', 'Laff': '163', 'Lafl': '164', 'Lafo': '165',
    'Lafont': '166', 'Lafor': '167', 'Lafos': '168', 'Lafr': '169', 'Lafu': '171',
    'Lag': '172', 'Lagar': '173', 'Lage': '174', 'Lagi': '175', 'Lagn': '176',
    'Lago': '177', 'Lagr': '178', 'Lagre': '179', 'Lagu': '181', 'Lagui': '182',
    'Lah': '183', 'Laho': '184', 'Lai': '185', 'Lain': '186', 'Laing': '187',
    'Lair': '188', 'Lais': '189', 'Laj': '191', 'Lak': '192', 'Lal': '193',
    'Lalann': '194', 'Lali': '195', 'Lall': '196', 'Lalle': '197', 'Lalli': '198',
    'Lallo': '199', 'Lally': '211', 'Lalo': '212', 'Lam': '213', 'Laman': '214',
    'Lamar': '215', 'Lamarm': '216', 'Lamart': '217', 'Lamb': '218', 'Lamba': '219',
    'Lambe': '221', 'Lambert': '222', 'Lamberti': '223', 'Lambi': '224', 'Lambo': '225',
    'Lambr': '226', 'Lambt': '227', 'Lame': '228', 'Lamet': '229', 'Lami': '231',
    'Lamir': '232', 'Lamo': '233', 'Lamon': '234', 'Lamot': '235', 'Lamou': '236',
    'Lamp': '237', 'Lampi': '238', 'Lampr': '239', 'Lams': '241', 'Lamy': '242',
    'Lan': '243', 'Lanc': '244', 'Lancaster, M.': '245', 'Lance': '246', 'Lancel': '247',
    'Lancey': '248', 'Lanci': '249', 'Lanco': '251', 'Lancr': '252', 'Land': '253',
    'Lande': '254', 'Lander': '255', 'Landes': '256', 'Landi': '257', 'Lando': '258',
    'Landon': '259', 'Landor': '261', 'Landr': '262', 'Lands': '263', 'Landu': '264',
    'Lane': '265', 'Lane, M.': '266', 'Laneh': '267', 'Lanf': '268', 'Lang': '269',
    'Lang, M.': '271', 'Langd': '272', 'Langdo': '273', 'Lange': '274', 'Langen': '275',
    'Langer': '276', 'Langet': '277', 'Langf': '278', 'Langh': '279', 'Langi': '281',
    'Langl': '282', 'Langle': '283', 'Langlo': '284', 'Langr': '285', 'Langt': '286',
    'Langu': '287', 'Lanj': '288', 'Lank': '289', 'Lanm': '291', 'Lann': '292',
    'Lano': '293', 'Lans': '294', 'Lansd': '295', 'Lant': '296', 'Lanz': '297',
    'Lao': '298', 'Lap': '299', 'Lape': '311', 'Laph': '312', 'Lapi': '313',
    'Lapl': '314', 'Lapo': '315', 'Lapp': '316', 'Lapr': '317', 'Lar': '318',
    'Larc': '319', 'Lard': '321', 'Larg': '322', 'Lari': '323', 'Lark': '324',
    'Larn': '325', 'Laro': '326', 'Larochef': '327', 'Larochej': '328', 'Larom': '329',
    'Laron': '331', 'Larou': '332', 'Larr': '333', 'Larri': '334', 'Lart': '335',
    'Laru': '336', 'Las': '337', 'Lasal': '338', 'Lasan': '339', 'Lasc': '341',
    'Lasco': '342', 'Lase': '343', 'Lasi': '344', 'Lask': '345', 'Lass': '346',
    'Lasse': '347', 'Lassu': '348', 'Last': '349', 'Lat': '351', 'Lath': '352',
    'Lathr': '353', 'Lathrop, G.': '354', 'Lathrop, M.': '355', 'Lati': '356',
    'Latim': '357', 'Lato': '358', 'Latour': '359', 'Latourr': '361', 'Latr': '362',
    'Latri': '363', 'Latro': '364', 'Latu': '365', 'Lau': '366', 'Laud': '367',
    'Laude': '368', 'Lauderd': '369', 'Laudi': '371', 'Laudo': '372', 'Lauf': '373',
    'Laug': '374', 'Laum': '375', 'Laun': '376', 'Laur': '377', 'Laure': '378',
    'Laurenc': '379', 'Laurens': '381', 'Laurent': '382', 'Laurenti': '383', 'Lauri': '384',
    'Laurie': '385', 'Lauris': '386', 'Lauro': '387', 'Laus': '388', 'Laut': '389',
    'Lauv': '391', 'Lav': '392', 'Lavale': '393', 'Lavall': '394', 'Lavalli': '395',
    'Lavar': '396', 'Lavat': '397', 'Lavau': '398', 'Lave': '399', 'Lavi': '411',
    'Lavil': '412', 'Lavis': '413', 'Lavo': '414', 'Law': '415', 'Law, M.': '416',
    'Lawe': '417', 'Lawl': '418', 'Lawrence': '419', 'Lawrence, G.': '421', 'Lawrence, M.': '422',
    'Lawrence, S.': '423', 'Lawrence, W.': '424', 'Laws': '425', 'Lay': '426',
    'Layc': '427', 'Layn': '428', 'Layt': '429', 'Laz': '431', 'Lazz': '432',
    'Le': '433', 'Leac': '434', 'Leak': '435', 'Leam': '436', 'Lean': '437',
    'Lear': '438', 'Leav': '439', 'Leb': '441', 'Lebe': '442', 'Leber': '443',
    'Lebi': '444', 'Lebl': '445', 'Leblo': '446', 'Lebo': '447', 'Lebor': '448',
    'Lebou': '449', 'Lebr': '451', 'Lebret': '452', 'Lebri': '453', 'Lebru': '454',
    'Lec': '455', 'Lecar': '456', 'Lecc': '457', 'Lech': '458', 'Leche': '459',
    'Leck': '461', 'Lecl': '462', 'Leclu': '463', 'Leco': '464', 'Lecom': '465',
    'Lecon': '466', 'Lecoq': '467', 'Lecou': '468', 'Lecr': '469', 'Lect': '471',
    'Led': '472', 'Lede': '473', 'Ledo': '474', 'Ledr': '475', 'Ledy': '476',
    'Lee': '477', 'Lee, G.': '478', 'Lee, M.': '479', 'Lee, S.': '481',
    'Lee, W.': '482', 'Leec': '483', 'Leed': '484', 'Leek': '485', 'Leen': '486',
    'Lees': '487', 'Lef': '488', 'Lefebv': '489', 'Lefer': '491', 'Lefeu': '492',
    'Lefev': '493', 'Lefo': '494', 'Lefr': '495', 'Leg': '496', 'Legar': '497',
    'Legat': '498', 'Lege': '499', 'Legen': '511', 'Leger': '512', 'Legg': '513',
    'Legi': '514', 'Legn': '515', 'Lego': '516', 'Legr': '517', 'Legras': '518',
    'Legro': '519', 'Legu': '521', 'Leh': '522', 'Lehm': '523', 'Leho': '524',
    'Lei': '525', 'Leic': '526', 'Leid': '527', 'Leig': '528', 'Leigh, M.': '529',
    'Lein': '531', 'Leis': '532', 'Leit': '533', 'Lej': '534', 'Lejo': '535',
    'Lek': '536', 'Lel': '537', 'Leland': '538', 'Lele': '539', 'Leli': '541',
    'Lell': '542', 'Lelo': '543', 'Lem': '544', 'Lemai': '545', 'Lemais': '546',
    'Lemait': '547', 'Lemar': '548', 'Lemas': '549', 'Leme': '551', 'Lemere': '552',
    'Lemet': '553', 'Lemi': '554', 'Lemo': '555', 'Lemon': '556', 'Lemonn': '557',
    'Lemot': '558', 'Lemoy': '559', 'Lemp': '561', 'Lemu': '562', 'Len': '563',
    'Lend': '564', 'Lene': '565', 'Leng': '566', 'Lenn': '567', 'Lennox': '568',
    'Leno': '569', 'Lenoir': '571', 'Lenor': '572', 'Lens': '573', 'Lent': '574',
    'Lenz': '575', 'Leo': '576', 'Leod': '577', 'Leof': '578', 'Leon': '579',
    'Leonard': '581', 'Leonc': '582', 'Leone': '583', 'Leonh': '584', 'Leoni': '585',
    'Leont': '586', 'Leop': '587', 'Leot': '588', 'Leow': '589', 'Lep': '591',
    'Lepai': '592', 'Lepau': '593', 'Lepe': '594', 'Lepell': '595', 'Lepi': '596',
    'Lepl': '597', 'Lepo': '598', 'Lepr': '599', 'Leps': '611', 'Lepu': '612',
    'Leq': '613', 'Ler': '614', 'Lerd': '615', 'Lerm': '616', 'Lero': '617',
    'Leroux': '618', 'Leroy': '619', 'Leroy, M.': '621', 'Les': '622', 'Lesb': '623',
    'Lesc': '624', 'Lesch': '625', 'Lesco': '626', 'Lescu': '627', 'Lesd': '628',
    'Lesg': '629', 'Lesl': '631', 'Lesley': '632', 'Lesley, M.': '633', 'Leslie': '634',
    'Leslie, G.': '635', 'Leslie, M.': '636', 'Leslie, S.': '637', 'Less': '638',
    'Lessi': '639', 'Lesso': '641', 'Lest': '642', 'Lestr': '643', 'Lesu': '644',
    'Let': '645', 'Letell': '646', 'Leth': '647', 'Leti': '648', 'Leto': '649',
    'Lett': '651', 'Leu': '652', 'Leul': '653', 'Leus': '654', 'Lev': '655',
    'Levas': '656', 'Leve': '657', 'Lever': '658', 'Lever, M.': '659', 'Levere': '661',
    'Leves': '662', 'Levet': '663', 'Levi': '664', 'Levin': '665', 'Levis': '666',
    'Levr': '667', 'Levy': '668', 'Lew': '669', 'Lewe': '671', 'Lewin': '672',
    'Lewis': '673', 'Lewis, G.': '674', 'Lewis, M.': '675', 'Lewis, S.': '676',
    'Lewis, W.': '677', 'Lewk': '678', 'Lex': '679', 'Ley': '681', 'Leybu': '682',
    'Leyd': '683', 'Leyl': '684', 'Leys': '685', 'Lez': '686', 'Lezo': '687',
    'Lh': '688', 'Lheu': '689', 'Lho': '691', 'Lhu': '692', 'Li': '693',
    'Lib': '694', 'Liber': '695', 'Libo': '696', 'Libr': '697', 'Lic': '698',
    'Licht': '699', 'Lici': '711', 'Lid': '712', 'Liddo': '713', 'Lide': '714',
    'Lido': '715', 'Lie': '716', 'Liebn': '717', 'Liec': '718', 'Lief': '719',
    'Lieu': '721', 'Liev': '722', 'Lig': '723', 'Lightf': '724', 'Lign': '725',
    'Ligo': '726', 'Ligu': '727', 'Lil': '728', 'Lill': '729', 'Lily': '731',
    'Lim': '732', 'Limb': '733', 'Limi': '734', 'Lin': '735', 'Linc': '736',
    'Lincoln, G.': '737', 'Lincoln, M.': '738', 'Lincoln, S.': '739', 'Lincoln, W.': '741',
    'Lind': '742', 'Linde': '743', 'Linden': '744', 'Lindes': '745', 'Lindl': '746',
    'Lindn': '747', 'Linds': '748', 'Lindsay, M.': '749', 'Lindsel': '751', 'Lindsey': '752',
    'Lindsey, M.': '753', 'Lindw': '754', 'Ling': '755', 'Lini': '756', 'Linl': '757',
    'Linn': '758', 'Lins': '759', 'Lint': '761', 'Linw': '762', 'Lio': '763',
    'Lip': '764', 'Lipp': '765', 'Lippm': '766', 'Lips': '767', 'Lir': '768',
    'Lis': '769', 'Lisl': '771', 'Liss': '772', 'List': '773', 'Lisz': '774',
    'Lit': '775', 'Litch': '776', 'Litte': '777', 'Littl': '778', 'Littleb': '779',
    'Littlet': '781', 'Littr': '782', 'Liu': '783', 'Liv': '784', 'Livermore, M.': '785',
    'Livings': '786', 'Livingston, M.': '787', 'Livingstone': '788', 'Liz': '789',
    'Ll': '791', 'Llo': '792', 'Lloyd': '793', 'Lly': '794', 'Lo': '795',
    'Lob': '796', 'Lobe': '797', 'Lobk': '798', 'Lobo': '799', 'Loc': '811',
    'Loch': '812', 'Lock': '813', 'Locke': '814', 'Locker': '815', 'Lockh': '816',
    'Lockw': '817', 'Locky': '818', 'Loco': '819', 'Lod': '821', 'Lodg': '822',
    'Lodi': '823', 'Lodo': '824', 'Loe': '825', 'Loes': '826', 'Loew': '827',
    'Lof': '828', 'Loft': '829', 'Log': '831', 'Loge': '832', 'Loh': '833',
    'Loi': '834', 'Loisel': '835', 'Lok': '836', 'Lol': '837', 'Lolm': '838',
    'Lom': '839', 'Lombard': '841', 'Lombardi': '842', 'Lombe': '843', 'Lombr': '844',
    'Lome': '845', 'Lomo': '846', 'Lon': '847', 'Long': '848', 'Long, M.': '849',
    'Longc': '851', 'Longe': '852', 'Longf': '853', 'Longh': '854', 'Longi': '855',
    'Longl': '856', 'Longs': '857', 'Longu': '858', 'Longus': '859', 'Loni': '861',
    'Lons': '862', 'Loo': '863', 'Lop': '864', 'Lor': '865', 'Lord': '866',
    'Lord, M.': '867', 'Lore': '868', 'Lorenz': '869', 'Lorg': '871', 'Lori': '872',
    'Loring': '873', 'Loring, M.': '874', 'Lorm': '875', 'Lorr': '876', 'Lorry': '877',
    'Lort': '878', 'Los': '879', 'Loso': '881', 'Lot': '882', 'Loti': '883',
    'Lott': '884', 'Lotz': '885', 'Lou': '886', 'Loug': '887', 'Loui': '888',
    'Loun': '889', 'Loup': '891', 'Lour': '892', 'Lout': '893', 'Louv': '894',
    'Louvo': '895', 'Lov': '896', 'Love': '897', 'Lovel': '898', 'Lovell': '899',
    'Lovell, M.': '911', 'Low': '912', 'Lowe': '913', 'Lowell': '914', 'Lowell, G.': '915',
    'Lowell, M.': '916', 'Lowell, S.': '917', 'Lowi': '918', 'Lown': '919',
    'Lowr': '921', 'Lowt': '922', 'Loy': '923', 'Loys': '924', 'Loz': '925',
    'Lu': '926', 'Lubbo': '927', 'Lube': '928', 'Lubi': '929', 'Luc': '931',
    'Lucan': '932', 'Lucas': '933', 'Lucc': '934', 'Luce': '935', 'Luch': '936',
    'Luci': '937', 'Lucin': '938', 'Luciu': '939', 'Luck': '941', 'Lucr': '942',
    'Lucy': '943', 'Lud': '944', 'Ludl': '945', 'Ludo': '946', 'Ludr': '947',
    'Ludw': '948', 'Luf': '949', 'Lug': '951', 'Lui': '952', 'Luis': '953',
    'Luk': '954', 'Lul': '955', 'Lully': '956', 'Lum': '957', 'Luml': '958',
    'Lums': '959', 'Lun': '961', 'Lund': '962', 'Lung': '963', 'Lunt': '964',
    'Lup': '965', 'Lupt': '966', 'Lur': '967', 'Lus': '968', 'Lush': '969',
    'Lusi': '971', 'Luss': '972', 'Lut': '973', 'Luto': '974', 'Lutz': '975',
    'Luv': '976', 'Lux': '977', 'Luy': '978', 'Luz': '979', 'Ly': '981',
    'Lycu': '982', 'Lyd': '983', 'Lye': '984', 'Lyl': '985', 'Lym': '986',
    'Lyn': '987', 'Lynd': '988', 'Lynn': '989', 'Lyo': '991', 'Lyr': '992',
    'Lys': '993', 'Lysi': '994', 'Lyso': '995', 'Lyt': '996', 'Lyttl': '997',
    'Lytto': '998', 'Lyv': '999'
  },
  'M': {
    'Ma': '111', 'Mab': '112', 'Mac': '113', 'Macal': '114', 'Macar': '115',
    'Macart': '116', 'Macau': '117', 'Macb': '118', 'Macbr': '119', 'Macc': '121',
    'Maccal': '122', 'Maccar': '123', 'Macch': '124', 'Macci': '125', 'Maccl': '126',
    'Maccli': '127', 'Macclu': '128', 'Macco': '129', 'Maccor': '131', 'Maccr': '132',
    'Maccu': '133', 'Macd': '134', 'Macdon': '135', 'Macdonn': '136', 'Macdou': '137',
    'Macdow': '138', 'Macdu': '139', 'Mace': '141', 'Macer': '142', 'Macf': '143',
    'Macfi': '144', 'Macg': '145', 'Macgo': '146', 'Macgr': '147', 'Macgu': '148',
    'Mach': '149', 'Macho': '151', 'Maci': '152', 'Mack': '153', 'Macke': '154',
    'Macken': '155', 'Mackenz': '156', 'Mackenzie, M.': '157', 'Macki': '158', 'Mackn': '159',
    'Macl': '161', 'Maclay': '162', 'Macle': '163', 'Maclel': '164', 'Macleo': '165',
    'Maclu': '166', 'Macm': '167', 'Macmu': '168', 'Macn': '169', 'Maco': '171',
    'Macp': '172', 'Macq': '173', 'Macr': '174', 'Macs': '175', 'Macv': '176',
    'Macw': '177', 'Mad': '178', 'Madd': '179', 'Made': '181', 'Madi': '182',
    'Mado': '183', 'Mae': '184', 'Mael': '185', 'Maes': '186', 'Maf': '187',
    'Mag': '188', 'Magat': '189', 'Mage': '191', 'Magen': '192', 'Magg': '193',
    'Magi': '194', 'Magl': '195', 'Magn': '196', 'Magni': '197', 'Magno': '198',
    'Magnu': '199', 'Mago': '211', 'Magr': '212', 'Magu': '213', 'Mah': '214',
    'Mahm': '215', 'Maho': '216', 'Mai': '217', 'Maig': '218', 'Mail': '219',
    'Maille': '221', 'Mailly': '222', 'Maim': '223', 'Main': '224', 'Maine': '225',
    'Maint': '226', 'Mainw': '227', 'Mair': '228', 'Mairo': '229', 'Mais': '231',
    'Mait': '232', 'Maj': '233', 'Majo': '234', 'Mak': '235', 'Mal': '236',
    'Malan': '237', 'Malas': '238', 'Malat': '239', 'Malb': '241', 'Malc': '242',
    'Malco': '243', 'Mald': '244', 'Male': '245', 'Males': '246', 'Malet': '247',
    'Malev': '248', 'Malh': '249', 'Mali': '251', 'Mall': '252', 'Mallet': '253',
    'Malli': '254', 'Mallo': '255', 'Malm': '256', 'Malo': '257', 'Malou': '258',
    'Malp': '259', 'Malt': '261', 'Malv': '262', 'Mam': '263', 'Mame': '264',
    'Mami': '265', 'Man': '266', 'Manas': '267', 'Manc': '268', 'Manci': '269',
    'Mand': '271', 'Mander': '272', 'Mandr': '273', 'Mane': '274', 'Manet': '275',
    'Manf': '276', 'Mang': '277', 'Mani': '278', 'Manl': '279', 'Mann': '281',
    'Mann, M.': '282', 'Manni': '283', 'Manning, M.': '284', 'Manno': '285', 'Mans': '286',
    'Mansf': '287', 'Mansi': '288', 'Manso': '289', 'Mant': '291', 'Mantel': '292',
    'Manto': '293', 'Manu': '294', 'Manv': '295', 'Manz': '296', 'Map': '297',
    'Mar': '298', 'Marai': '299', 'Maran': '311', 'Marb': '312', 'Marc': '313',
    'Marcel': '314', 'March': '315', 'Marche': '316', 'Marchet': '317', 'Marchm': '318',
    'Marci': '319', 'Marco': '321', 'Marcu': '322', 'Mare': '323', 'Maren': '324',
    'Mares': '325', 'Maret': '326', 'Marg': '327', 'Marge': '328', 'Margo': '329',
    'Margu': '331', 'Mari': '332', 'Marian': '333', 'Marie': '334', 'Marig': '335',
    'Maril': '336', 'Marin': '337', 'Marine': '338', 'Marini': '339', 'Mario': '341',
    'Mariot': '342', 'Mariu': '343', 'Marj': '344', 'Mark': '345', 'Markl': '346',
    'Marl': '347', 'Marli': '348', 'Marlo': '349', 'Marm': '351', 'Marmon': '352',
    'Marn': '353', 'Maro': '354', 'Marot': '355', 'Marou': '356', 'Marq': '357',
    'Marr': '358', 'Marri': '359', 'Marro': '361', 'Marry': '362', 'Mars': '363',
    'Marsd': '364', 'Marsh': '365', 'Marsh, M.': '366', 'Marshall': '367', 'Marshall, G.': '368',
    'Marshall, M.': '369', 'Marshm': '371', 'Marsi': '372', 'Marso': '373', 'Marst': '374',
    'Mart': '375', 'Martel': '376', 'Marten': '377', 'Marti': '378', 'Martin': '379',
    'Martin, G.': '381', 'Martin, M.': '382', 'Martin, S.': '383', 'Martind': '384', 'Martine': '385',
    'Martini': '386', 'Marto': '387', 'Marty': '388', 'Maru': '389', 'Marv': '391',
    'Marx': '392', 'Mary': '393', 'Mas': '394', 'Masc': '395', 'Mase': '396',
    'Mash': '397', 'Maso': '398', 'Mason, G.': '399', 'Mason, M.': '411', 'Mason, S.': '412',
    'Masq': '413', 'Mass': '414', 'Masse': '415', 'Massey': '416', 'Massi': '417',
    'Massing': '418', 'Masso': '419', 'Masson, M.': '421', 'Massu': '422', 'Mast': '423',
    'Masu': '424', 'Mat': '425', 'Math': '426', 'Mather': '427', 'Mathew': '428',
    'Mathews': '429', 'Mathi': '431', 'Matho': '432', 'Mati': '433', 'Mats': '434',
    'Matt': '435', 'Matth': '436', 'Matthew': '437', 'Matthews': '438', 'Matthews, C.': '439',
    'Matthews, M.': '441', 'Matthews, S.': '442', 'Matthi': '443', 'Matti': '444', 'Matu': '445',
    'Maty': '446', 'Mau': '447', 'Mauds': '448', 'Maug': '449', 'Maun': '451',
    'Maup': '452', 'Maur': '453', 'Mauri': '454', 'Maurice, M.': '455', 'Maurit': '456',
    'Mauro': '457', 'Mauru': '458', 'Maury': '459', 'Mav': '461', 'Maw': '462',
    'Max': '463', 'Maxi': '464', 'Maxw': '465', 'May': '466', 'May, M.': '467',
    'Mayer': '468', 'Mayh': '469', 'Mayn': '471', 'Mayne': '472', 'Mayo': '473',
    'Mayr': '474', 'Maz': '475', 'Maze': '476', 'Mazz': '477', 'Mazzon': '478',
    'Me': '479', 'Meade': '481', 'Meado': '482', 'Mean': '483', 'Meas': '484',
    'Meb': '485', 'Mec': '486', 'Meck': '487', 'Med': '488', 'Medi': '489',
    'Medin': '491', 'Medo': '492', 'Medu': '493', 'Mee': '494', 'Meer': '495',
    'Meg': '496', 'Meger': '497', 'Meh': '498', 'Mei': '499', 'Meier': '511',
    'Meig': '512', 'Meil': '513', 'Mein': '514', 'Meis': '515', 'Mej': '516',
    'Mel': '517', 'Melc': '518', 'Mele': '519', 'Melf': '521', 'Meli': '522',
    'Melis': '523', 'Mell': '524', 'Mellen': '525', 'Melli': '526', 'Mello': '527',
    'Melo': '528', 'Melu': '529', 'Melv': '531', 'Melz': '532', 'Mem': '533',
    'Men': '534', 'Menar': '535', 'Menc': '536', 'Mend': '537', 'Mendes': '538',
    'Mendo': '539', 'Mene': '541', 'Menen': '542', 'Menes': '543', 'Meng': '544',
    'Meni': '545', 'Menl': '546', 'Menn': '547', 'Mens': '548', 'Ment': '549',
    'Menz': '551', 'Mer': '552', 'Merc': '553', 'Mercer': '554', 'Merci': '555',
    'Merco': '556', 'Mercy': '557', 'Mere': '558', 'Meredith': '559', 'Meri': '561',
    'Merin': '562', 'Meriv': '563', 'Merl': '564', 'Merli': '565', 'Merm': '566',
    'Mero': '567', 'Merr': '568', 'Merrif': '569', 'Merril': '571', 'Merrit': '572',
    'Merry': '573', 'Mers': '574', 'Mert': '575', 'Merv': '576', 'Merz': '577',
    'Mes': '578', 'Mesm': '579', 'Mesn': '581', 'Mesni': '582', 'Mess': '583',
    'Messe': '584', 'Messi': '585', 'Mest': '586', 'Met': '587', 'Metc': '588',
    'Mete': '589', 'Metey': '591', 'Meth': '592', 'Meto': '593', 'Metr': '594',
    'Mett': '595', 'Metz': '596', 'Meu': '597', 'Meur': '598', 'Meus': '599',
    'Mew': '611', 'Mey': '612', 'Meyer, M.': '613', 'Meyn': '614', 'Meyr': '615',
    'Meys': '616', 'Mez': '617', 'Mi': '618', 'Mic': '619', 'Mich': '621',
    'Michau': '622', 'Miche': '623', 'Michi': '624', 'Micho': '625', 'Mico': '626',
    'Mid': '627', 'Middleton': '628', 'Middleton, M.': '629', 'Mie': '631',
    'Mier': '632', 'Mif': '633', 'Mig': '634', 'Mign': '635', 'Migno': '636',
    'Mil': '637', 'Milb': '638', 'Milc': '639', 'Mild': '641', 'Mile': '642',
    'Miles': '643', 'Milf': '644', 'Mill': '645', 'Mille': '646', 'Miller': '647',
    'Miller, G.': '648', 'Miller, M.': '649', 'Miller, S.': '651', 'Miller, W.': '652',
    'Millet': '653', 'Milli': '654', 'Millin': '655', 'Millo': '656', 'Mills': '657',
    'Milm': '658', 'Miln': '659', 'Milo': '661', 'Milt': '662', 'Min': '663',
    'Mine': '664', 'Mini': '665', 'Mino': '666', 'Mint': '667', 'Minu': '668',
    'Mio': '669', 'Mir': '671', 'Miran': '672', 'Mirb': '673', 'Mire': '674',
    'Miri': '675', 'Miro': '676', 'Mirz': '677', 'Mis': '678', 'Mit': '679',
    'Mitchell': '681', 'Mitchell, M.': '682', 'Mitf': '683', 'Mith': '684', 'Mitt': '685',
    'Mn': '686', 'Mo': '687', 'Moce': '688', 'Mod': '689', 'Modes': '691',
    'Modi': '692', 'Moe': '693', 'Moer': '694', 'Mof': '695', 'Mog': '696',
    'Moh': '697', 'Mohl': '698', 'Mohr': '699', 'Mohu': '711', 'Moi': '712',
    'Moir': '713', 'Mois': '714', 'Moit': '715', 'Mok': '716', 'Mol': '717',
    'Mole': '718', 'Moles': '719', 'Moli': '721', 'Molin': '722', 'Molini': '723',
    'Molis': '724', 'Molit': '725', 'Moll': '726', 'Mollo': '727', 'Molo': '728',
    'Molt': '729', 'Moly': '731', 'Mom': '732', 'Momm': '733', 'Mon': '734',
    'Monal': '735', 'Monas': '736', 'Monc': '737', 'Moncl': '738', 'Moncr': '739',
    'Mond': '741', 'Mone': '742', 'Mong': '743', 'Moni': '744', 'Monk': '745',
    'Monl': '746', 'Monm': '747', 'Monn': '748', 'Monni': '749', 'Mono': '751',
    'Monr': '752', 'Monroe': '753', 'Mons': '754', 'Monso': '755', 'Monst': '756',
    'Mont': '757', 'Montag': '758', 'Montague': '759', 'Montai': '761', 'Montal': '762',
    'Montale': '763', 'Montan': '764', 'Montano': '765', 'Montar': '766', 'Montau': '767',
    'Montb': '768', 'Montbr': '769', 'Montc': '771', 'Monte': '772', 'Monteb': '773',
    'Montef': '774', 'Monteg': '775', 'Montel': '776', 'Montem': '777', 'Monter': '778',
    'Montes': '779', 'Montess': '781', 'Montf': '782', 'Montfl': '783', 'Montfo': '784',
    'Montg': '785', 'Montgo': '786', 'Montgom': '787', 'Montgomery, M.': '788', 'Month': '789',
    'Monti': '791', 'Montig': '792', 'Montl': '793', 'Montlu': '794', 'Montm': '795',
    'Montmi': '796', 'Montmo': '797', 'Monto': '798', 'Montp': '799', 'Montr': '811',
    'Montri': '812', 'Montro': '813', 'Montv': '814', 'Monu': '815', 'Monz': '816',
    'Moo': '817', 'Moon': '818', 'Moor': '819', 'Moore': '821', 'Moore, G.': '822',
    'Moore, M.': '823', 'Moore, S.': '824', 'Moore, W.': '825', 'Moq': '826',
    'Mor': '827', 'Moral': '828', 'Moran': '829', 'Morat': '831', 'Moraz': '832',
    'Morc': '833', 'Mord': '834', 'More': '835', 'More, M.': '836', 'Moreau': '837',
    'Moreh': '838', 'Morel': '839', 'Morell': '841', 'Morelli': '842', 'Moren': '843',
    'Moret': '844', 'Moreti': '845', 'Morf': '846', 'Morg': '847', 'Morgan, G.': '848',
    'Morgan, M.': '849', 'Morge': '851', 'Morgeus': '852', 'Morh': '853', 'Mori': '854',
    'Morie': '855', 'Morig': '856', 'Moril': '857', 'Morin': '858', 'Morini': '859',
    'Moris': '861', 'Morit': '862', 'Morl': '863', 'Morle': '864', 'Morlo': '865',
    'Morn': '866', 'Moro': '867', 'Moron': '868', 'Moros': '869', 'Moroz': '871',
    'Morr': '872', 'Morrell': '873', 'Morri': '874', 'Morris': '875', 'Morris, G.': '876',
    'Morris, M.': '877', 'Morrison': '878', 'Morrison, G.': '879', 'Morrison, M.': '881',
    'Morrison, S.': '882', 'Morrison, W.': '883', 'Mors': '884', 'Morse, G.': '885',
    'Morse, M.': '886', 'Mort': '887', 'Morti': '888', 'Morto': '889', 'Morton, M.': '891',
    'Morv': '892', 'Mory': '893', 'Mos': '894', 'Mosch': '895', 'Moscho': '896',
    'Mose': '897', 'Mosel': '898', 'Moser': '899', 'Moses': '911', 'Mosl': '912',
    'Moss': '913', 'Mosso': '914', 'Most': '915', 'Mosto': '916', 'Mot': '917',
    'Moth': '918', 'Motl': '919', 'Mott': '921', 'Motte': '922', 'Motz': '923',
    'Mou': '924', 'Mouf': '925', 'Moul': '926', 'Moult': '927', 'Moun': '928',
    'Mour': '929', 'Moure': '931', 'Mous': '932', 'Mouss': '933', 'Mout': '934',
    'Mov': '935', 'Mow': '936', 'Mox': '937', 'Moy': '938', 'Moz': '939',
    'Mu': '941', 'Muc': '942', 'Mud': '943', 'Mudg': '944', 'Mudi': '945',
    'Muel': '946', 'Mueller, M.': '947', 'Muen': '948', 'Muf': '949', 'Mug': '951',
    'Muh': '952', 'Mui': '953', 'Mul': '954', 'Mulf': '955', 'Mulg': '956',
    'Muli': '957', 'Mull': '958', 'Mulli': '959', 'Mulr': '961', 'Mum': '962',
    'Mun': '963', 'Munck': '964', 'Mund': '965', 'Munf': '966', 'Muno': '967',
    'Munr': '968', 'Muns': '969', 'Munt': '971', 'Mur': '972', 'Murc': '973',
    'Murd': '974', 'Mure': '975', 'Murg': '976', 'Muri': '977', 'Murp': '978',
    'Murr': '979', 'Murray': '981', 'Murray, G.': '982', 'Murray, M.': '983', 'Murray, S.': '984',
    'Mus': '985', 'Muse': '986', 'Musg': '987', 'Musp': '988', 'Muss': '989',
    'Must': '991', 'Mut': '992', 'Mutr': '993', 'Muz': '994', 'My': '995',
    'Mye': '996', 'Myl': '997', 'Myr': '998', 'Myt': '999'
  },
  'N': {
    'Na': '111', 'Naas': '112', 'Nab': '113', 'Nabb': '114', 'Nabe': '115',
    'Nabi': '116', 'Nabo': '117', 'Nac': '118', 'Nach': '119', 'Nachi': '121',
    'Nachm': '122', 'Nacho': '123', 'Nacht': '124', 'Nack': '125', 'Nad': '126',
    'Nadal': '127', 'Nadar': '128', 'Nadas': '129', 'Nadast': '131', 'Nadau': '132',
    'Nadaul': '133', 'Nade': '134', 'Nader': '135', 'Nadi': '136', 'Nadj': '137',
    'Nado': '138', 'Nae': '139', 'Naeg': '141', 'Naek': '142', 'Nael': '143',
    'Naer': '144', 'Naev': '145', 'Naf': '146', 'Nag': '147', 'Nagi': '148',
    'Nagl': '149', 'Nagli': '151', 'Nago': '152', 'Nah': '153', 'Nahl': '154',
    'Nai': '155', 'Nail': '156', 'Naim': '157', 'Nair': '158', 'Nait': '159',
    'Naiv': '161', 'Naj': '162', 'Nak': '163', 'Nakw': '164', 'Nal': '165',
    'Naldi': '166', 'Naldin': '167', 'Naldo': '168', 'Nale': '169', 'Nali': '171',
    'Nall': '172', 'Nals': '173', 'Nam': '174', 'Nan': '175', 'Nanc': '176',
    'Nane': '177', 'Nang': '178', 'Nani': '179', 'Nanin': '181', 'Nanini': '182',
    'Nann': '183', 'Nanni': '184', 'Nanno': '185', 'Nannu': '186', 'Nanq': '187',
    'Nans': '188', 'Nanso': '189', 'Nant': '191', 'Nanteu': '192', 'Nanti': '193',
    'Nao': '194', 'Nap': '195', 'Napier': '196', 'Napier, C.': '197', 'Napier, F.': '198',
    'Napier, J.': '199', 'Napier, M.': '211', 'Napier, S.': '212', 'Napier, W.': '213', 'Napio': '214',
    'Napl': '215', 'Napo': '216', 'Napp': '217', 'Nar': '218', 'Narbo': '219',
    'Narbor': '221', 'Narc': '222', 'Nard': '223', 'Nardin': '224', 'Nare': '225',
    'Nares': '226', 'Nares, M.': '227', 'Narg': '228', 'Nari': '229', 'Narin': '231',
    'Narn': '232', 'Narp': '233', 'Narr': '234', 'Nars': '235', 'Narst': '236',
    'Naru': '237', 'Narv': '238', 'Narvy': '239', 'Nas': '241', 'Nasaf': '242',
    'Nasal': '243', 'Nasc': '244', 'Nasco': '245', 'Nase': '246', 'Naser': '247',
    'Nash': '248', 'Nash, F.': '249', 'Nash, J.': '251', 'Nash, M.': '252', 'Nash, S.': '253',
    'Nasi': '254', 'Nasm': '255', 'Nasmith': '256', 'Nasmith, M.': '257', 'Nasmyth': '258',
    'Nasmyth, M.': '259', 'Naso': '261', 'Nasol': '262', 'Nason': '263', 'Nasr': '264',
    'Nass': '265', 'Nassau': '266', 'Nasse': '267', 'Nassi': '268', 'Nast': '269',
    'Nat': '271', 'Natali': '272', 'Natar': '273', 'Nath': '274', 'Nathans': '275',
    'Nathu': '276', 'Nati': '277', 'Nativ': '278', 'Nato': '279', 'Natt': '281',
    'Natte': '282', 'Natti': '283', 'Natto': '284', 'Natu': '285', 'Natz': '286',
    'Nau': '287', 'Naub': '288', 'Nauc': '289', 'Naud': '291', 'Naudet': '292',
    'Naudi': '293', 'Naudo': '294', 'Naue': '295', 'Nauer': '296', 'Naug': '297',
    'Naul': '298', 'Naum': '299', 'Naumann, M.': '311', 'Naun': '312', 'Naus': '313',
    'Nauss': '314', 'Nauz': '315', 'Nav': '316', 'Navag': '317', 'Navai': '318',
    'Navar': '319', 'Navarr': '321', 'Navarro': '322', 'Nave': '323', 'Navez': '324',
    'Navi': '325', 'Navil': '326', 'Navo': '327', 'Naw': '328', 'Nawr': '329',
    'Nay': '331', 'Nayli': '332', 'Naylo': '333', 'Naz': '334', 'Nazar': '335',
    'Nazo': '336', 'Nazz': '337', 'Ne': '338', 'Neal, F.': '339', 'Neal, J.': '341',
    'Neal, M.': '342', 'Neal, S.': '343', 'Neal, W.': '344', 'Neale': '345', 'Neale, G.': '346',
    'Neale, M.': '347', 'Neale, S.': '348', 'Neander': '349', 'Neander, J.': '351', 'Neander, P.': '352',
    'Neap': '353', 'Near': '354', 'Neat': '355', 'Neate': '356', 'Neav': '357',
    'Neb': '358', 'Nebe': '359', 'Neben': '361', 'Nebr': '362', 'Nebu': '363',
    'Nec': '364', 'Neck': '365', 'Necker': '366', 'Necker, M.': '367', 'Neco': '368',
    'Nect': '369', 'Ned': '371', 'Nee': '372', 'Neeb': '373', 'Need': '374',
    'Needham, M.': '375', 'Neef': '376', 'Neefe': '377', 'Neel': '378', 'Neele': '379',
    'Neer': '381', 'Nees': '382', 'Nef': '383', 'Neg': '384', 'Negr': '385',
    'Negri': '386', 'Negri, G.': '387', 'Negri, M.': '388', 'Negri, S.': '389', 'Negri, W.': '391',
    'Negrier': '392', 'Negro': '393', 'Negron': '394', 'Neh': '395', 'Nehr': '396',
    'Nei': '397', 'Neil': '398', 'Neile': '399', 'Neill': '411', 'Neill, J.': '412',
    'Neill, P.': '413', 'Neils': '414', 'Neip': '415', 'Neis': '416', 'Neit': '417',
    'Nek': '418', 'Nel': '419', 'Nell': '421', 'Nelli': '422', 'Nello': '423',
    'Nels': '424', 'Nelson, C.': '425', 'Nelson, F.': '426', 'Nelson, J.': '427', 'Nelson, M.': '428',
    'Nelson, R.': '429', 'Nelson, S.': '431', 'Nelson, W.': '432', 'Nem': '433',
    'Nemi': '434', 'Nemn': '435', 'Nemo': '436', 'Nen': '437', 'Neo': '438',
    'Nep': '439', 'Nepo': '441', 'Nepos': '442', 'Ner': '443', 'Nere': '444',
    'Neri': '445', 'Nerin': '446', 'Nerit': '447', 'Nerl': '448', 'Nero': '449',
    'Neroc': '451', 'Neron': '452', 'Ners': '453', 'Neru': '454', 'Nerv': '455',
    'Nervet': '456', 'Nes': '457', 'Nesb': '458', 'Nese': '459', 'Nesl': '461',
    'Nesm': '462', 'Ness': '463', 'Nessel': '464', 'Nessi': '465', 'Nessm': '466',
    'Nesso': '467', 'Nest': '468', 'Net': '469', 'Nets': '471', 'Nett': '472',
    'Nette': '473', 'Netter': '474', 'Nettl': '475', 'Nettleton, M.': '476', 'Neu': '477',
    'Neube': '478', 'Neud': '479', 'Neue': '481', 'Neuf': '482', 'Neufv': '483',
    'Neug': '484', 'Neuh': '485', 'Neuk': '486', 'Neul': '487', 'Neum': '488',
    'Neuman': '489', 'Neuman, G.': '491', 'Neuman, M.': '492', 'Neumar': '493', 'Neun': '494',
    'Neus': '495', 'Neusi': '496', 'Neut': '497', 'Neuv': '498', 'Nev': '499',
    'Neve': '511', 'Nevel': '512', 'Never': '513', 'Nevers': '514', 'Nevers, G.': '515',
    'Nevers, M.': '516', 'Nevers, S.': '517', 'Nevers, W.': '518', 'Neveu': '519', 'Nevi': '521',
    'Nevill': '522', 'Neville': '523', 'Neville, J.': '524', 'Neville, P.': '525', 'Nevin': '526',
    'Nevins': '527', 'Nevins, M.': '528', 'Nevit': '529', 'Nevy': '531', 'New': '532',
    'Newb': '533', 'Newbe': '534', 'Newbu': '535', 'Newc': '536', 'Newco': '537',
    'Newcomb, M.': '538', 'Newcombe': '539', 'Newcome': '541', 'Newd': '542', 'Newe': '543',
    'Newell': '544', 'Newell, G.': '545', 'Newell, M.': '546', 'Newell, S.': '547', 'Newh': '548',
    'Newl': '549', 'Newm': '551', 'Newman, D.': '552', 'Newman, J.': '553', 'Newman, M.': '554',
    'Newman, S.': '555', 'Newman, W.': '556', 'Newn': '557', 'Newp': '558', 'Newt': '559',
    'Newton': '561', 'Newton, C.': '562', 'Newton, F.': '563', 'Newton, J.': '564', 'Newton, M.': '565',
    'Newton, S.': '566', 'Newton, W.': '567', 'Ney': '568', 'Ney, J.': '569', 'Ney, P.': '571',
    'Neyl': '572', 'Neyn': '573', 'Neyr': '574', 'Nez': '575', 'Ng': '576',
    'Ni': '577', 'Nib': '578', 'Nibe': '579', 'Nibo': '581', 'Nic': '582',
    'Nican': '583', 'Nicc': '584', 'Niccoli': '585', 'Niccolini': '586', 'Niccolo': '587',
    'Nice': '588', 'Nicep': '589', 'Nicer': '591', 'Nicet': '592', 'Nicetas': '593',
    'Nich': '594', 'Nichol': '595', 'Nichol, M.': '596', 'Nicholas': '597', 'Nicholas, J.': '598',
    'Nicholas, P.': '599', 'Nicholl': '611', 'Nicholl, M.': '612', 'Nicholls': '613', 'Nicholls, G.': '614',
    'Nicholls, M.': '615', 'Nichols': '616', 'Nichols, C.': '617', 'Nichols, F.': '618', 'Nichols, J.': '619',
    'Nichols, M.': '621', 'Nichols, S.': '622', 'Nichols, W.': '623', 'Nicholson': '624', 'Nicholson, D.': '625',
    'Nicholson, J.': '626', 'Nicholson, M.': '627', 'Nicholson, S.': '628', 'Nicholson, W.': '629', 'Nici': '631',
    'Nick': '632', 'Nico': '633', 'Nicol': '634', 'Nicolai': '635', 'Nicolai, J.': '636',
    'Nicolai, P.': '637', 'Nicolas': '638', 'Nicolau': '639', 'Nicolay': '641', 'Nicole': '642',
    'Nicolet': '643', 'Nicoli': '644', 'Nicoll': '645', 'Nicollet': '646', 'Nicolls': '647',
    'Nicolls, J.': '648', 'Nicolls, P.': '649', 'Nicolo': '651', 'Nicols': '652', 'Nicolson': '653',
    'Nicolson, M.': '654', 'Nicom': '655', 'Nicome': '656', 'Nicon': '657', 'Nicop': '658',
    'Nicor': '659', 'Nicos': '661', 'Nicot': '662', 'Nicou': '663', 'Nid': '664',
    'Nie': '665', 'Nied': '666', 'Niel': '667', 'Niell': '668', 'Niels': '669',
    'Niem': '671', 'Nieme': '672', 'Niemo': '673', 'Niep': '674', 'Nier': '675',
    'Niero': '676', 'Niet': '677', 'Nieu': '678', 'Nieul': '679', 'Nieup': '681',
    'Nieuw': '682', 'Nif': '683', 'Nig': '684', 'Niger': '685', 'Niget': '686',
    'Nigh': '687', 'Nightengale, M.': '688', 'Nigr': '689', 'Nih': '691', 'Nik': '692',
    'Niko': '693', 'Nikon': '694', 'Nil': '695', 'Niles': '696', 'Niles, D.': '697',
    'Niles, J.': '698', 'Niles, M.': '699', 'Niles, S.': '711', 'Niles, W.': '712', 'Nim': '713',
    'Nin': '714', 'Nini': '715', 'Nino': '716', 'Ninu': '717', 'Nio': '718',
    'Nip': '719', 'Niq': '721', 'Nis': '722', 'Nisb': '723', 'Nisbet, M.': '724',
    'Nisl': '725', 'Niss': '726', 'Nisso': '727', 'Nit': '728', 'Nith': '729',
    'Nito': '731', 'Nits': '732', 'Nitt': '733', 'Niv': '734', 'Niver': '735',
    'Nix': '736', 'Niz': '737', 'Nj': '738', 'No': '739', 'Noail': '741',
    'Noailles, M.': '742', 'Noak': '743', 'Nob': '744', 'Nobi': '745', 'Nobl': '746',
    'Noble': '747', 'Noble, D.': '748', 'Noble, J.': '749', 'Noble, M.': '751', 'Noble, S.': '752',
    'Noble, W.': '753', 'Nobr': '754', 'Noby': '755', 'Noc': '756', 'Noch': '757',
    'Noci': '758', 'Nocr': '759', 'Nod': '761', 'Nodu': '762', 'Noe': '763',
    'Noed': '764', 'Noel': '765', 'Noel, D.': '766', 'Noel, J.': '767', 'Noel, M.': '768',
    'Noel, S.': '769', 'Noes': '771', 'Noet': '772', 'Nof': '773', 'Nog': '774',
    'Nogaro': '775', 'Noge': '776', 'Nogh': '777', 'Nogu': '778', 'Noh': '779',
    'Nohr': '781', 'Noi': '782', 'Noiret': '783', 'Noirot': '784', 'Nok': '785',
    'Nol': '786', 'Nolan': '787', 'Nolan, J.': '788', 'Nolan, P.': '789', 'Nold': '791',
    'Noli': '792', 'Noll': '793', 'Nollek': '794', 'Nollet': '795', 'Nolli': '796',
    'Nolp': '797', 'Nolt': '798', 'Nom': '799', 'Nomu': '811', 'Non': '812',
    'Noni': '813', 'Nonn': '814', 'Nonz': '815', 'Noo': '816', 'Noom': '817',
    'Noor': '818', 'Noot': '819', 'Nop': '821', 'Nor': '822', 'Norbert': '823',
    'Norbert, M.': '824', 'Norbl': '825', 'Norby': '826', 'Norc': '827', 'Nord': '828',
    'Norden': '829', 'Nordenh': '831', 'Nordens': '832', 'Nordt': '833', 'Nore': '834',
    'Norf': '835', 'Norfolk, J.': '836', 'Norfolk, P.': '837', 'Norg': '838', 'Norgh': '839',
    'Nori': '841', 'Norm': '842', 'Norman, M.': '843', 'Normanb': '844', 'Normand': '845',
    'Normand, J.': '846', 'Normand, P.': '847', 'Normandy': '848', 'Normann': '849', 'Normant': '851',
    'Noro': '852', 'Norr': '853', 'Norris, C.': '854', 'Norris, F.': '855', 'Norris, J.': '856',
    'Norris, M.': '857', 'Norris, R.': '858', 'Norris, S.': '859', 'Norris, W.': '861', 'Norry': '862',
    'Nors': '863', 'North': '864', 'North, G.': '865', 'North, M.': '866', 'North, S.': '867',
    'Northa': '868', 'Northampton': '869', 'Northampton, M.': '871', 'Northb': '872', 'Northc': '873',
    'Northe': '874', 'Northn': '875', 'Northo': '876', 'Northr': '877', 'Northu': '878',
    'Northw': '879', 'Northwo': '881', 'Norto': '882', 'Norton, C.': '883', 'Norton, F.': '884',
    'Norton, J.': '885', 'Norton, M.': '886', 'Norton, R.': '887', 'Norton, S.': '888', 'Norton, W.': '889',
    'Norv': '891', 'Norw': '892', 'Norwich, M.': '893', 'Norwo': '894', 'Norwood, M.': '895',
    'Norz': '896', 'Nos': '897', 'Nost': '898', 'Not': '899', 'Note': '911',
    'Noth': '912', 'Notk': '913', 'Notr': '914', 'Nott': '915', 'Nott, G.': '916',
    'Nott, M.': '917', 'Nott, S.': '918', 'Notti': '919', 'Nottingham, M.': '921', 'Nottn': '922',
    'Notto': '923', 'Nou': '924', 'Noue': '925', 'Nouet': '926', 'Noug': '927',
    'Nouh': '928', 'Noul': '929', 'Nour': '931', 'Nourr': '932', 'Nours': '933',
    'Nouv': '934', 'Nov': '935', 'Novar': '936', 'Nove': '937', 'Novelli': '938',
    'Novello': '939', 'Nover': '941', 'Noves': '942', 'Novi': '943', 'Novio': '944',
    'Noviu': '945', 'Now': '946', 'Nowe': '947', 'Nowell, M.': '948', 'Noy': '949',
    'Noyer': '951', 'Noyes': '952', 'Noyes, C.': '953', 'Noyes, F.': '954', 'Noyes, J.': '955',
    'Noyes, M.': '956', 'Noyes, R.': '957', 'Noyes, S.': '958', 'Noyes, W.': '959', 'Noz': '961',
    'Nu': '962', 'Nuce': '963', 'Nuci': '964', 'Nug': '965', 'Nugent': '966',
    'Nugent, J.': '967', 'Nugent, S.': '968', 'Nul': '969', 'Num': '971',
    'Nun': '972', 'Nunu': '973', 'Nur': '974', 'Nus': '975', 'Nut': '976',
    'Nutt, J.': '977', 'Nutt, P.': '978', 'Nutta': '979', 'Nuttall, M.': '981', 'Nutter': '982',
    'Nutter, G.': '983', 'Nutter, M.': '984', 'Nutter, S.': '985', 'Nutting': '986', 'Nutting, G.': '987',
    'Nutting, M.': '988', 'Nuv': '989', 'Nuy': '991', 'Nuz': '992', 'Ny': '993',
    'Nye': '994', 'Nyk': '995', 'Nym': '996', 'Nyo': '997', 'Nys': '998',
    'Nyt': '999'
  },
  'O': {
    'Oa': '11', 'Ob': '12', 'Obr': '13', 'Obs': '14', 'Oc': '15',
    'Och': '16', 'Oco': '17', 'Oconn': '18', 'Ocor': '19', 'Oct': '21',
    'Od': '22', 'Ode': '23', 'Odi': '24', 'Odo': '25', 'Odon': '26',
    'Odr': '27', 'Oe': '28', 'Oer': '29', 'Of': '31', 'Off': '32',
    'Ofl': '33', 'Og': '34', 'Ogl': '35', 'Oh': '36', 'Ohe': '37',
    'Ohm': '38', 'Oi': '39', 'Ok': '41', 'Ol': '42', 'Olb': '43',
    'Old': '44', 'Ole': '45', 'Oli': '46', 'Olip': '47', 'Oliv': '48',
    'Olivi': '49', 'Olm': '51', 'Olo': '52', 'Oly': '53', 'Om': '54',
    'Ome': '55', 'Omo': '56', 'Omu': '57', 'On': '58', 'Ons': '59',
    'Op': '61', 'Opp': '62', 'Or': '63', 'Orb': '64', 'Ord': '65',
    'Ore': '66', 'Orf': '67', 'Org': '68', 'Ori': '69', 'Orl': '71',
    'Orlo': '72', 'Orm': '73', 'Orn': '74', 'Orr': '75', 'Ors': '76',
    'Ort': '77', 'Orto': '78', 'Orv': '79', 'Os': '81', 'Osg': '82',
    'Osm': '83', 'Oss': '84', 'Ost': '85', 'Osw': '86', 'Ot': '87',
    'Oti': '88', 'Ott': '89', 'Ottl': '91', 'Otw': '92', 'Ou': '93',
    'Ous': '94', 'Ouv': '95', 'Ov': '96', 'Ow': '97', 'Ox': '98',
    'Oz': '99'
  },
  'P': {
    'Pa': '111', 'Paac': '112', 'Paacu': '113', 'Pacc': '114', 'Pace': '115',
    'Pach': '116', 'Paci': '117', 'Pacin': '118', 'Pack': '119', 'Paco': '121',
    'Pacu': '122', 'Pad': '123', 'Pado': '124', 'Padu': '125', 'Pae': '126',
    'Paez': '127', 'Pag': '128', 'Pagani': '129', 'Pagano': '131', 'Page': '132',
    'Page, M.': '133', 'Pagen': '134', 'Paget': '135', 'Pagi': '136', 'Pagit': '137',
    'Pagl': '138', 'Pagn': '139', 'Pah': '141', 'Pai': '142', 'Pail': '143',
    'Pain': '144', 'Paine, G.': '145', 'Paine, M.': '146', 'Paine, S.': '147', 'Paint': '148',
    'Pais': '149', 'Paj': '151', 'Pak': '152', 'Pal': '153', 'Palai': '154',
    'Palaz': '155', 'Pale': '156', 'Pales': '157', 'Paley': '158', 'Palf': '159',
    'Palg': '161', 'Pali': '162', 'Palis': '163', 'Pall': '164', 'Pallav': '165',
    'Palle': '166', 'Palli': '167', 'Pallis': '168', 'Pallu': '169', 'Palm': '171',
    'Palme': '172', 'Palmer': '173', 'Palmer, G.': '174', 'Palmer, M.': '175', 'Palmer, S.': '176',
    'Palmer, W.': '177', 'Palmers': '178', 'Palmi': '179', 'Palo': '181', 'Pals': '182',
    'Palt': '183', 'Palu': '184', 'Pam': '185', 'Pamph': '186', 'Pan': '187',
    'Panc': '188', 'Pand': '189', 'Pane': '191', 'Pani': '192', 'Paniz': '193',
    'Pann': '194', 'Pano': '195', 'Pans': '196', 'Pant': '197', 'Panto': '198',
    'Panz': '199', 'Pao': '211', 'Paolo': '212', 'Pap': '213', 'Pape': '214',
    'Papi': '215', 'Papil': '216', 'Papin': '217', 'Papo': '218', 'Paq': '219',
    'Par': '221', 'Parad': '222', 'Paran': '223', 'Parav': '224', 'Parc': '225',
    'Pard': '226', 'Pare': '227', 'Paren': '228', 'Parf': '229', 'Pari': '231',
    'Paris': '232', 'Parish': '233', 'Parisi': '234', 'Park': '235', 'Park, M.': '236',
    'Parke': '237', 'Parker': '238', 'Parker, F.': '239', 'Parker, J.': '241', 'Parker, M.': '242',
    'Parker, S.': '243', 'Parker, W.': '244', 'Parkes': '245', 'Parkh': '246', 'Parki': '247',
    'Parkinson, M.': '248', 'Parkman': '249', 'Parkman, M.': '251', 'Parks': '252', 'Parm': '253',
    'Parment': '254', 'Parmi': '255', 'Parn': '256', 'Paro': '257', 'Parr': '258',
    'Parr, M.': '259', 'Parri': '261', 'Parro': '262', 'Parrot': '263', 'Parry': '264',
    'Parry, M.': '265', 'Pars': '266', 'Parsons': '267', 'Parsons, G.': '268', 'Parsons, M.': '269',
    'Parsons, S.': '271', 'Parsons, W.': '272', 'Part': '273', 'Parto': '274', 'Partr': '275',
    'Parv': '276', 'Pas': '277', 'Pasc': '278', 'Pasch': '279', 'Pasco': '281',
    'Pasi': '282', 'Paso': '283', 'Pasq': '284', 'Pass': '285', 'Passar': '286',
    'Passe': '287', 'Passi': '288', 'Passo': '289', 'Past': '291', 'Pasto': '292',
    'Pastor': '293', 'Pat': '294', 'Pate': '295', 'Paters': '296', 'Paterson, M.': '297',
    'Pati': '298', 'Patis': '299', 'Patm': '311', 'Pato': '312', 'Patou': '313',
    'Patr': '314', 'Patt': '315', 'Patten': '316', 'Patterson': '317', 'Patterson, M.': '318',
    'Pattes': '319', 'Patti': '321', 'Patto': '322', 'Pau': '323', 'Paul': '324',
    'Pauld': '325', 'Paule': '326', 'Pauli': '327', 'Paulin': '328', 'Paull': '329',
    'Paulm': '331', 'Pauls': '332', 'Paulu': '333', 'Paus': '334', 'Paut': '335',
    'Pauw': '336', 'Pav': '337', 'Pavi': '338', 'Pavo': '339', 'Pax': '341',
    'Paxt': '342', 'Pay': '343', 'Payer': '344', 'Payn': '345', 'Payne': '346',
    'Pays': '347', 'Paz': '348', 'Pe': '349', 'Peabody': '351', 'Peabody, G.': '352',
    'Peabody, M.': '353', 'Peabody, S.': '354', 'Peac': '355', 'Peaco': '356', 'Peak': '357',
    'Peal': '358', 'Pear': '359', 'Pears': '361', 'Pearson, M.': '362', 'Peas': '363',
    'Pec': '364', 'Pecc': '365', 'Peck': '366', 'Peck, M.': '367', 'Peckh': '368',
    'Peco': '369', 'Ped': '371', 'Pedro': '372', 'Pee': '373', 'Peel': '374',
    'Peer': '375', 'Peg': '376', 'Pei': '377', 'Peirc': '378', 'Peirs': '379',
    'Pel': '381', 'Pelet': '382', 'Pelh': '383', 'Peli': '384', 'Pell': '385',
    'Pelle': '386', 'Peller': '387', 'Pellet': '388', 'Pellew': '389', 'Pelli': '391',
    'Pello': '392', 'Pelt': '393', 'Pemb': '394', 'Pemberton, M.': '395', 'Pembr': '396',
    'Pen': '397', 'Pendl': '398', 'Penh': '399', 'Peni': '411', 'Penn': '412',
    'Pennel': '413', 'Penni': '414', 'Penno': '415', 'Penny': '416', 'Penr': '417',
    'Pens': '418', 'Pent': '419', 'Pep': '421', 'Pepi': '422', 'Pepo': '423',
    'Pepp': '424', 'Pepy': '425', 'Per': '426', 'Perau': '427', 'Perc': '428',
    'Perci': '429', 'Percy': '431', 'Percy, M.': '432', 'Perd': '433', 'Pere': '434',
    'Pereg': '435', 'Perei': '436', 'Perel': '437', 'Perez': '438', 'Perg': '439',
    'Peri': '441', 'Perier': '442', 'Perig': '443', 'Perigo': '444', 'Perin': '445',
    'Peris': '446', 'Perk': '447', 'Perkins': '448', 'Perkins, J.': '449', 'Perkins, P.': '451',
    'Pern': '452', 'Pero': '453', 'Perr': '454', 'Perre': '455', 'Perri': '456',
    'Perrier': '457', 'Perrin': '458', 'Perro': '459', 'Perrot': '461', 'Perry': '462',
    'Perry, G.': '463', 'Perry, M.': '464', 'Perry, S.': '465', 'Pers': '466', 'Perso': '467',
    'Pert': '468', 'Perti': '469', 'Peru': '471', 'Pes': '472', 'Pesc': '473',
    'Pese': '474', 'Pess': '475', 'Pest': '476', 'Pet': '477', 'Peter': '478',
    'Peterb': '479', 'Peters': '481', 'Peters, J.': '482', 'Peters, P.': '483', 'Petersen': '484',
    'Peterson': '485', 'Peth': '486', 'Peti': '487', 'Petis': '488', 'Petit': '489',
    'Petito': '491', 'Peto': '492', 'Petr': '493', 'Petrei': '494', 'Petri': '495',
    'Petrin': '496', 'Petro': '497', 'Petru': '498', 'Pett': '499', 'Petti': '511',
    'Petty': '512', 'Petz': '513', 'Peu': '514', 'Pey': '515', 'Peyro': '516',
    'Peys': '517', 'Peyst': '518', 'Peyt': '519', 'Pez': '521', 'Pezr': '522',
    'Pf': '523', 'Pfe': '524', 'Pfei': '525', 'Pfeiffer': '526', 'Pfeiffer, M.': '527',
    'Pfen': '528', 'Pfi': '529', 'Pfl': '531', 'Ph': '532', 'Phal': '533',
    'Phale': '534', 'Phan': '535', 'Phar': '536', 'Phe': '537', 'Phel': '538',
    'Phelps, J.': '539', 'Phelps, P.': '541', 'Pher': '542', 'Phi': '543', 'Phil': '544',
    'Philb': '545', 'Phile': '546', 'Phili': '547', 'Philid': '548', 'Philip': '549',
    'Philipp': '551', 'Philippi': '552', 'Philippu': '553', 'Philips': '554', 'Philips, M.': '555',
    'Phill': '556', 'Phillip': '557', 'Phillips': '558', 'Phillips, F.': '559', 'Phillips, J.': '561',
    'Phillips, M': '562', 'Phillips, S.': '563', 'Phillips, W.': '564', 'Philo': '565', 'Philoc': '566',
    'Philom': '567', 'Philos': '568', 'Philox': '569', 'Philp': '571', 'Phin': '572',
    'Phip': '573', 'Pho': '574', 'Phor': '575', 'Phr': '576', 'Phry': '577',
    'Phy': '578', 'Pi': '579', 'Pian': '581', 'Piat': '582', 'Piatt': '583',
    'Piaz': '584', 'Pic': '585', 'Picar': '586', 'Picc': '587', 'Piccin': '588',
    'Piccio': '589', 'Picco': '591', 'Pich': '592', 'Picho': '593', 'Pick': '594',
    'Picker': '595', 'Pickering, M.': '596', 'Picket': '597', 'Pico': '598', 'Picou': '599',
    'Pict': '611', 'Pid': '612', 'Pie': '613', 'Pien': '614', 'Pier': '615',
    'Pierce, G.': '616', 'Pierce, M.': '617', 'Pierce, S.': '618', 'Pierl': '619', 'Pierp': '621',
    'Pierr': '622', 'Pierres': '623', 'Piers': '624', 'Piet': '625', 'Pietro': '626',
    'Pif': '627', 'Pig': '628', 'Pige': '629', 'Pigg': '631', 'Pign': '632',
    'Pigo': '633', 'Pih': '634', 'Pik': '635', 'Pike, M.': '636', 'Pil': '637',
    'Piles': '638', 'Pilk': '639', 'Pill': '641', 'Pillo': '642', 'Pilo': '643',
    'Pim': '644', 'Pin': '645', 'Pinar': '646', 'Pinc': '647', 'Pind': '648',
    'Pine': '649', 'Pinel': '651', 'Pinet': '652', 'Ping': '653', 'Pinh': '654',
    'Pink': '655', 'Pinn': '656', 'Pino': '657', 'Pins': '658', 'Pint': '659',
    'Pinz': '661', 'Pio': '662', 'Pioz': '663', 'Pip': '664', 'Piper': '665',
    'Piq': '666', 'Pir': '667', 'Piri': '668', 'Pirk': '669', 'Piro': '671',
    'Piron': '672', 'Pis': '673', 'Pisani': '674', 'Pisano': '675', 'Pisc': '676',
    'Pise': '677', 'Piso': '678', 'Pist': '679', 'Pit': '681', 'Pitc': '682',
    'Pith': '683', 'Piti': '684', 'Pitm': '685', 'Pitr': '686', 'Pits': '687',
    'Pitt': '688', 'Pitti': '689', 'Pitto': '691', 'Pitts': '692', 'Piu': '693',
    'Pix': '694', 'Piz': '695', 'Pl': '696', 'Plac': '697', 'Placi': '698',
    'Plan': '699', 'Planchet': '711', 'Plane': '712', 'Plant': '713', 'Planti': '714',
    'Plas': '715', 'Plat': '716', 'Platn': '717', 'Plato': '718', 'Platt': '719',
    'Plau': '721', 'Play': '722', 'Playfo': '723', 'Ple': '724', 'Plen': '725',
    'Ples': '726', 'Pley': '727', 'Pli': '728', 'Plo': '729', 'Plou': '731',
    'Plow': '732', 'Plu': '733', 'Plum': '734', 'Plumm': '735', 'Plump': '736',
    'Plun': '737', 'Pluy': '738', 'Po': '739', 'Poco': '741', 'Pod': '742',
    'Poe': '743', 'Poel': '744', 'Poer': '745', 'Pog': '746', 'Poh': '747',
    'Pohl': '748', 'Poi': '749', 'Poin': '751', 'Poins': '752', 'Poir': '753',
    'Pois': '754', 'Poisso': '755', 'Poit': '756', 'Poiti': '757', 'Poix': '758',
    'Poj': '759', 'Pok': '761', 'Pol': '762', 'Pole': '763', 'Polem': '764',
    'Polen': '765', 'Poli': '766', 'Polier': '767', 'Polig': '768', 'Polit': '769',
    'Poll': '771', 'Pollard, M.': '772', 'Polle': '773', 'Polli': '774', 'Pollio': '775',
    'Pollo': '776', 'Pollock, M.': '777', 'Polo': '778', 'Polt': '779', 'Poly': '781',
    'Polyc': '782', 'Polym': '783', 'Pom': '784', 'Pome': '785', 'Pomf': '786',
    'Pomm': '787', 'Pomp': '788', 'Pompi': '789', 'Pompo': '791', 'Pon': '792',
    'Poncel': '793', 'Poncet': '794', 'Ponch': '795', 'Pond': '796', 'Poni': '797',
    'Pons': '798', 'Ponso': '799', 'Pont': '811', 'Pontb': '812', 'Ponte': '813',
    'Pontec': '814', 'Pontev': '815', 'Ponti': '816', 'Pontm': '817', 'Ponto': '818',
    'Ponz': '819', 'Poo': '821', 'Poole': '822', 'Poor': '823', 'Poort': '824',
    'Pop': '825', 'Pope, M.': '826', 'Poph': '827', 'Popi': '828', 'Popo': '829',
    'Popp': '831', 'Por': '832', 'Porc': '833', 'Porci': '834', 'Pord': '835',
    'Pori': '836', 'Porp': '837', 'Porr': '838', 'Port': '839', 'Portaf': '841',
    'Portal': '842', 'Porte': '843', 'Porter': '844', 'Porter, F.': '845', 'Porter, J.': '846',
    'Porter, M.': '847', 'Porter, S.': '848', 'Porter, W.': '849', 'Porth': '851', 'Porti': '852',
    'Portm': '853', 'Porz': '854', 'Pos': '855', 'Poss': '856', 'Post': '857',
    'Postl': '858', 'Pot': '859', 'Pote': '861', 'Poth': '862', 'Poti': '863',
    'Poto': '864', 'Pott': '865', 'Potter': '866', 'Potter, G.': '867', 'Potter, M.': '868',
    'Potter, S.': '869', 'Potti': '871', 'Pou': '872', 'Poui': '873', 'Poul': '874',
    'Poull': '875', 'Poult': '876', 'Pour': '877', 'Pous': '878', 'Pout': '879',
    'Pow': '881', 'Powell': '882', 'Powell, F.': '883', 'Powell, J.': '884', 'Powell, M.': '885',
    'Powell, S.': '886', 'Power': '887', 'Powers': '888', 'Pown': '889', 'Poy': '891',
    'Poyn': '892', 'Poz': '893', 'Pozzo': '894', 'Pr': '895', 'Prad': '896',
    'Prae': '897', 'Praet': '898', 'Pran': '899', 'Pras': '911', 'Prat': '912',
    'Pratt': '913', 'Pratt, F.': '914', 'Pratt, J.': '915', 'Pratt, M.': '916', 'Pratt, S.': '917',
    'Prau': '918', 'Prax': '919', 'Pray': '921', 'Pre': '922', 'Prec': '923',
    'Prei': '924', 'Prem': '925', 'Pren': '926', 'Prent': '927', 'Pres': '928',
    'Prescott': '929', 'Prescott, G.': '931', 'Prescott, M.': '932', 'Prescott, S.': '933', 'Presl': '934',
    'Press': '935', 'Prest': '936', 'Preston': '937', 'Preston, G.': '938', 'Preston, M.': '939',
    'Preston, S.': '941', 'Preston, W.': '942', 'Preu': '943', 'Prev': '944', 'Pri': '945',
    'Price, M.': '946', 'Prich': '947', 'Prie': '948', 'Pries': '949', 'Prieu': '951',
    'Prim': '952', 'Prime': '953', 'Prin': '954', 'Prince, G.': '955', 'Prince, M.': '956',
    'Prince, S.': '957', 'Prio': '958', 'Pris': '959', 'Prit': '961', 'Pro': '962',
    'Proc': '963', 'Proct': '964', 'Prom': '965', 'Pros': '966', 'Prot': '967',
    'Prou': '968', 'Prov': '969', 'Pru': '971', 'Prun': '972', 'Pry': '973',
    'Ps': '974', 'Pt': '975', 'Pu': '976', 'Puc': '977', 'Pug': '978',
    'Pui': '979', 'Pul': '981', 'Pull': '982', 'Pult': '983', 'Pun': '984',
    'Pur': '985', 'Purs': '986', 'Pus': '987', 'Put': '988', 'Putnam': '989',
    'Putnam, G.': '991', 'Putnam, M.': '992', 'Putnam, S.': '993', 'Puy': '994', 'Py': '995',
    'Pyl': '996', 'Pyn': '997', 'Pyr': '998', 'Pyt': '999'
  },
  'Q': {
    'Qua': '1', 'Quat': '2', 'Que': '3', 'Quer': '4', 'Ques': '5',
    'Qui': '6', 'Quin': '7', 'Quir': '8', 'Quo': '9'
  },
  'R': {
    'Ra': '111', 'Rab': '112', 'Rabau': '113', 'Rabe': '114', 'Raben': '115',
    'Rabi': '116', 'Rabu': '117', 'Rac': '118', 'Rach': '119', 'Raci': '121',
    'Rack': '122', 'Raco': '123', 'Rad': '124', 'Radc': '125', 'Rade': '126',
    'Radem': '127', 'Radet': '128', 'Radi': '129', 'Rado': '131', 'Radu': '132',
    'Radz': '133', 'Rae': '134', 'Raen': '135', 'Raf': '136', 'Raffen': '137',
    'Raffl': '138', 'Rafn': '139', 'Rag': '141', 'Ragg': '142', 'Ragl': '143',
    'Rago': '144', 'Ragu': '145', 'Ragus': '146', 'Rah': '147', 'Rahn': '148',
    'Rai': '149', 'Raik': '151', 'Rail': '152', 'Raim': '153', 'Rain': '154',
    'Raine': '155', 'Rainey': '156', 'Raini': '157', 'Raino': '158', 'Rainv': '159',
    'Rait': '161', 'Rak': '162', 'Ral': '163', 'Rals': '164', 'Ram': '165',
    'Ramaz': '166', 'Ramb': '167', 'Rambu': '168', 'Ramd': '169', 'Rame': '171',
    'Ramel': '172', 'Rami': '173', 'Ramm': '174', 'Ramo': '175', 'Ramou': '176',
    'Ramp': '177', 'Rams': '178', 'Ramsay, J.': '179', 'Ramsay, P.': '181', 'Ramsd': '182',
    'Ramse': '183', 'Ramu': '184', 'Ran': '185', 'Rand': '186', 'Rand, M.': '187',
    'Randall': '188', 'Randall, M.': '189', 'Rande': '191', 'Rando': '192', 'Randolph, G.': '193',
    'Randolph, M.': '194', 'Randon': '195', 'Rang': '196', 'Rani': '197', 'Rank': '198',
    'Ranken': '199', 'Ranki': '211', 'Rans': '212', 'Rant': '213', 'Ranz': '214',
    'Rao': '215', 'Rap': '216', 'Raph': '217', 'Rapi': '218', 'Rapo': '219',
    'Rapp': '221', 'Ras': '222', 'Rasch': '223', 'Rase': '224', 'Rask': '225',
    'Rasp': '226', 'Raspo': '227', 'Rass': '228', 'Rast': '229', 'Rasto': '231',
    'Rat': '232', 'Ratc': '233', 'Rath': '234', 'Raths': '235', 'Rati': '236',
    'Ratt': '237', 'Ratz': '238', 'Rau': '239', 'Rauch': '241', 'Rauco': '242',
    'Raud': '243', 'Rauf': '244', 'Raul': '245', 'Raum': '246', 'Raup': '247',
    'Raus': '248', 'Raut': '249', 'Rauz': '251', 'Rav': '252', 'Raven': '253',
    'Ravens': '254', 'Raves': '255', 'Ravi': '256', 'Raw': '257', 'Rawl': '258',
    'Rawlin': '259', 'Rawlinson': '261', 'Raws': '262', 'Ray': '263', 'Ray, M.': '264',
    'Rayb': '265', 'Raye': '266', 'Raym': '267', 'Raymond': '268', 'Raymond, G.': '269',
    'Raymond, M.': '271', 'Raymond, S.': '272', 'Raymond, W.': '273', 'Rayn': '274', 'Rayne': '275',
    'Rayno': '276', 'Rayo': '277', 'Raz': '278', 'Razou': '279', 'Re': '281',
    'Read': '282', 'Read, H.': '283', 'Read, M.': '284', 'Reade': '285', 'Reade, M.': '286',
    'Reading': '287', 'Real': '288', 'Reb': '289', 'Rebell': '291', 'Rebo': '292',
    'Rebs': '293', 'Rec': '294', 'Recco': '295', 'Rech': '296', 'Rechen': '297',
    'Reck': '298', 'Recl': '299', 'Reco': '311', 'Red': '312', 'Redd': '313',
    'Rede': '314', 'Redf': '315', 'Redg': '316', 'Redi': '317', 'Redm': '318',
    'Redo': '319', 'Redp': '321', 'Ree': '322', 'Reed': '323', 'Reed, G.': '324',
    'Reed, M.': '325', 'Reed, S.': '326', 'Reed, W.': '327', 'Rees': '328', 'Reese': '329',
    'Reev': '331', 'Reeves': '332', 'Reg': '333', 'Regg': '334', 'Regi': '335',
    'Regio': '336', 'Regis': '337', 'Regn': '338', 'Regnau': '339', 'Regne': '341',
    'Regni': '342', 'Rego': '343', 'Regu': '344', 'Reh': '345', 'Reht': '346',
    'Rei': '347', 'Reicha': '348', 'Reiche': '349', 'Reichen': '351', 'Reichm': '352',
    'Reid': '353', 'Reid, D.': '354', 'Reid, F.': '355', 'Reid, J.': '356', 'Reid, M.': '357',
    'Reid, S.': '358', 'Reid, W.': '359', 'Reif': '361', 'Reil': '362', 'Reim': '363',
    'Rein': '364', 'Reine': '365', 'Reinec': '366', 'Reiner': '367', 'Reinh': '368',
    'Reinhard': '369', 'Reinhart': '371', 'Reinho': '372', 'Reinm': '373', 'Reins': '374',
    'Reis': '375', 'Reiset': '376', 'Reisi': '377', 'Reiss': '378', 'Reit': '379',
    'Rej': '381', 'Rel': '382', 'Rell': '383', 'Rem': '384', 'Remb': '385',
    'Reme': '386', 'Remi': '387', 'Remin': '388', 'Remo': '389', 'Remu': '391',
    'Remy': '392', 'Ren': '393', 'Renar': '394', 'Renau': '395', 'Renaul': '396',
    'Rend': '397', 'Rendu': '398', 'Rene': '399', 'Renes': '411', 'Reng': '412',
    'Reni': '413', 'Renn': '414', 'Rennev': '415', 'Renni': '416', 'Renny': '417',
    'Reno': '418', 'Renou': '419', 'Rens': '421', 'Rent': '422', 'Renu': '423',
    'Renv': '424', 'Rep': '425', 'Rept': '426', 'Req': '427', 'Rer': '428',
    'Res': '429', 'Resch': '431', 'Rese': '432', 'Resen': '433', 'Resn': '434',
    'Ress': '435', 'Rest': '436', 'Ret': '437', 'Reth': '438', 'Rett': '439',
    'Retz': '441', 'Reu': '442', 'Reul': '443', 'Reum': '444', 'Reus': '445',
    'Reuss': '446', 'Reut': '447', 'Reuv': '448', 'Rev': '449', 'Revell': '451',
    'Rever': '452', 'Reves': '453', 'Revi': '454', 'Rex': '455', 'Rey': '456',
    'Reyes': '457', 'Reym': '458', 'Reyn': '459', 'Reyni': '461', 'Reyno': '462',
    'Reynolds, G.': '463', 'Reynolds, M.': '464', 'Reynolds, S.': '465', 'Reynolds, W.': '466', 'Rez': '467',
    'Rh': '468', 'Rhe': '469', 'Rhen': '471', 'Rhet': '472', 'Rhi': '473',
    'Rho': '474', 'Rhod': '475', 'Rhodes': '476', 'Rhodes, M.': '477', 'Rhodo': '478',
    'Rhou': '479', 'Ri': '481', 'Rib': '482', 'Ribb': '483', 'Ribe': '484',
    'Ribes': '485', 'Ribo': '486', 'Ric': '487', 'Ricardo': '488', 'Ricc': '489',
    'Ricci': '491', 'Ricciar': '492', 'Riccio': '493', 'Ricco': '494', 'Rice': '495',
    'Rice, G.': '496', 'Rice, M.': '497', 'Rich': '498', 'Rich, M.': '499', 'Richard': '511',
    'Richard, G.': '512', 'Richard, M': '513', 'Richards': '514', 'Richards, F.': '515', 'Richards, J.': '516',
    'Richards, M.': '517', 'Richards, S.': '518', 'Richards, W.': '519', 'Richardson': '521', 'Richardson, D.': '522',
    'Richardson, J.': '523', 'Richardson, M.': '524', 'Richardson, S.': '525', 'Richardson, W.': '526', 'Riche': '527',
    'Richel': '528', 'Richer': '529', 'Richi': '531', 'Richm': '532', 'Richmond, M.': '533',
    'Richt': '534', 'Richter': '535', 'Richter, M.': '536', 'Richter, S.': '537', 'Rici': '538',
    'Rick': '539', 'Rico': '541', 'Rid': '542', 'Riddel': '543', 'Ride': '544',
    'Ridl': '545', 'Ridley, M.': '546', 'Rido': '547', 'Rie': '548', 'Ried': '549',
    'Riedes': '551', 'Riedi': '552', 'Rief': '553', 'Rieg': '554', 'Rieh': '555',
    'Riem': '556', 'Rien': '557', 'Riep': '558', 'Ries': '559', 'Riese': '561',
    'Riesn': '562', 'Riet': '563', 'Rieu': '564', 'Rig': '565', 'Rigaul': '566',
    'Rigb': '567', 'Rige': '568', 'Rigg': '569', 'Righ': '571', 'Rign': '572',
    'Ril': '573', 'Rill': '574', 'Rim': '575', 'Rimi': '576', 'Rimm': '577',
    'Rin': '578', 'Rinc': '579', 'Ring': '581', 'Ringo': '582', 'Rint': '583',
    'Rinu': '584', 'Rio': '585', 'Rios': '586', 'Riou': '587', 'Rip': '588',
    'Ripley': '589', 'Ripley, H.': '591', 'Ripley, R.': '592', 'Ripp': '593', 'Riq': '594',
    'Ris': '595', 'Riss': '596', 'Rist': '597', 'Rit': '598', 'Ritchie, G.': '599',
    'Ritchie, M.': '611', 'Rits': '612', 'Ritt': '613', 'Ritter': '614', 'Ritter, M.': '615',
    'Riv': '616', 'Rivan': '617', 'Rivar': '618', 'Rivau': '619', 'Rive': '621',
    'Rivers': '622', 'Rives': '623', 'Rivet': '624', 'Rivi': '625', 'Rivo': '626',
    'Riz': '627', 'Ro': '628', 'Robar': '629', 'Robb': '631', 'Robbins': '632',
    'Robbins, F.': '633', 'Robbins, J.': '634', 'Robbins, M.': '635', 'Robbins, S.': '636', 'Robbins, W.': '637',
    'Robe': '638', 'Robert': '639', 'Robert, G.': '641', 'Robert, M.': '642', 'Roberts': '643',
    'Roberts, F.': '644', 'Roberts, J.': '645', 'Roberts, M.': '646', 'Roberts, S.': '647', 'Roberts, W.': '648',
    'Robertson': '649', 'Robertson, J.': '651', 'Robertson, S.': '652', 'Robes': '653', 'Robi': '654',
    'Robin': '655', 'Robine': '656', 'Robins': '657', 'Robinson': '658', 'Robinson, D.': '659',
    'Robinson, G.': '661', 'Robinson, J.': '662', 'Robinson, M.': '663', 'Robinson, S.': '664', 'Robinson, T.': '665',
    'Robinson, W.': '666', 'Robs': '667', 'Roby': '668', 'Roc': '669', 'Rocc': '671',
    'Roch': '672', 'Roche': '673', 'Rochef': '674', 'Rochem': '675', 'Roches': '676',
    'Rochet': '677', 'Rochf': '678', 'Rochm': '679', 'Rocho': '681', 'Rock': '682',
    'Rocki': '683', 'Rockw': '684', 'Rod': '685', 'Rodd': '686', 'Rode': '687',
    'Roder': '688', 'Rodew': '689', 'Rodg': '691', 'Rodi': '692', 'Rodm': '693',
    'Rodn': '694', 'Rodo': '695', 'Rodr': '696', 'Rodw': '697', 'Roe': '698',
    'Roe, M.': '699', 'Roeb': '711', 'Roed': '712', 'Roeh': '713', 'Roel': '714',
    'Roem': '715', 'Roep': '716', 'Roer': '717', 'Roes': '718', 'Roet': '719',
    'Rog': '721', 'Roger': '722', 'Roger, M.': '723', 'Rogers': '724', 'Rogers, D.': '725',
    'Rogers, G.': '726', 'Rogers, J.': '727', 'Rogers, M.': '728', 'Rogers, S.': '729', 'Rogers, W.': '731',
    'Roget': '732', 'Rogg': '733', 'Rogi': '734', 'Rogn': '735', 'Rogu': '736',
    'Roh': '737', 'Rohl': '738', 'Rohr': '739', 'Roi': '741', 'Rok': '742',
    'Roko': '743', 'Rol': '744', 'Role': '745', 'Rolf': '746', 'Rolfe, M.': '747',
    'Roli': '748', 'Roll': '749', 'Rolles': '751', 'Rollett': '752', 'Rolli': '753',
    'Rollin': '754', 'Rollo': '755', 'Rom': '756', 'Romai': '757', 'Roman': '758',
    'Romano': '759', 'Romanu': '761', 'Romb': '762', 'Rome': '763', 'Romey': '764',
    'Romi': '765', 'Romm': '766', 'Romu': '767', 'Ron': '768', 'Ronc': '769',
    'Rond': '771', 'Rone': '772', 'Rong': '773', 'Ronquillo': '733', 'Rons': '774', 'Ronz': '775',
    'Roo': '776', 'Rook': '777', 'Roop': '778', 'Roor': '779', 'Roos': '781',
    'Root': '782', 'Root, M.': '783', 'Rop': '784', 'Ropes': '785', 'Roq': '786',
    'Ror': '787', 'Ros': '788', 'Rosar': '789', 'Rosc': '791', 'Rosco': '792',
    'Roscoe, G.': '793', 'Roscoe, M.': '794', 'Rose': '795', 'Rose, G.': '796', 'Rose, M.': '797',
    'Roseb': '798', 'Rosec': '799', 'Rosel': '811', 'Rosem': '812', 'Rosen': '813',
    'Rosenk': '814', 'Rosenn': '815', 'Rosenw': '816', 'Roset': '817', 'Rosew': '818',
    'Rosi': '819', 'Rosin': '821', 'Rosn': '822', 'Ross': '823', 'Ross, G.': '824',
    'Ross, M.': '825', 'Ross, S.': '826', 'Ross, W.': '827', 'Rossel': '828', 'Rosset': '829',
    'Rossi': '831', 'Rossi, G.': '832', 'Rossi, M.': '833', 'Rossig': '834', 'Rossin': '835',
    'Rossl': '836', 'Rossm': '837', 'Rosso': '838', 'Rost': '839', 'Rosw': '841',
    'Rot': '842', 'Rote': '843', 'Rotg': '844', 'Roth': '845', 'Rothen': '846',
    'Roths': '847', 'Rothw': '848', 'Rotr': '849', 'Rott': '851', 'Rou': '852',
    'Roub': '853', 'Rouc': '854', 'Roug': '855', 'Rouget': '856', 'Roui': '857',
    'Rouj': '858', 'Roul': '859', 'Roup': '861', 'Rouq': '862', 'Rous': '863',
    'Rouss': '864', 'Roussel': '865', 'Roussele': '866', 'Rousset': '867', 'Roust': '868',
    'Rout': '869', 'Roux': '871', 'Rouy': '872', 'Rov': '873', 'Rovet': '874',
    'Rovi': '875', 'Row': '876', 'Rowan': '877', 'Rowe': '878', 'Rowe, M.': '879',
    'Rowel': '881', 'Rowi': '882', 'Rowl': '883', 'Rowle': '884', 'Rows': '885',
    'Rox': '886', 'Roxb': '887', 'Roy': '888', 'Roye': '889', 'Royer': '891',
    'Royo': '892', 'Roz': '893', 'Ru': '894', 'Ruben': '895', 'Rubi': '896',
    'Rubr': '897', 'Ruc': '898', 'Ruch': '899', 'Ruck': '911', 'Ruckers': '912',
    'Rud': '913', 'Rudd': '914', 'Rude': '915', 'Rudi': '916', 'Rudo': '917',
    'Rue': '918', 'Ruef': '919', 'Ruel': '921', 'Ruf': '922', 'Ruffi': '923',
    'Ruffn': '924', 'Ruffo': '925', 'Rufi': '926', 'Rufu': '927', 'Rug': '928',
    'Rugg': '929', 'Ruggi': '931', 'Ruggl': '932', 'Ruh': '933', 'Rui': '934',
    'Rul': '935', 'Rum': '936', 'Rumm': '937', 'Rums': '938', 'Run': '939',
    'Rund': '941', 'Rung': '942', 'Ruo': '944', 'Rup': '945', 'Rupp': '946',
    'Rupr': '947', 'Rur': '948', 'Rus': '949', 'Rusch': '951', 'Rush': '952',
    'Rush, M.': '953', 'Rusht': '954', 'Rushw': '955', 'Rusk': '956', 'Rusp': '957',
    'Russ': '958', 'Russel': '959', 'Russell': '961', 'Russell, D.': '962', 'Russell, F.': '963',
    'Russell, J.': '964', 'Russell, M.': '965', 'Russell, P.': '966', 'Russell, S.': '967', 'Russell, W.': '968',
    'Russi': '969', 'Rust': '971', 'Rut': '972', 'Rutg': '973', 'Ruth': '974',
    'Rutherf': '975', 'Ruthv': '976', 'Ruti': '977', 'Rutl': '978', 'Rutland, M.': '979',
    'Rutledge': '981', 'Rutt': '982', 'Ruv': '983', 'Rux': '984', 'Ruy': '985',
    'Ruyt': '986', 'Ruz': '987', 'Ry': '988', 'Ryan, M.': '989', 'Ryc': '991',
    'Ryd': '992', 'Rye': '993', 'Ryl': '994', 'Rym': '995', 'Rys': '996',
    'Ryt': '997', 'Ryv': '998'
  },
  'S': {
    'Sa': '111', 'Saar': '112', 'Sab': '113', 'Sabb': '114', 'Sabe': '115',
    'Sabi': '116', 'Sabl': '117', 'Sabr': '118', 'Sac': '119', 'Sach': '121',
    'Saco': '122', 'Sacr': '123', 'Sad': '124', 'Sade': '125', 'Sadl': '126',
    'Sae': '127', 'Saf': '128', 'Sag': '129', 'Sah': '131', 'Sai': '132',
    'Saint A': '133', 'Saint An': '134', 'Saint B': '135', 'Saint C': '136', 'Saint E': '137',
    'Saint F': '138', 'Saint G': '139', 'Saint H': '141', 'Saint I': '142', 'Saint J': '143',
    'Saint Ju': '144', 'Saint L': '145', 'Saint M': '146', 'Saint N': '147', 'Saint O': '148',
    'Saint P': '149', 'Saint R': '151', 'Saint S': '152', 'Saint Simon': '153', 'Saint U': '154',
    'Saint V': '155', 'Sainte': '156', 'Sainte M': '157', 'Sais': '158', 'Sal': '159',
    'Salan': '161', 'Sald': '162', 'Sale': '163', 'Salg': '164', 'Sali': '165',
    'Salis': '166', 'Salisbury': '167', 'Sall': '168', 'Sallo': '169', 'Salm': '171',
    'Salmon': '172', 'Salo': '173', 'Salomon': '174', 'Salon': '175', 'Salt': '176',
    'Salter': '177', 'Saltm': '178', 'Salto': '179', 'Salu': '181', 'Salv': '182',
    'Salve': '183', 'Salvi': '184', 'Salvin': '185', 'Salvo': '186', 'Sam': '187',
    'Samh': '188', 'Samm': '189', 'Samo': '191', 'Samp': '192', 'Sams': '193',
    'San': '194', 'San F': '195', 'San L': '196', 'San S': '197', 'Sanb': '198',
    'Sanc': '199', 'Sanch': '211', 'Sancr': '212', 'Sand': '213', 'Sande': '214',
    'Sanders': '215', 'Sanderson': '216', 'Sandf': '217', 'Sando': '218', 'Sandr': '219',
    'Sands': '221', 'Sandy': '222', 'Sane': '223', 'Sanf': '224', 'Sang': '225',
    'Sangr': '226', 'Sani': '227', 'Sann': '228', 'Sans': '229', 'Sant': '231',
    'Santag': '232', 'Santar': '233', 'Sante': '234', 'Santi': '235', 'Santis': '236',
    'Santo': '237', 'Sanu': '238', 'Sao': '239', 'Sap': '241', 'Saq': '242',
    'Sar': '243', 'Sard': '244', 'Sarg': '245', 'Sarm': '246', 'Sarr': '247',
    'Sars': '248', 'Sart': '249', 'Sarto': '251', 'Sas': '252', 'Sat': '253',
    'Satu': '254', 'Sau': '255', 'Saul': '256', 'Saun': '257', 'Saup': '258',
    'Saur': '259', 'Saut': '261', 'Sauv': '262', 'Sav': '263', 'Savage, J.': '264',
    'Savar': '265', 'Savas': '266', 'Savi': '267', 'Savo': '268', 'Savot': '269',
    'Saw': '271', 'Sax': '272', 'Saxo': '273', 'Say': '274', 'Sayl': '275',
    'Sba': '276', 'Sca': '277', 'Scae': '278', 'Scal': '279', 'Scalab': '281',
    'Scali': '282', 'Scam': '283', 'Scap': '284', 'Scar': '285', 'Scarl': '286',
    'Scars': '287', 'Scav': '288', 'Sce': '289', 'Sch': '291', 'Schad': '292',
    'Schae': '293', 'Schaef': '294', 'Schaer': '295', 'Schaf': '296', 'Schal': '297',
    'Schall': '298', 'Scham': '299', 'Schar': '311', 'Schat': '312', 'Schau': '313',
    'Sche': '314', 'Sched': '315', 'Schef': '316', 'Scheffer, J.': '317', 'Schei': '318',
    'Scheif': '319', 'Scheit': '321', 'Schel': '322', 'Schem': '323', 'Schen': '324',
    'Schep': '325', 'Scher': '326', 'Schet': '327', 'Scheu': '328', 'Schi': '329',
    'Schick': '331', 'Schie': '332', 'Schif': '333', 'Schil': '334', 'Schim': '335',
    'Schin': '336', 'Schir': '337', 'Schl': '338', 'Schle': '339', 'Schlei': '341',
    'Schles': '342', 'Schleu': '343', 'Schli': '344', 'Schlo': '345', 'Schlu': '346',
    'Schm': '347', 'Schmi': '348', 'Schmidt': '349', 'Schmidt, F.': '351', 'Schmidt, J.': '352',
    'Schmidt, L.': '353', 'Schmidt, S.': '354', 'Schmit': '355', 'Schmo': '356', 'Schn': '357',
    'Schne': '358', 'Schneider, J.': '359', 'Schni': '361', 'Schno': '362', 'Scho': '363',
    'Schoe': '364', 'Schoen': '365', 'Schoenl': '366', 'Schoep': '367', 'Schol': '368',
    'Schom': '369', 'Schon': '371', 'Schoo': '372', 'Schop': '373', 'Schor': '374',
    'Schot': '375', 'Schou': '376', 'Schra': '377', 'Schrei': '378', 'Schrey': '379',
    'Schro': '381', 'Schroet': '382', 'Schu': '383', 'Schube': '384', 'Schue': '385',
    'Schul': '386', 'Schultz': '387', 'Schulz': '388', 'Schulz, J.': '389', 'Schulze': '391',
    'Schum': '392', 'Schun': '393', 'Schur': '394', 'Schus': '395', 'Schut': '396',
    'Schuy': '397', 'Schw': '398', 'Schwar': '399', 'Schwarz': '411', 'Schwe': '412',
    'Schwei': '413', 'Schwem': '414', 'Schwer': '415', 'Sci': '416', 'Scin': '417',
    'Scip': '418', 'Scir': '419', 'Sco': '421', 'Scog': '422', 'Scor': '423',
    'Scot': '424', 'Scott': '425', 'Scott, G.': '426', 'Scott, J.': '427', 'Scott, M.': '428',
    'Scott, S.': '429', 'Scott, W.': '431', 'Scou': '432', 'Scr': '433', 'Scri': '434',
    'Scro': '435', 'Scu': '436', 'Scul': '437', 'Sea': '438', 'Sear': '439',
    'Seat': '441', 'Seav': '442', 'Seb': '443', 'Sec': '444', 'Seco': '445',
    'Secr': '446', 'Sed': '447', 'Sedg': '448', 'Sedl': '449', 'See': '451',
    'Seel': '452', 'Seem': '453', 'Seg': '454', 'Segr': '455', 'Segu': '456',
    'Sei': '457', 'Seid': '458', 'Seif': '459', 'Seil': '461', 'Seis': '462',
    'Sej': '463', 'Sel': '464', 'Self': '465', 'Selk': '466', 'Sell': '467',
    'Sello': '468', 'Selv': '469', 'Sem': '471', 'Seml': '472', 'Semp': '473',
    'Sen': '474', 'Sene': '475', 'Senf': '476', 'Seni': '477', 'Senn': '478',
    'Sep': '479', 'Ser': '481', 'Seras': '482', 'Sere': '483', 'Serg': '484',
    'Seri': '485', 'Serm': '486', 'Serr': '487', 'Serre': '488', 'Serro': '489',
    'Serv': '491', 'Servin': '492', 'Ses': '493', 'Sest': '494', 'Set': '495',
    'Seu': '496', 'Sev': '497', 'Sever': '498', 'Severus': '499', 'Sevi': '511',
    'Sew': '512', 'Sewall, S.': '513', 'Seward': '514', 'Sewel': '515', 'Sewell': '516',
    'Sewell, S.': '517', 'Sex': '518', 'Sey': '519', 'Seym': '521', 'Seyt': '522',
    'Sfo': '523', 'Sha': '524', 'Shaf': '525', 'Shai': '526', 'Shak': '527',
    'Shal': '528', 'Shap': '529', 'Shar': '531', 'Sharpe': '532', 'Shat': '533',
    'Shaw': '534', 'Shaw, L.': '535', 'Shaw, S.': '536', 'Shaw, W.': '537', 'Shay': '538',
    'She': '539', 'Shed': '541', 'Shef': '542', 'Shei': '543', 'Shel': '544',
    'Shelley': '545', 'Shen': '546', 'Shep': '547', 'Sheph': '548', 'Shepp': '549',
    'Sher': '551', 'Sheri': '552', 'Sherm': '553', 'Sherw': '554', 'Shi': '555',
    'Shil': '556', 'Ship': '557', 'Shir': '558', 'Sho': '559', 'Shr': '561',
    'Shu': '562', 'Sib': '563', 'Sibl': '564', 'Sic': '565', 'Sici': '566',
    'Sico': '567', 'Sid': '568', 'Sidn': '569', 'Sie': '571', 'Sien': '572',
    'Sies': '573', 'Sig': '574', 'Sigf': '575', 'Sigi': '576', 'Sigis': '577',
    'Sign': '578', 'Sigu': '579', 'Sil': '581', 'Silb': '582', 'Sili': '583',
    'Sill': '584', 'Silo': '585', 'Silv': '586', 'Silve': '587', 'Sim': '588',
    'Sime': '589', 'Siml': '591', 'Simm': '592', 'Simo': '593', 'Simon': '594',
    'Simon, J.': '595', 'Simon, P.': '596', 'Simond': '597', 'Simone': '598', 'Simoni': '599',
    'Simons': '611', 'Simp': '612', 'Simps': '613', 'Sims': '614', 'Sin': '615',
    'Sincl': '616', 'Sing': '617', 'Sins': '618', 'Sir': '619', 'Sirm': '621',
    'Sis': '622', 'Sism': '623', 'Siv': '624', 'Six': '625', 'Ska': '626',
    'Ske': '627', 'Ski': '628', 'Skr': '629', 'Sla': '631', 'Sle': '632',
    'Sli': '633', 'Slo': '634', 'Sma': '635', 'Smar': '636', 'Sme': '637',
    'Smel': '638', 'Smi': '639', 'Smil': '641', 'Smit': '642', 'Smith, B.': '643',
    'Smith, C.': '644', 'Smith, D.': '645', 'Smith, E.': '646', 'Smith, F.': '647', 'Smith, G.': '648',
    'Smith, H.': '649', 'Smith, J.': '651', 'Smith, John': '652', 'Smith, Jos.': '653', 'Smith, L.': '654',
    'Smith, M.': '655', 'Smith, O.': '656', 'Smith, R.': '657', 'Smith, Robert': '658', 'Smith, S.': '659',
    'Smith, Sol': '661', 'Smith, T.': '662', 'Smith, W.': '663', 'Smith, Wm.': '664', 'Smits': '665',
    'Smo': '666', 'Smy': '667', 'Smythe': '668', 'Sna': '669', 'Sne': '671',
    'Sni': '672', 'Sno': '673', 'Snow': '674', 'Sny': '675', 'Soa': '676',
    'Sob': '677', 'Soc': '678', 'Sod': '679', 'Soe': '681', 'Sog': '682',
    'Soi': '683', 'Sol': '684', 'Sole': '685', 'Soli': '686', 'Solis': '687',
    'Soll': '688', 'Solo': '689', 'Solt': '691', 'Soly': '692', 'Som': '693',
    'Somer': '694', 'Somers': '695', 'Somerv': '696', 'Somm': '697', 'Son': '698',
    'Sonn': '699', 'Soo': '711', 'Sop': '712', 'Sor': '713', 'Sori': '714',
    'Sos': '715', 'Sost': '716', 'Sot': '717', 'Soto': '718', 'Sou': '719',
    'Souf': '721', 'Soul': '722', 'Souli': '723', 'Soum': '724', 'Sous': '725',
    'Sout': '726', 'Southe': '727', 'Southw': '728', 'Souv': '729', 'Sow': '731',
    'Spa': '732', 'Spaf': '733', 'Spal': '734', 'Span': '735', 'Spar': '736',
    'Sparr': '737', 'Spat': '738', 'Spau': '739', 'Spe': '741', 'Spee': '742',
    'Spel': '743', 'Spen': '744', 'Spencer': '745', 'Spencer, S.': '746', 'Spene': '747',
    'Spens': '748', 'Sper': '749', 'Sperr': '751', 'Spet': '752', 'Sph': '753',
    'Spi': '754', 'Spie': '755', 'Spil': '756', 'Spin': '757', 'Spino': '758',
    'Spir': '759', 'Spit': '761', 'Spo': '762', 'Spon': '763', 'Spoo': '764',
    'Spot': '765', 'Spr': '766', 'Spran': '767', 'Spre': '768', 'Spri': '769',
    'Spro': '771', 'Spu': '772', 'Squ': '773', 'Squir': '774', 'Sta': '775',
    'Stad': '776', 'Stadl': '777', 'Stae': '778', 'Staf': '779', 'Stah': '781',
    'Stai': '782', 'Stam': '783', 'Stan': '784', 'Stand': '785', 'Stanh': '786',
    'Stanl': '787', 'Stanley, J.': '788', 'Stanley, S.': '789', 'Stans': '791', 'Stant': '792',
    'Stap': '793', 'Stapl': '794', 'Star': '795', 'Starr': '796', 'Stat': '797',
    'Stau': '798', 'Ste': '799', 'Steb': '811', 'Sted': '812', 'Stee': '813',
    'Steele': '814', 'Steev': '815', 'Stef': '816', 'Steffe': '817', 'Stei': '818',
    'Stein': '819', 'Steind': '821', 'Steine': '822', 'Steinm': '823', 'Stel': '824',
    'Sten': '825', 'Steno': '826', 'Step': '827', 'Stephen': '828', 'Stephen, M.': '829',
    'Stephen, S.': '831', 'Stephens': '832', 'Stephens, G.': '833', 'Stephens, L.': '834', 'Stephens, R.': '835',
    'Stephenson': '836', 'Stephenson, R.': '837', 'Ster': '838', 'Stern': '839', 'Stet': '841',
    'Steu': '842', 'Stev': '843', 'Stevens': '844', 'Stevens, M.': '845', 'Stevens, S.': '846',
    'Stevenson': '847', 'Stevenson, M.': '848', 'Stew': '849', 'Stewart, M.': '851', 'Stewart, T.': '852',
    'Stey': '853', 'Sti': '854', 'Stie': '855', 'Stil': '856', 'Still': '857',
    'Stim': '858', 'Stimp': '859', 'Stir': '861', 'Stit': '862', 'Sto': '863',
    'Stoc': '864', 'Stockl': '865', 'Stockt': '866', 'Stod': '867', 'Stoddard, M.': '868',
    'Stoddard, S.': '869', 'Stoe': '871', 'Stoel': '872', 'Stof': '873', 'Stok': '874',
    'Stol': '875', 'Stolt': '876', 'Ston': '877', 'Stone, J.': '878', 'Stone, M.': '879',
    'Stone, T.': '881', 'Stoo': '882', 'Stop': '883', 'Stor': '884', 'Stork': '885',
    'Storr': '886', 'Story': '887', 'Story, S.': '888', 'Stou': '889', 'Stow': '891',
    'Stowe': '892', 'Stowell': '893', 'Stra': '894', 'Strad': '895', 'Straf': '896',
    'Stran': '897', 'Strat': '898', 'Strath': '899', 'Stratt': '911', 'Strau': '912',
    'Straw': '913', 'Stre': '914', 'Street': '915', 'Stri': '916', 'Strickl': '917',
    'Strin': '918', 'Stro': '919', 'Strog': '921', 'Stron': '922', 'Strong': '923',
    'Strong, P.': '924', 'Strot': '925', 'Stroz': '926', 'Stru': '927', 'Stry': '928',
    'Stu': '929', 'Stuart, J.': '931', 'Stuart, M.': '932', 'Stud': '933', 'Stuk': '934',
    'Stur': '935', 'Sturm': '936', 'Stut': '937', 'Stuy': '938', 'Sua': '939',
    'Sub': '941', 'Suc': '942', 'Sud': '943', 'Sue': '944', 'Suev': '945',
    'Suf': '946', 'Sug': '947', 'Sui': '948', 'Sul': '949', 'Sullivan, M.': '951',
    'Sullivan, S.': '952', 'Sully': '953', 'Sulp': '954', 'Sum': '955', 'Sumn': '956',
    'Sun': '957', 'Sunderl': '958', 'Sup': '959', 'Sur': '961', 'Surr': '962',
    'Surv': '963', 'Sus': '964', 'Sut': '965', 'Suth': '966', 'Sutt': '967',
    'Suz': '968', 'Svi': '969', 'Swa': '971', 'Swan': '972', 'Swar': '973',
    'Swe': '974', 'Swet': '975', 'Swi': '976', 'Swift': '977', 'Swin': '978',
    'Swint': '979', 'Sya': '981', 'Syd': '982', 'Syk': '983', 'Syl': '984',
    'Sylv': '985', 'Sym': '986', 'Symm': '987', 'Symo': '988', 'Symp': '989',
    'Syms': '991', 'Syn': '992', 'Syng': '993', 'Syp': '994', 'Syr': '995',
    'Sza': '996', 'Sze': '997', 'Szi': '998', 'Szy': '999'
  },
  'T': {
    'Ta': '111', 'Tab': '112', 'Tabe': '113', 'Tabo': '114', 'Tac': '115',
    'Tacf': '116', 'Tach': '117', 'Taci': '118', 'Taco': '119', 'Tad': '121',
    'Tado': '122', 'Tae': '123', 'Taf': '124', 'Tag': '125', 'Tagl': '126',
    'Taglias': '127', 'Taglio': '128', 'Tai': '129', 'Tail': '131', 'Taille': '132',
    'Tailli': '133', 'Tain': '134', 'Tais': '135', 'Tak': '136', 'Tal': '137',
    'Talbot': '138', 'Talbot, G.': '139', 'Talbot, M.': '141', 'Talbot, S.': '142', 'Tale': '143',
    'Talf': '144', 'Talh': '145', 'Tali': '146', 'Tall': '147', 'Talley': '148',
    'Talli': '149', 'Talm': '151', 'Talo': '152', 'Tam': '153', 'Tamb': '154',
    'Tambe': '155', 'Tambou': '156', 'Tame': '157', 'Tami': '158', 'Tamp': '159',
    'Tan': '161', 'Tanc': '162', 'Tand': '163', 'Tane': '164', 'Tank': '165',
    'Tann': '166', 'Tanner, M.': '167', 'Tans': '168', 'Tant': '169', 'Tanz': '171',
    'Tap': '172', 'Tapl': '173', 'Tapp': '174', 'Tappan, M.': '175', 'Tar': '176',
    'Taras': '177', 'Tarau': '178', 'Tarb': '179', 'Tard': '181', 'Tardieu': '182',
    'Tardif': '183', 'Tare': '184', 'Targ': '185', 'Tari': '186', 'Tarin': '187',
    'Tarl': '188', 'Tarn': '189', 'Taro': '191', 'Tarr': '192', 'Tars': '193',
    'Tartar': '194', 'Tarti': '195', 'Taru': '196', 'Tas': '197', 'Task': '198',
    'Tasm': '199', 'Tass': '211', 'Tasse': '212', 'Tassi': '213', 'Tasso': '214',
    'Tasson': '215', 'Tat': '216', 'Tate, M.': '217', 'Tath': '218', 'Tati': '219',
    'Tatt': '221', 'Tau': '222', 'Taubn': '223', 'Tauc': '224', 'Taul': '225',
    'Taun': '226', 'Taup': '227', 'Taus': '228', 'Taut': '229', 'Tav': '231',
    'Tave': '232', 'Taver': '233', 'Taverni': '234', 'Tax': '235', 'Tay': '236',
    'Tayler': '237', 'Taylor': '238', 'Taylor, C.': '239', 'Taylor, F.': '241', 'Taylor, H.': '242',
    'Taylor, J.': '243', 'Taylor, M.': '244', 'Taylor, P.': '245', 'Taylor, S.': '246', 'Taylor, W.': '247',
    'Taz': '248', 'Tc': '249', 'Tche': '251', 'Tcho': '252', 'Te': '253',
    'Teb': '254', 'Tec': '255', 'Ted': '256', 'Tedm': '257', 'Tee': '258',
    'Tef': '259', 'Teg': '261', 'Tei': '262', 'Teif': '263', 'Teil': '264',
    'Teis': '265', 'Teix': '266', 'Tel': '267', 'Telem': '268', 'Teles': '269',
    'Telf': '271', 'Teli': '272', 'Tell': '273', 'Teller': '274', 'Tellez': '275',
    'Telli': '276', 'Tello': '277', 'Tem': '278', 'Teme': '279', 'Temm': '281',
    'Temp': '282', 'Tempest, M.': '283', 'Templ': '284', 'Temple, G.': '285', 'Temple, M.': '286',
    'Temple, S.': '287', 'Templet': '288', 'Ten': '289', 'Tend': '291', 'Tene': '292',
    'Teni': '293', 'Tenis': '294', 'Tenn': '295', 'Tennant, M.': '296', 'Tenne': '297',
    'Tenney': '298', 'Tenney, M.': '299', 'Tenni': '311', 'Tenny': '312', 'Tent': '313',
    'Teo': '314', 'Ter': '315', 'Tere': '316', 'Terg': '317', 'Terh': '318',
    'Term': '319', 'Tern': '321', 'Terp': '322', 'Terr': '323', 'Terras': '324',
    'Terre': '325', 'Terri': '326', 'Terrin': '327', 'Terro': '328', 'Terry': '329',
    'Ters': '331', 'Tert': '332', 'Terw': '333', 'Terz': '334', 'Tes': '335',
    'Tesau': '336', 'Tesc': '337', 'Tess': '338', 'Tessi': '339', 'Tessin': '341',
    'Test': '342', 'Teste': '343', 'Testi': '344', 'Testo': '345', 'Testu': '346',
    'Tet': '347', 'Tetr': '348', 'Tetz': '349', 'Teu': '351', 'Teut': '352',
    'Tev': '353', 'Tew': '354', 'Tex': '355', 'Tey': '356', 'Th': '357',
    'Thac': '358', 'Thacher, G.': '359', 'Thacher, M.': '361', 'Thacher, S.': '362', 'Thack': '363',
    'Thai': '364', 'Thal': '365', 'Tham': '366', 'Than': '367', 'Thau': '368',
    'Thay': '369', 'Thayer, G.': '371', 'Thayer, M.': '372', 'Thayer, S.': '373', 'The': '374',
    'Theb': '375', 'Thei': '376', 'Theim': '377', 'Thek': '378', 'Thel': '379',
    'Thelo': '381', 'Thelw': '382', 'Them': '383', 'Then': '384', 'Theo': '385',
    'Theoc': '386', 'Theod': '387', 'Theodo': '388', 'Theodos': '389', 'Theog': '391',
    'Theon': '392', 'Theop': '393', 'Theophi': '394', 'Theopo': '395', 'Theor': '396',
    'Theos': '397', 'Ther': '398', 'Theri': '399', 'Therm': '411', 'Thero': '412',
    'Thes': '413', 'Thess': '414', 'Theu': '415', 'Thev': '416', 'Theveni': '417',
    'Theveno': '418', 'Thew': '419', 'Thex': '421', 'Thi': '422', 'Thiard': '423',
    'Thib': '424', 'Thibaul': '425', 'Thibaut': '426', 'Thibo': '427', 'Thic': '428',
    'Thie': '429', 'Thiel': '431', 'Thielm': '432', 'Thiem': '433', 'Thien': '434',
    'Thier': '435', 'Thierry': '436', 'Thierry, M.': '437', 'Thiers': '438', 'Thies': '439',
    'Thil': '441', 'Thilo': '442', 'Thim': '443', 'Thio': '444', 'Thir': '445',
    'Thirl': '446', 'Thiro': '447', 'This': '448', 'Tho': '449', 'Thol': '451',
    'Thom': '452', 'Thoman': '453', 'Thomas': '454', 'Thomas, C.': '455', 'Thomas, F.': '456',
    'Thomas, H.': '457', 'Thomas, J.': '458', 'Thomas, M.': '459', 'Thomas, P.': '461', 'Thomas, S.': '462',
    'Thomas, W.': '463', 'Thomass': '464', 'Thomassy': '465', 'Thomo': '466', 'Thomp': '467',
    'Thompson': '468', 'Thompson, C.': '469', 'Thompson, F.': '471', 'Thompson, H.': '472', 'Thompson, J.': '473',
    'Thompson, M.': '474', 'Thompson, P.': '475', 'Thompson, S.': '476', 'Thompson, T.': '477', 'Thompson, W.': '478',
    'Thoms': '479', 'Thomsen': '481', 'Thomson': '482', 'Thomson, G.': '483', 'Thomson, M.': '484',
    'Thomson, S.': '485', 'Thomson, W.': '486', 'Thor': '487', 'Thore': '488', 'Thores': '489',
    'Thori': '491', 'Thoris': '492', 'Thork': '493', 'Thorl': '494', 'Thorm': '495',
    'Thorn': '496', 'Thornb': '497', 'Thornd': '498', 'Thorndi': '499', 'Thorne': '511',
    'Thorney': '512', 'Thornt': '513', 'Thornton, M.': '514', 'Thornw': '515', 'Thoro': '516',
    'Thorp': '517', 'Thorpe': '518', 'Thorpe, G.': '519', 'Thorpe, M.': '521', 'Thorpe, S.': '522',
    'Thort': '523', 'Thou': '524', 'Thoui': '525', 'Thour': '526', 'Thout': '527',
    'Thouv': '528', 'Thr': '529', 'Thre': '531', 'Thu': '532', 'Thui': '533',
    'Thul': '534', 'Thun': '535', 'Thur': '536', 'Thurl': '537', 'Thurlo': '538',
    'Thurm': '539', 'Thurn': '541', 'Thuro': '542', 'Thurs': '543', 'Thurston': '544',
    'Thurston, G.': '545', 'Thurston, M.': '546', 'Thurston, S.': '547', 'Thw': '548',
    'Thy': '549', 'Ti': '551', 'Tib': '552', 'Tibe': '553', 'Tibn': '554',
    'Tic': '555', 'Tick': '556', 'Ticknor': '557', 'Tid': '558', 'Tie': '559',
    'Tief': '561', 'Tiel': '562', 'Tiep': '563', 'Tier': '564', 'Tif': '565',
    'Tig': '566', 'Tigl': '567', 'Tigr': '568', 'Til': '569', 'Tild': '571',
    'Tile': '572', 'Tili': '573', 'Till': '574', 'Tille': '575', 'Tillet': '576',
    'Tilli': '577', 'Tillo': '578', 'Tilly': '579', 'Tils': '581', 'Tim': '582',
    'Timb': '583', 'Timm': '584', 'Timo': '585', 'Timp': '586', 'Tin': '587',
    'Tind': '588', 'Tink': '589', 'Tinn': '591', 'Tins': '592', 'Tint': '593',
    'Tio': '594', 'Tip': '595', 'Tir': '596', 'Tiri': '597', 'Tis': '598',
    'Tisch': '599', 'Tische': '611', 'Tischl': '612', 'Tisd': '613', 'Tiss': '614',
    'Tissi': '615', 'Tisso': '616', 'Tit': '617', 'Titi': '618', 'Titin': '619',
    'Tito': '621', 'Titt': '622', 'Titu': '623', 'Tix': '624', 'Tiz': '625',
    'Tk': '626', 'To': '627', 'Tob': '628', 'Tobi': '629', 'Toc': '631',
    'Tocq': '632', 'Tod': '633', 'Todd, G.': '634', 'Todd, M.': '635', 'Todd, S.': '636',
    'Tode': '637', 'Todh': '638', 'Todl': '639', 'Toe': '641', 'Toep': '642',
    'Toes': '643', 'Tof': '644', 'Tog': '645', 'Toi': '646', 'Tol': '647',
    'Tolb': '648', 'Tole': '649', 'Toll': '651', 'Tolm': '652', 'Tolo': '653',
    'Tols': '654', 'Tom': '655', 'Tomb': '656', 'Tomi': '657', 'Tomk': '658',
    'Toml': '659', 'Tomm': '661', 'Tomp': '662', 'Ton': '663', 'Tone': '664',
    'Tong': '665', 'Tonn': '666', 'Tont': '667', 'Too': '668', 'Tooke, M.': '669',
    'Tool': '671', 'Toom': '672', 'Top': '673', 'Toph': '674', 'Topl': '675',
    'Tor': '676', 'Tord': '677', 'Tore': '678', 'Toren': '679', 'Tores': '681',
    'Torg': '682', 'Tori': '683', 'Torl': '684', 'Torn': '685', 'Torno': '686',
    'Torq': '687', 'Torr': '688', 'Torre': '689', 'Torren': '691', 'Torrent': '692',
    'Torres': '693', 'Torrey': '694', 'Torri': '695', 'Torrig': '696', 'Torrin': '697',
    'Tors': '698', 'Tort': '699', 'Torti': '711', 'Torto': '712', 'Tos': '713',
    'Tose': '714', 'Toss': '715', 'Tost': '716', 'Tot': '717', 'Tott': '718',
    'Totten': '719', 'Tottl': '721', 'Tou': '722', 'Toul': '723', 'Toulm': '724',
    'Toulo': '725', 'Toup': '726', 'Tour': '727', 'Tourn': '728', 'Tourno': '729',
    'Touro': '731', 'Tourr': '732', 'Tourv': '733', 'Tous': '734', 'Tousse': '735',
    'Tout': '736', 'Tow': '737', 'Tower, M.': '738', 'Towers': '739', 'Towg': '741',
    'Towl': '742', 'Town': '743', 'Towne': '744', 'Townel': '745', 'Townl': '746',
    'Towns': '747', 'Townsend, G.': '748', 'Townsend, M.': '749', 'Townsend, S.': '751', 'Townsend, W.': '752',
    'Townsh': '753', 'Townshend, M.': '754', 'Townso': '755', 'Toy': '756', 'Toz': '757',
    'Tr': '758', 'Trac': '759', 'Tracy': '761', 'Tracy, M.': '762', 'Trad': '763',
    'Trae': '764', 'Trag': '765', 'Trai': '766', 'Traill, M.': '767', 'Train': '768',
    'Tral': '769', 'Tram': '771', 'Tran': '772', 'Trap': '773', 'Trapp': '774',
    'Tras': '775', 'Trat': '776', 'Trau': '777', 'Trauts': '778', 'Trav': '779',
    'Travers, M.': '781', 'Travi': '782', 'Trax': '783', 'Tre': '784', 'Trebo': '785',
    'Tred': '786', 'Trei': '787', 'Trel': '788', 'Trem': '789', 'Tremo': '791',
    'Tren': '792', 'Trench, M.': '793', 'Trenck': '794', 'Trent': '795', 'Tres': '796',
    'Tresh': '797', 'Tresi': '798', 'Tress': '799', 'Treu': '811', 'Trev': '812',
    'Trevi': '813', 'Trevis': '814', 'Trevo': '815', 'Trevor, M.': '816', 'Trew': '817',
    'Trez': '818', 'Tri': '819', 'Trian': '821', 'Trib': '822', 'Tric': '823',
    'Trico': '824', 'Trie': '825', 'Trier': '826', 'Tries': '827', 'Trig': '828',
    'Tril': '829', 'Trim': '831', 'Trin': '832', 'Trinci': '833', 'Trio': '834',
    'Trip': '835', 'Tripp': '836', 'Tris': '837', 'Trist': '838', 'Trit': '839',
    'Triv': '841', 'Trivu': '842', 'Tro': '843', 'Trog': '844', 'Troi': '845',
    'Trol': '846', 'Trollo': '847', 'Trollope, M.': '848', 'Trom': '849', 'Tromp': '851',
    'Tron': '852', 'Tronci': '853', 'Trons': '854', 'Troo': '855', 'Trop': '856',
    'Tros': '857', 'Trot': '858', 'Trou': '859', 'Troui': '861', 'Trouv': '862',
    'Trow': '863', 'Troy': '864', 'Tru': '865', 'Trud': '866', 'Trum': '867',
    'Trumbull': '868', 'Trumbull, J.': '869', 'Trumbull, S.': '871', 'Trur': '872', 'Trus': '873',
    'Trut': '874', 'Try': '875', 'Tryp': '876', 'Ts': '877', 'Tscher': '878',
    'Tschi': '879', 'Tschu': '881', 'Tse': '882', 'Tu': '883', 'Tub': '884',
    'Tuber': '885', 'Tuc': '886', 'Tuch': '887', 'Tucher': '888', 'Tuck': '889',
    'Tucker': '891', 'Tucker, G.': '892', 'Tucker, M.': '893', 'Tucker, S.': '894', 'Tucker, W.': '895',
    'Tuckerman': '896', 'Tuckerman, M.': '897', 'Tucket': '898', 'Tud': '899', 'Tudi': '911',
    'Tudo': '912', 'Tue': '913', 'Tuf': '914', 'Tufts, M.': '915', 'Tuk': '916',
    'Tul': '917', 'Tull': '918', 'Tulloch': '919', 'Tulloch, M.': '921', 'Tullus': '922',
    'Tully': '923', 'Tulo': '924', 'Tum': '925', 'Tun': '926', 'Tuns': '927',
    'Tup': '928', 'Tur': '929', 'Turb': '931', 'Turc': '932', 'Turco': '933',
    'Ture': '934', 'Turen': '935', 'Turg': '936', 'Turgo': '937', 'Turi': '938',
    'Turk': '939', 'Turl': '941', 'Turn': '942', 'Turnbull, M.': '943', 'Turne': '944',
    'Turner, C.': '945', 'Turner, F.': '946', 'Turner, H.': '947', 'Turner, J.': '948', 'Turner, M.': '949',
    'Turner, P.': '951', 'Turner, S.': '952', 'Turner, T.': '953', 'Turner, W.': '954', 'Turnh': '955',
    'Turno': '956', 'Turp': '957', 'Turr': '958', 'Turrett': '959', 'Turri': '961',
    'Turt': '962', 'Turv': '963', 'Tus': '964', 'Tuss': '965', 'Tut': '966',
    'Tutt': '967', 'Tuy': '968', 'Tw': '969', 'Twee': '971', 'Twi': '972',
    'Twin': '973', 'Twis': '974', 'Twy': '975', 'Twys': '976', 'Ty': '977',
    'Tyc': '978', 'Tye': '979', 'Tyl': '981', 'Tyler, G.': '982', 'Tyler, M.': '983',
    'Tyler, S.': '984', 'Tyler, W.': '985', 'Tym': '986', 'Tyn': '987', 'Tyndall': '988',
    'Tyng': '989', 'Typ': '991', 'Tyr': '992', 'Tyrrell': '993', 'Tys': '994',
    'Tyt': '995', 'Tytler': '996', 'Tytler, S.': '997', 'Tz': '998', 'Tzs': '999'
  },
  'U': {
    'Ua': '11', 'Ub': '12', 'Ube': '13', 'Uber': '14', 'Ubi': '15',
    'Uc': '16', 'Uch': '17', 'Ud': '18', 'Ude': '19', 'Udi': '21',
    'Ue': '22', 'Uf': '23', 'Uffi': '24', 'Uffo': '25', 'Ug': '26',
    'Ugo': '27', 'Uh': '28', 'Uhd': '29', 'Uhl': '31', 'Uht': '32',
    'Ui': '33', 'Uk': '34', 'Ukr': '35', 'Ul': '36', 'Ule': '37',
    'Ulf': '38', 'Uli': '39', 'Ull': '41', 'Ulle': '42', 'Ulm': '43',
    'Ulp': '44', 'Ulr': '45', 'Uls': '46', 'Ult': '47', 'Um': '48',
    'Umbr': '49', 'Umf': '51', 'Uml': '52', 'Ums': '53', 'Un': '54',
    'Unde': '55', 'Underw': '56', 'Ung': '57', 'Uni': '58', 'Uns': '59',
    'Unt': '61', 'Unw': '62', 'Unz': '63', 'Uo': '64', 'Up': '65',
    'Upd': '66', 'Uph': '67', 'Upm': '68', 'Ups': '69', 'Upt': '71',
    'Ur': '72', 'Urbi': '73', 'Urc': '74', 'Ure': '75', 'Uri': '76',
    'Url': '77', 'Uro': '78', 'Urq': '79', 'Urr': '81', 'Urs': '82',
    'Urv': '83', 'Us': '84', 'Ush': '85', 'Usl': '86', 'Uss': '87',
    'Ust': '88', 'Ut': '89', 'Utl': '91', 'Utr': '92', 'Utt': '93',
    'Uv': '94', 'Uw': '95', 'Ux': '96', 'Uy': '97', 'Uyt': '98',
    'Uz': '99'
  },
  'V': {
    'Va': '111', 'Vac': '112', 'Vacc': '113', 'Vaccar': '114', 'Vacch': '115',
    'Vacchi': '116', 'Vacco': '117', 'Vach': '118', 'Vacho': '119', 'Vacq': '121',
    'Vad': '122', 'Vade': '123', 'Vadi': '124', 'Vae': '125', 'Vag': '126',
    'Vah': '127', 'Vai': '128', 'Vail': '129', 'Vaill': '131', 'Vais': '132',
    'Vaj': '133', 'Vak': '134', 'Val': '135', 'Valad': '136', 'Valar': '137',
    'Valaz': '138', 'Valb': '139', 'Valc': '141', 'Valck': '142', 'Valckenb': '143',
    'Vald': '144', 'Valdes': '145', 'Valdi': '146', 'Valdo': '147', 'Valdr': '148',
    'Vale': '149', 'Valeg': '151', 'Valen': '152', 'Valens': '153', 'Valent': '154',
    'Valenti': '155', 'Valentin': '156', 'Valentine': '157', 'Valentine, J.': '158', 'Valentine, P.': '159',
    'Valentini': '161', 'Valer': '162', 'Valeri': '163', 'Valerio': '164', 'Valeriu': '165',
    'Valery': '166', 'Vales': '167', 'Valet': '168', 'Valg': '169', 'Valh': '171',
    'Vali': '172', 'Valin': '173', 'Valk': '174', 'Vall': '175', 'Vallad': '176',
    'Vallan': '177', 'Vallar': '178', 'Vallau': '179', 'Valle': '181', 'Vallee': '182',
    'Vallem': '183', 'Valler': '184', 'Valles': '185', 'Vallet': '186', 'Vallett': '187',
    'Valli': '188', 'Vallis': '189', 'Vallo': '191', 'Vallon': '192', 'Vallot': '193',
    'Vallou': '194', 'Valls': '195', 'Valm': '196', 'Valmy': '197', 'Valo': '198',
    'Valor': '199', 'Valp': '211', 'Valpy': '212', 'Valr': '213', 'Vals': '214',
    'Valt': '215', 'Vam': '216', 'Van': '217', 'Vanb': '218', 'Vanbr': '219',
    'Vanbu': '221', 'Vanc': '222', 'Vanco': '223', 'Vand': '224', 'Vande': '225',
    'Vandel': '226', 'Vanden': '227', 'Vander': '228', 'Vanderbu': '229', 'Vanderc': '231',
    'Vanderd': '232', 'Vanderh': '233', 'Vanderho': '234', 'Vanderl': '235', 'Vanderm': '236',
    'Vanderme': '237', 'Vandermo': '238', 'Vanderp': '239', 'Vanders': '241', 'Vanderw': '242',
    'Vandeu': '243', 'Vandev': '244', 'Vandi': '245', 'Vando': '246', 'Vandy': '247',
    'Vandyk': '248', 'Vane': '249', 'Vane, M.': '251', 'Vanee': '252', 'Vang': '253',
    'Vanh': '254', 'Vanhe': '255', 'Vanho': '256', 'Vanhu': '257', 'Vani': '258',
    'Vanl': '259', 'Vanloo': '261', 'Vanm': '262', 'Vanmo': '263', 'Vann': '264',
    'Vanne': '265', 'Vannes': '266', 'Vannet': '267', 'Vanni': '268', 'Vannin': '269',
    'Vannu': '271', 'Vano': '272', 'Vanp': '273', 'Vanr': '274', 'Vanro': '275',
    'Vans': '276', 'Vansa': '277', 'Vansc': '278', 'Vansi': '279', 'Vansp': '281',
    'Vant': '282', 'Vanu': '283', 'Vanv': '284', 'Vanw': '285', 'Vap': '286',
    'Var': '287', 'Varan': '288', 'Varc': '289', 'Vard': '291', 'Vare': '292',
    'Varel': '293', 'Varen': '294', 'Varenn': '295', 'Vares': '296', 'Varg': '297',
    'Vargu': '298', 'Vari': '299', 'Varil': '311', 'Varin': '312', 'Variu': '313',
    'Varl': '314', 'Varley': '315', 'Varlo': '316', 'Varn': '317', 'Varney': '318',
    'Varnh': '319', 'Varni': '321', 'Varnu': '322', 'Varo': '323', 'Varot': '324',
    'Varr': '325', 'Vart': '326', 'Varu': '327', 'Vas': '328', 'Vasc': '329',
    'Vasco': '331', 'Vase': '332', 'Vash': '333', 'Vasi': '334', 'Vasq': '335',
    'Vass': '336', 'Vassall': '337', 'Vasse': '338', 'Vassi': '339', 'Vast': '341',
    'Vat': '342', 'Vater': '343', 'Vath': '344', 'Vati': '345', 'Vatin': '346',
    'Vatk': '347', 'Vato': '348', 'Vatr': '349', 'Vatt': '351', 'Vatti': '352',
    'Vau': '353', 'Vauban': '354', 'Vaubl': '355', 'Vauc': '356', 'Vauch': '357',
    'Vaud': '358', 'Vaudoy': '359', 'Vaudr': '361', 'Vaudrey': '362', 'Vaug': '363',
    'Vaughan': '364', 'Vaughan, C.': '365', 'Vaughan, G.': '366', 'Vaughan, J.': '367', 'Vaughan, M.': '368',
    'Vaughan, S.': '369', 'Vaughan, W.': '371', 'Vaugi': '372', 'Vaugo': '373', 'Vaul': '374',
    'Vaulo': '375', 'Vault': '376', 'Vaum': '377', 'Vauq': '378', 'Vaus': '379',
    'Vaut': '381', 'Vauv': '382', 'Vauvi': '383', 'Vaux': '384', 'Vaux, G.': '385',
    'Vaux, M.': '386', 'Vauxc': '387', 'Vauz': '388', 'Vav': '389', 'Vavi': '391',
    'Vay': '392', 'Vaz': '393', 'Ve': '394', 'Veau': '395', 'Vec': '396',
    'Vecchi': '397', 'Vecchio': '398', 'Vece': '399', 'Vecellio': '411', 'Vecn': '412',
    'Veco': '413', 'Ved': '414', 'Vedd': '415', 'Vedo': '416', 'Vee': '417',
    'Veen': '418', 'Veer': '419', 'Vees': '421', 'Veg': '422', 'Vegi': '423',
    'Vegl': '424', 'Veh': '425', 'Vei': '426', 'Veil': '427', 'Veit': '428',
    'Veitch': '429', 'Veith': '431', 'Vel': '432', 'Velas': '433', 'Velasq': '434',
    'Veld': '435', 'Vele': '436', 'Veli': '437', 'Vell': '438', 'Velle': '439',
    'Vello': '441', 'Vellu': '442', 'Velly': '443', 'Velp': '444', 'Velt': '445',
    'Veltr': '446', 'Ven': '447', 'Venan': '448', 'Venc': '449', 'Vences': '451',
    'Vend': '452', 'Vendr': '453', 'Vene': '454', 'Veneg': '455', 'Venel': '456',
    'Venet': '457', 'Venez': '458', 'Veni': '459', 'Venin': '461', 'Venn': '462',
    'Venner': '463', 'Venni': '464', 'Vent': '465', 'Vento': '466', 'Ventr': '467',
    'Ventu': '468', 'Venturi': '469', 'Venu': '471', 'Venut': '472', 'Ver': '473',
    'Verac': '474', 'Veral': '475', 'Verar': '476', 'Verb': '477', 'Verbi': '478',
    'Verbo': '479', 'Verc': '481', 'Verci': '482', 'Verd': '483', 'Verdi': '484',
    'Verdig': '485', 'Verdo': '486', 'Verdu': '487', 'Verdy': '488', 'Vere': '489',
    'Verel': '491', 'Verels': '492', 'Verg': '493', 'Vergar': '494', 'Verge': '495',
    'Verger': '496', 'Vergi': '497', 'Vergn': '498', 'Vergy': '499', 'Verh': '511',
    'Verhag': '512', 'Verhe': '513', 'Verho': '514', 'Verhu': '515', 'Veri': '516',
    'Verin': '517', 'Verj': '518', 'Verk': '519', 'Verl': '521', 'Verm': '522',
    'Verme': '523', 'Vermeu': '524', 'Vermi': '525', 'Vermil': '526', 'Vermo': '527',
    'Vermoo': '528', 'Vern': '529', 'Verne': '531', 'Vernet': '532', 'Verneu': '533',
    'Verney': '534', 'Verney, M.': '535', 'Verni': '536', 'Vernin': '537', 'Verniz': '538',
    'Verno': '539', 'Vernon, G.': '541', 'Vernon, M.': '542', 'Vernon, S.': '543', 'Vernu': '544',
    'Verny': '545', 'Vero': '546', 'Veron': '547', 'Verona': '548', 'Verone': '549',
    'Verp': '551', 'Verpo': '552', 'Verr': '553', 'Verri': '554', 'Verril': '555',
    'Verrim': '556', 'Verrio': '557', 'Verro': '558', 'Verru': '559', 'Vers': '561',
    'Verschu': '562', 'Verse': '563', 'Verso': '564', 'Verst': '565', 'Versto': '566',
    'Vert': '567', 'Verto': '568', 'Veru': '569', 'Verv': '571', 'Verw': '572',
    'Very': '573', 'Verz': '574', 'Ves': '575', 'Vesey': '576', 'Vesi': '577',
    'Vesl': '578', 'Vesp': '579', 'Vespu': '581', 'Vesq': '582', 'Vest': '583',
    'Vestr': '584', 'Vet': '585', 'Vetch': '586', 'Veth': '587', 'Veti': '588',
    'Vetr': '589', 'Vett': '591', 'Vetto': '592', 'Vetu': '593', 'Veu': '594',
    'Vey': '595', 'Veys': '596', 'Vez': '597', 'Vi': '598', 'Vial': '599',
    'Viale': '611', 'Viall': '612', 'Vialo': '613', 'Vian': '614', 'Vianen': '615',
    'Viani': '616', 'Viann': '617', 'Viar': '618', 'Viardo': '619', 'Viart': '621',
    'Vias': '622', 'Viau': '623', 'Vib': '624', 'Vibi': '625', 'Vibn': '626',
    'Vic': '627', 'Vicar': '628', 'Vicars': '629', 'Vicat': '631', 'Vice': '632',
    'Vicenti': '633', 'Vich': '634', 'Vici': '635', 'Vick': '636', 'Vickers': '637',
    'Vico': '638', 'Vicom': '639', 'Vicq': '641', 'Vict': '642', 'Victor, G.': '643',
    'Victor, M.': '644', 'Victor, S.': '645', 'Victorin': '646', 'Vicu': '647', 'Vid': '648',
    'Vidal, M.': '649', 'Vidau': '651', 'Vide': '652', 'Vidi': '653', 'Vido': '654',
    'Vidu': '655', 'Vie': '656', 'Viei': '657', 'Vieillo': '658', 'Viel': '659',
    'Viell': '661', 'Vien': '662', 'Vienne': '663', 'Vienno': '664', 'Vier': '665',
    'Viet': '666', 'Vieu': '667', 'Vieus': '668', 'Vieuv': '669', 'Vieux': '671',
    'Vig': '672', 'Vige': '673', 'Viger': '674', 'Vigh': '675', 'Vigi': '676',
    'Vigil': '677', 'Vign': '678', 'Vignal': '679', 'Vignau': '681', 'Vigne': '682',
    'Vigner': '683', 'Vignes': '684', 'Vigni': '685', 'Vigno': '686', 'Vignon': '687',
    'Vigny': '688', 'Vigo': '689', 'Vigor': '691', 'Vigr': '692', 'Vigu': '693',
    'Vigui': '694', 'Vil': '695', 'Vilain': '696', 'Vilar': '697', 'Vilat': '698',
    'Vilb': '699', 'Vilh': '711', 'Vill': '712', 'Villaf': '713', 'Villal': '714',
    'Villam': '715', 'Villan': '716', 'Villano': '717', 'Villanu': '718', 'Villar': '719',
    'Villaret': '721', 'Villari': '722', 'Villars': '723', 'Villars, G.': '724', 'Villars, M.': '725',
    'Villars, S.': '726', 'Villav': '727', 'Ville': '728', 'Villec': '729', 'Villef': '731',
    'Villeg': '732', 'Villego': '733', 'Villeh': '734', 'Villel': '735', 'Villem': '736',
    'Villen': '737', 'Villene': '738', 'Villep': '739', 'Villeq': '741', 'Viller': '742',
    'Villerm': '743', 'Villero': '744', 'Villers': '745', 'Villers, M.': '746', 'Villes': '747',
    'Villet': '748', 'Villeu': '749', 'Villi': '751', 'Villiers': '752', 'Villiers, F.': '753',
    'Villiers, J.': '754', 'Villiers, M.': '755', 'Villiers, S.': '756', 'Villiers, W.': '757', 'Villo': '758',
    'Villon': '759', 'Villot': '761', 'Vilm': '762', 'Vils': '763', 'Vim': '764',
    'Vimo': '765', 'Vin': '766', 'Vinc': '767', 'Vincent': '768', 'Vincent, C.': '769',
    'Vincent, F.': '771', 'Vincent, J.': '772', 'Vincent, M.': '773', 'Vincent, S.': '774', 'Vincent, W.': '775',
    'Vinch': '776', 'Vinci': '777', 'Vinck': '778', 'Vind': '779', 'Vindi': '781',
    'Vine': '782', 'Vinet': '783', 'Ving': '784', 'Vini': '785', 'Vink': '786',
    'Vinn': '787', 'Vino': '788', 'Vint': '789', 'Vinton': '791', 'Vinton, G.': '792',
    'Vinton, M.': '793', 'Vinton, S.': '794', 'Vio': '795', 'Violl': '796', 'Viom': '797',
    'Vion': '798', 'Viot': '799', 'Vip': '811', 'Vipo': '812', 'Vir': '813',
    'Vire': '814', 'Virey': '815', 'Virg': '816', 'Virgin': '817', 'Viri': '818',
    'Virl': '819', 'Viru': '821', 'Vis': '822', 'Visch': '823', 'Visco': '824',
    'Visconti, G.': '825', 'Visconti, M.': '826', 'Visconti, S.': '827', 'Visd': '828', 'Vise': '829',
    'Visi': '831', 'Vism': '832', 'Viss': '833', 'Visse': '834', 'Vit': '835',
    'Vital': '836', 'Vitalis': '837', 'Vite': '838', 'Vitel': '839', 'Vitelli': '841',
    'Viten': '842', 'Viter': '843', 'Vitet': '844', 'Vito': '845', 'Vitr': '846',
    'Vitro': '847', 'Vitru': '848', 'Vitry': '849', 'Vitt': '851', 'Vitti': '852',
    'Vitto': '853', 'Vitu': '854', 'Viv': '855', 'Vivari': '856', 'Vive': '857',
    'Vivi': '858', 'Viviani': '859', 'Vivien': '861', 'Vivier': '862', 'Vivo': '863',
    'Viz': '864', 'Vl': '865', 'Vlam': '866', 'Vlas': '867', 'Vle': '868',
    'Vli': '869', 'Vliet': '871', 'Vo': '872', 'Voelc': '873', 'Voell': '874',
    'Voer': '875', 'Voet': '876', 'Vog': '877', 'Vogel': '878', 'Vogel, M.': '879',
    'Vogh': '881', 'Vogi': '882', 'Vogl': '883', 'Vogler, M.': '884', 'Vogo': '885',
    'Vogt': '886', 'Vogt, M.': '887', 'Vogu': '888', 'Voi': '889', 'Voigt': '891',
    'Voigt, G.': '892', 'Voigt, M.': '893', 'Voigt, S.': '894', 'Voil': '895',
    'Voir': '896', 'Vois': '897', 'Voit': '898', 'Vol': '899', 'Volc': '911',
    'Volck': '912', 'Volckm': '913', 'Vold': '914', 'Volg': '915', 'Volk': '916',
    'Volke': '917', 'Volkh': '918', 'Volkm': '919', 'Volko': '921', 'Volky': '922',
    'Voll': '923', 'Vollm': '924', 'Vollw': '925', 'Volm': '926', 'Voln': '927',
    'Volney': '928', 'Volo': '929', 'Volp': '931', 'Volpi': '932', 'Volpin': '933',
    'Vols': '934', 'Volt': '935', 'Voltch': '936', 'Volte': '937', 'Volto': '938',
    'Voltr': '939', 'Voltu': '941', 'Voltz': '942', 'Volu': '943', 'Volv': '944',
    'Von': '945', 'Vond': '946', 'Vonk': '947', 'Vono': '948', 'Voo': '949',
    'Voor': '951', 'Vop': '952', 'Vor': '953', 'Voro': '954', 'Vors': '955',
    'Vorster': '956', 'Vort': '957', 'Vory': '958', 'Vos': '959', 'Vose': '961',
    'Vose, D.': '962', 'Vose, H.': '963', 'Vose, J.': '964', 'Vose, M.': '965', 'Vose, S.': '966',
    'Vose, W.': '967', 'Vosm': '968', 'Voss': '969', 'Vossi': '971', 'Vou': '972',
    'Voul': '973', 'Vow': '974', 'Voy': '975', 'Voys': '976', 'Voz': '977',
    'Vr': '978', 'Vre': '979', 'Vri': '981', 'Vries': '982', 'Vril': '983',
    'Vro': '984', 'Vs': '985', 'Vu': '986', 'Vui': '987', 'Vuil': '988',
    'Vuit': '989', 'Vul': '991', 'Vulp': '992', 'Vuls': '993', 'Vuo': '994',
    'Vuy': '995', 'Vy': '996', 'Vyr': '997', 'Vys': '998', 'Vz': '999'
  },
  'W': {
    'Wa': '111', 'Waas': '112', 'Wac': '113', 'Wachs': '114', 'Wack': '115',
    'Wad': '116', 'Waddi': '117', 'Waddington': '118', 'Wade': '119', 'Wade, M.': '121',
    'Wadh': '122', 'Wadl': '123', 'Wads': '124', 'Wadsworth, M.': '125', 'Wae': '126',
    'Wael': '127', 'Waf': '128', 'Wag': '129', 'Wagen': '131', 'Wagn': '132',
    'Wagner, G.': '133', 'Wagner, M.': '134', 'Wagner, S.': '135', 'Wah': '136', 'Wahlen': '137',
    'Wai': '138', 'Waill': '139', 'Wain': '141', 'Wainwright, M.': '142', 'Wais': '143',
    'Wait': '144', 'Waite': '145', 'Wak': '146', 'Wakef': '147', 'Wakeh': '148',
    'Wakel': '149', 'Wal': '151', 'Walch': '152', 'Walch, J.': '153', 'Walch, P.': '154',
    'Walck': '155', 'Walco': '156', 'Wald': '157', 'Walde': '158', 'Waldeg': '159',
    'Waldem': '161', 'Walden': '162', 'Walder': '163', 'Waldm': '164', 'Waldo': '165',
    'Waldor': '166', 'Waldr': '167', 'Walds': '168', 'Wale': '169', 'Walei': '171',
    'Wales': '172', 'Wales, M.': '173', 'Walf': '174', 'Walg': '175', 'Wali': '176',
    'Walk': '177', 'Walker, D.': '178', 'Walker, F.': '179', 'Walker, J.': '181', 'Walker, M.': '182',
    'Walker, P.': '183', 'Walker, S.': '184', 'Walker, T.': '185', 'Walker, W.': '186', 'Wall': '187',
    'Wallace, D.': '188', 'Wallace, F.': '189', 'Wallace, J.': '191', 'Wallace, M.': '192', 'Wallace, P.': '193',
    'Wallace, S.': '194', 'Wallace, W.': '195', 'Wallc': '196', 'Wallen': '197', 'Waller': '198',
    'Walley': '199', 'Walli': '211', 'Wallingf': '212', 'Wallingt': '213', 'Wallis': '214',
    'Wallo': '215', 'Walm': '216', 'Waln': '217', 'Walp': '218', 'Walpole, M.': '219',
    'Walr': '221', 'Wals': '222', 'Walsh': '223', 'Walsh, D.': '224', 'Walsh, J.': '225',
    'Walsh, M.': '226', 'Walsh, S.': '227', 'Walsh, W.': '228', 'Walsi': '229', 'Walt': '231',
    'Walter, G.': '232', 'Walter, M.': '233', 'Walter, S.': '234', 'Walters': '235', 'Walth': '236',
    'Walther': '237', 'Walto': '238', 'Walton, G.': '239', 'Walton, M.': '241', 'Walw': '242',
    'Wam': '243', 'Wan': '244', 'Wand': '245', 'Wang': '246', 'Wanh': '247',
    'Wanl': '248', 'Wann': '249', 'Wans': '251', 'Wap': '252', 'War': '253',
    'Warburton': '254', 'Warburton, M.': '255', 'Ward': '256', 'Ward, C.': '257', 'Ward, F.': '258',
    'Ward, J.': '259', 'Ward, M.': '261', 'Ward, P.': '262', 'Ward, S.': '263', 'Ward, W.': '264',
    'Warde': '265', 'Wardl': '266', 'Ware': '267', 'Ware, D.': '268', 'Ware, J.': '269',
    'Ware, M.': '271', 'Ware, S.': '272', 'Ware, W.': '273', 'Waren': '274', 'Warh': '275',
    'Wari': '276', 'Waring, M.': '277', 'Warn': '278', 'Warner': '279', 'Warner, D.': '281',
    'Warner, J.': '282', 'Warner, M.': '283', 'Warner, S.': '284', 'Warner, W.': '285', 'Warr': '286',
    'Warren, C.': '287', 'Warren, F.': '288', 'Warren, J.': '289', 'Warren, M.': '291', 'Warren, P.': '292',
    'Warren, S.': '293', 'Warren, W.': '294', 'Warri': '295', 'Wart': '296', 'Wartens': '297',
    'Warto': '298', 'Warw': '299', 'Warwick, M.': '311', 'Was': '312', 'Waser': '313',
    'Wash': '314', 'Washburn, M.': '315', 'Washi': '316', 'Washington': '317', 'Washington, G.': '318',
    'Washington, M.': '319', 'Wass': '321', 'Wasser': '322', 'Wassi': '323', 'Wat': '324',
    'Waterf': '325', 'Waterh': '326', 'Waterl': '327', 'Waterm': '328', 'Waters': '329',
    'Waters, M.': '331', 'Waterst': '332', 'Waterw': '333', 'Watk': '334', 'Watke': '335',
    'Watkinson': '336', 'Wats': '337', 'Watson, D.': '338', 'Watson, J.': '339', 'Watson, M.': '341',
    'Watson, S.': '342', 'Watson, W.': '343', 'Watt': '344', 'Watt, J.': '345', 'Watt, P.': '346',
    'Watti': '347', 'Watts': '348', 'Watts, D.': '349', 'Watts, J.': '351', 'Watts, M.': '352',
    'Watts, S.': '353', 'Wau': '354', 'Waut': '355', 'Waw': '356', 'Way': '357',
    'Wayl': '358', 'Wayn': '359', 'We': '361', 'Weal': '362', 'Weav': '363',
    'Web': '364', 'Webb': '365', 'Webb, G.': '366', 'Webb, M.': '367', 'Webb, S.': '368',
    'Webbe': '369', 'Webber': '371', 'Webber, M.': '372', 'Weber': '373', 'Weber, G.': '374',
    'Weber, M.': '375', 'Weber, S.': '376', 'Webs': '377', 'Webster, C.': '378', 'Webster, F.': '379',
    'Webster, J.': '381', 'Webster, M.': '382', 'Webster, P.': '383', 'Webster, S.': '384', 'Webster, W.': '385',
    'Wech': '386', 'Weck': '387', 'Wed': '388', 'Wede': '389', 'Wedel': '391',
    'Wedg': '392', 'Wedgw': '393', 'Wee': '394', 'Weeks': '395', 'Weeks, M.': '396',
    'Weem': '397', 'Weer': '398', 'Weev': '399', 'Weg': '411', 'Wegn': '412',
    'Weh': '413', 'Wehr': '414', 'Wei': '415', 'Weich': '416', 'Weid': '417',
    'Weidm': '418', 'Weig': '419', 'Weik': '421', 'Weil': '422', 'Wein': '423',
    'Weinm': '424', 'Weir': '425', 'Weis': '426', 'Weise': '427', 'Weisk': '428',
    'Weiss': '429', 'Weiss, J.': '431', 'Weiss, P.': '432', 'Weissen': '433', 'Weit': '434',
    'Weits': '435', 'Weitz': '436', 'Wek': '437', 'Wel': '438', 'Welch': '439',
    'Welch, M.': '441', 'Welck': '442', 'Weld': '443', 'Weld, M.': '444', 'Welde': '445',
    'Welh': '446', 'Well': '447', 'Weller': '448', 'Welles': '449', 'Wellesl': '451',
    'Welli': '452', 'Wells': '453', 'Wells, G.': '454', 'Wells, M.': '455', 'Wells, S.': '456',
    'Wellw': '457', 'Wels': '458', 'Welse': '459', 'Welsh': '461', 'Welsh, J.': '462',
    'Welsh, P.': '463', 'Welt': '464', 'Welw': '465', 'Wem': '466', 'Wen': '467',
    'Wenc': '468', 'Wend': '469', 'Wendl': '471', 'Wendo': '472', 'Wendt': '473',
    'Weng': '474', 'Weni': '475', 'Wenl': '476', 'Went': '477', 'Wentworth, G.': '478',
    'Wentworth, M.': '479', 'Wentz': '481', 'Wenz': '482', 'Wep': '483', 'Wer': '484',
    'Werde': '485', 'Were': '486', 'Weren': '487', 'Werf': '488', 'Werl': '489',
    'Wern': '491', 'Werner': '492', 'Werner, G.': '493', 'Werner, M.': '494', 'Wernh': '495',
    'Werni': '496', 'Werns': '497', 'Werp': '498', 'Wert': '499', 'Wes': '511',
    'Wesen': '512', 'Wesl': '513', 'Wesley, M.': '514', 'Wess': '515', 'West': '516',
    'West, D.': '517', 'West, J.': '518', 'West, M.': '519', 'West, S.': '521', 'West, W.': '522',
    'Westb': '523', 'Westc': '524', 'Weste': '525', 'Wester': '526', 'Westerm': '527',
    'Westg': '528', 'Westh': '529', 'Westm': '531', 'Westmi': '532', 'Westmo': '533',
    'Westo': '534', 'Weston, G.': '535', 'Weston, P.': '536', 'Westp': '537', 'Westr': '538',
    'Wet': '539', 'Wetm': '541', 'Wett': '542', 'Wetts': '543', 'Wetz': '544',
    'Wex': '545', 'Wey': '546', 'Weye': '547', 'Weyl': '548', 'Weym': '549',
    'Wh': '551', 'Whal': '552', 'Whart': '553', 'Wharton, M.': '554', 'What': '555',
    'Whe': '556', 'Wheatl': '557', 'Wheato': '558', 'Whed': '559', 'Whee': '561',
    'Wheeler': '562', 'Wheeler, G.': '563', 'Wheeler, P.': '564', 'Wheelo': '565', 'Wheelw': '566',
    'Whelp': '567', 'Whet': '568', 'Whew': '569', 'Whi': '571', 'Whid': '572',
    'Whip': '573', 'Whipple, J.': '574', 'Whipple, P.': '575', 'Whis': '576', 'Whit': '577',
    'Whitaker, M.': '578', 'Whitb': '579', 'Whitc': '581', 'White': '582', 'White, C.': '583',
    'White, F.': '584', 'White, J.': '585', 'White, M.': '586', 'White, P.': '587', 'White, S.': '588',
    'White, W.': '589', 'Whitef': '591', 'Whiteh': '592', 'Whiteho': '593', 'Whitel': '594',
    'Whitf': '595', 'Whitg': '596', 'Whiti': '597', 'Whiting': '598', 'Whiting, G.': '599',
    'Whiting, M.': '611', 'Whiting, S.': '612', 'Whiting, W.': '613', 'Whitm': '614', 'Whitman, M.': '615',
    'Whitmore': '616', 'Whitney': '617', 'Whitney, D.': '618', 'Whitney, J.': '619', 'Whitney, M.': '621',
    'Whitney, S.': '622', 'Whitney, W.': '623', 'Whitt': '624', 'Whitti': '625', 'Whitting': '626',
    'Whittl': '627', 'Whitw': '628', 'Why': '629', 'Wi': '631', 'Wib': '632',
    'Wic': '633', 'Wichi': '634', 'Wichm': '635', 'Wick': '636', 'Wickh': '637',
    'Wid': '638', 'Wide': '639', 'Widm': '641', 'Wie': '642', 'Wiede': '643',
    'Wiedem': '644', 'Wieg': '645', 'Wiel': '646', 'Wien': '647', 'Wier': '648',
    'Wies': '649', 'Wiese': '651', 'Wiess': '652', 'Wif': '653', 'Wig': '654',
    'Wigg': '655', 'Wiggl': '656', 'Wigh': '657', 'Wightm': '658', 'Wigm': '659',
    'Wign': '661', 'Wigr': '662', 'Wik': '663', 'Wil': '664', 'Wilbr': '665',
    'Wilbu': '666', 'Wilc': '667', 'Wild': '668', 'Wildb': '669', 'Wilde': '671',
    'Wilde, M.': '672', 'Wilder': '673', 'Wildm': '674', 'Wildt': '675', 'Wile': '676',
    'Wilf': '677', 'Wilh': '678', 'Wili': '679', 'Wilk': '681', 'Wilkes': '682',
    'Wilki': '683', 'Wilkins': '684', 'Wilkins, M.': '685', 'Wilkinson': '686', 'Wilkinson, M.': '687',
    'Wilks': '688', 'Will': '689', 'Willar': '691', 'Willard, D.': '692', 'Willard, J.': '693',
    'Willard, M.': '694', 'Willard, S.': '695', 'Willard, W.': '696', 'Willc': '697', 'Wille': '698',
    'Willem': '699', 'Willen': '711', 'Willer': '712', 'Willes': '713', 'Willey': '714',
    'Willi': '715', 'William': '716', 'William, G.': '717', 'William, M.': '718', 'William, S.': '719',
    'Williams': '721', 'Williams, C.': '722', 'Williams, F.': '723', 'Williams, J.': '724', 'Williams, M.': '725',
    'Williams, P.': '726', 'Williams, S.': '727', 'Williams, W.': '728', 'Williamson': '729', 'Williamson, J.': '731',
    'Williamson, P.': '732', 'Willin': '733', 'Willis': '734', 'Willis, M.': '735', 'Willist': '736',
    'Willm': '737', 'Willmo': '738', 'Willo': '739', 'Wills': '741', 'Willso': '742',
    'Wilm': '743', 'Wilmo': '744', 'Wilr': '745', 'Wils': '746', 'Wilson, C.': '747',
    'Wilson, F.': '748', 'Wilson, J.': '749', 'Wilson, M.': '751', 'Wilson, P.': '752', 'Wilson, S.': '753',
    'Wilson, W.': '754', 'Wilt': '755', 'Wilton, M.': '756', 'Wim': '757', 'Win': '758',
    'Winche': '759', 'Winck': '761', 'Winckl': '762', 'Wind': '763', 'Windh': '764',
    'Windi': '765', 'Winds': '766', 'Wine': '767', 'Wines': '768', 'Wing': '769',
    'Wingf': '771', 'Wingr': '772', 'Wink': '773', 'Winkelm': '774', 'Winkl': '775',
    'Winn': '776', 'Wins': '777', 'Winslow': '778', 'Winslow, G.': '779', 'Winslow, M.': '781',
    'Winslow, S.': '782', 'Winst': '783', 'Wint': '784', 'Winter, G.': '785', 'Winter, M.': '786',
    'Winter, S.': '787', 'Winterf': '788', 'Winth': '789', 'Winthrop': '791', 'Winthrop, J.': '792',
    'Winthrop, P.': '793', 'Wintr': '794', 'Winw': '795', 'Wio': '796', 'Wip': '797',
    'Wir': '798', 'Wirt': '799', 'Wis': '811', 'Wise': '812', 'Wise, M.': '813',
    'Wisem': '814', 'Wisn': '815', 'Wiss': '816', 'Wist': '817', 'Wisw': '818',
    'Wit': '819', 'Wite': '821', 'With': '822', 'Witheri': '823', 'Withers': '824',
    'Witi': '825', 'Wits': '826', 'Witt': '827', 'Witte': '828', 'Witten': '829',
    'Wittg': '831', 'Witti': '832', 'Witz': '833', 'Witzl': '834', 'Wix': '835',
    'Wl': '836', 'Wo': '837', 'Wod': '838', 'Wodes': '839', 'Woe': '841',
    'Woel': '842', 'Woer': '843', 'Wof': '844', 'Wog': '845', 'Woh': '846',
    'Woi': '847', 'Wol': '848', 'Wolcott': '849', 'Wolcott, M.': '851', 'Wold': '852',
    'Wolf': '853', 'Wolf, J.': '854', 'Wolf, P.': '855', 'Wolffe': '856', 'Wolffe, J.': '857',
    'Wolffe, P.': '858', 'Wolfg': '859', 'Wolfr': '861', 'Wolk': '862', 'Woll': '863',
    'Wolle': '864', 'Wolm': '865', 'Wolo': '866', 'Wols': '867', 'Wolt': '868',
    'Woltm': '869', 'Wolz': '871', 'Wom': '872', 'Woo': '873', 'Wood, C.': '874',
    'Wood, F.': '875', 'Wood, J.': '876', 'Wood, M.': '877', 'Wood, P.': '878', 'Wood, S.': '879',
    'Wood, W.': '881', 'Woodbri': '882', 'Woodbridge, M.': '883', 'Woodbu': '884', 'Woodbury, M.': '885',
    'Woodc': '886', 'Woodf': '887', 'Woodh': '888', 'Woodho': '889', 'Woodhu': '891',
    'Woodm': '892', 'Woodr': '893', 'Woods': '894', 'Woods, J.': '895', 'Woods, M.': '896',
    'Woods, S.': '897', 'Woods, W.': '898', 'Woodw': '899', 'Woodward, J.': '911', 'Woodward, P.': '912',
    'Wool': '913', 'Woolm': '914', 'Woolr': '915', 'Wools': '916', 'Woolw': '917',
    'Woot': '918', 'Wor': '919', 'Worcester, G.': '921', 'Worcester, M.': '922', 'Worcester, S.': '923',
    'Word': '924', 'Wordsw': '925', 'Wordsworth, M.': '926', 'Worl': '927', 'Worm': '928',
    'Woro': '929', 'Wors': '931', 'Wort': '932', 'Worthington': '933', 'Worthington, M.': '934',
    'Wortl': '935', 'Wot': '936', 'Wott': '937', 'Wou': '938', 'Wr': '939',
    'Wran': '941', 'Wrat': '942', 'Wrax': '943', 'Wre': '944', 'Wren': '945',
    'Wri': '946', 'Wright': '947', 'Wright, C.': '948', 'Wright, F.': '949', 'Wright, J.': '951',
    'Wright, M.': '952', 'Wright, S.': '953', 'Wright, W.': '954', 'Wris': '955', 'Writ': '956',
    'Wro': '957', 'Wroth': '958', 'Wu': '959', 'Wul': '961', 'Wulfh': '962',
    'Wulfr': '963', 'Wulfs': '964', 'Wun': '965', 'Wuns': '966', 'Wur': '967',
    'Wurm': '968', 'Wurt': '969', 'Wurtz': '971', 'Wurz': '972', 'Wus': '973',
    'Wy': '974', 'Wyatt': '975', 'Wyatt, M.': '976', 'Wyc': '977', 'Wyd': '978',
    'Wye': '979', 'Wyk': '981', 'Wyl': '982', 'Wyle': '983', 'Wym': '984',
    'Wyn': '985', 'Wynf': '986', 'Wyng': '987', 'Wynn': '988', 'Wynne, M.': '989',
    'Wynt': '991', 'Wyo': '992', 'Wyr': '993', 'Wys': '994', 'Wyss': '995',
    'Wyt': '996', 'Wytt': '997', 'Wyv': '998', 'Wz': '999'
  },
  'X': {
    'Xa': '1', 'Xan': '2', 'Xav': '3', 'Xe': '4', 'Xen': '5',
    'Xer': '6', 'Xl': '7', 'Xn': '8', 'Xy': '9'
  },
  'Y': {
    'Ya': '11', 'Yac': '12', 'Yah': '13', 'Yai': '14', 'Yak': '15', 'Yal': '16', 'Yale': '17', 'Yale, M.': '18', 'Yales': '19',
    'Yan': '21', 'Yane': '22', 'Yani': '23', 'Yann': '24', 'Yao': '25', 'Yar': '26', 'Yard': '27', 'Yarf': '28', 'Yarr': '29',
    'Yat': '31', 'Yates, G.': '32', 'Yates, M.': '33', 'Yates, S.': '34', 'Yatm': '35', 'Yb': '36', 'Ye': '37', 'Yeam': '38', 'Year': '39',
    'Yeat': '41', 'Yeb': '42', 'Yef': '43', 'Yem': '44', 'Yen': '45', 'Yeo': '46', 'Yep': '47', 'Yet': '48', 'Yez': '49',
    'Yh': '51', 'Yl': '52', 'Yn': '53', 'Yo': '54', 'Yon': '55', 'Yonge, G.': '56', 'Yonge, M.': '57', 'Yonge, S.': '58', 'Yonge, W.': '59',
    'Yor': '61', 'York, J.': '62', 'York, P.': '63', 'Yorke': '64', 'Yorke, M.': '65', 'Yot': '66', 'You': '67', 'Young': '68', 'Young, C.': '69',
    'Young, E.': '71', 'Young, G.': '72', 'Young, J.': '73', 'Young, M.': '74', 'Young, P.': '75', 'Young, S.': '76', 'Young, T.': '77', 'Young, W.': '78', 'Youngm': '79',
    'Youngs': '81', 'Yous': '82', 'Youss': '83', 'Yoz': '84', 'Yp': '85', 'Yps': '86', 'Yr': '87', 'Yri': '88', 'Yrie': '89',
    'Ys': '91', 'Ysen': '92', 'Yss': '93', 'Yu': '94', 'Yule': '95', 'Yv': '96', 'Yve': '97', 'Yves': '98', 'Yvo': '99'
  },
  'Z': {
    'Za': '11', 'Zab': '12', 'Zac': '13', 'Zacco': '14', 'Zach': '15', 'Zachar': '16', 'Zacu': '17', 'Zag': '18', 'Zah': '19',
    'Zai': '21', 'Zal': '22', 'Zam': '23', 'Zambo': '24', 'Zamo': '25', 'Zamp': '26', 'Zan': '27', 'Zane': '28', 'Zang': '29',
    'Zani': '31', 'Zann': '32', 'Zano': '33', 'Zant': '34', 'Zap': '35', 'Zar': '36', 'Zari': '37', 'Zaro': '38', 'Zau': '39',
    'Ze': '41', 'Zec': '42', 'Zed': '43', 'Zeg': '44', 'Zei': '45', 'Zeif': '46', 'Zeis': '47', 'Zeit': '48', 'Zel': '49',
    'Zell': '51', 'Zelo': '52', 'Zelt': '53', 'Zen': '54', 'Zeno': '55', 'Zent': '56', 'Zep': '57', 'Zer': '58', 'Zes': '59',
    'Zet': '61', 'Zeu': '62', 'Zev': '63', 'Zi': '64', 'Zie': '65', 'Zieg': '66', 'Zies': '67', 'Zif': '68', 'Zil': '69',
    'Zim': '71', 'Zimmer': '72', 'Zimmermann': '73', 'Zimmermann, F.': '74', 'Zimmermann, M.': '75', 'Zimmermann, S.': '76', 'Zin': '77', 'Zink': '78', 'Zinz': '79',
    'Zir': '81', 'Zit': '82', 'Zo': '83', 'Zoc': '84', 'Zoe': '85', 'Zol': '86', 'Zon': '87', 'Zop': '88', 'Zot': '89',
    'Zou': '91', 'Zs': '92', 'Zu': '93', 'Zuc': '94', 'Zun': '95', 'Zur': '96', 'Zw': '97', 'Zwi': '98', 'Zy': '99'
  }
};

// Get cutter number from author's last name using Cutter Sanborn table
const getAuthorCutter = (author) => {
  if (!author) return 'UNK';
  
  const names = author.trim().split(/\s+/);
  if (names.length === 0) return 'UNK';
  
  const lastName = names[names.length - 1].toLowerCase();
  if (lastName.length === 0) return 'UNK';
  
  // Check if first letter is a vowel
  const firstLetter = lastName.charAt(0).toUpperCase();
  const isVowel = 'AEIOU'.includes(firstLetter);
  
  // Get the prefix: 2 letters for vowels, 1 letter for consonants
  const prefixLength = isVowel ? 2 : 1;
  const cutterPrefix = lastName.substring(0, prefixLength);
  
  // Check if we have a Cutter table for the first letter
  const letterTable = CUTTER_TABLE[firstLetter];
  if (!letterTable) return `${cutterPrefix.toUpperCase()}000`;
  
  // Try to find the best matching entry
  // Look for progressively shorter matches, starting from the full name
  for (let i = Math.min(lastName.length, 20); i >= prefixLength; i--) {
    const searchPrefix = lastName.substring(0, i);
    
    // Check for exact match first
    for (const [key, value] of Object.entries(letterTable)) {
      if (key.toLowerCase() === searchPrefix) {
        return `${cutterPrefix.toUpperCase()}${value}`;
      }
    }
  }
  
  // If no match found, return default with the vowel/consonant based prefix
  return `${cutterPrefix.toUpperCase()}000`;
};

const generateLibraryCallNumber = (collectionType, subject, author, year) => {
  const DDC_MAPPING = {
    '000 Computer science, knowledge & systems': '000',
    '010 Bibliographies': '010',
    '020 Library & information sciences': '020',
    '030 Encyclopedias & books of facts': '030',
    '050 Magazines, journals & serials': '050',
    '060 Associations, organizations & museums': '060',
    '070 News media, journalism & publishing': '070',
    '080 Quotations': '080',
    '090 Manuscripts & rare books': '090',
    '100 Philosophy': '100',
    '110 Metaphysics': '110',
    '120 Epistemology': '120',
    '130 Parapsychology & occultism': '130',
    '140 Philosophical schools of thought': '140',
    '150 Psychology': '150',
    '160 Logic': '160',
    '170 Ethics': '170',
    '180 Ancient, medieval & eastern philosophy': '180',
    '190 Modern western philosophy': '190',
    '200 Religion': '200',
    '210 Philosophy & theory of religion': '210',
    '220 The Bible': '220',
    '230 Christianity & Christian theology': '230',
    '240 Christian practice & observance': '240',
    '250 Christian pastoral practice & religious orders': '250',
    '260 Christian organization, social work & worship': '260',
    '270 History of Christianity': '270',
    '280 Christian denominations': '280',
    '290 Other religions': '290',
    '300 Social sciences, sociology & anthropology': '300',
    '310 Statistics': '310',
    '320 Political science': '320',
    '330 Economics': '330',
    '340 Law': '340',
    '350 Public administration & military science': '350',
    '360 Social problems & social services': '360',
    '370 Education': '370',
    '380 Commerce, communications & transportation': '380',
    '390 Customs, etiquette & folklore': '390',
    '400 Language': '400',
    '410 Linguistics': '410',
    '420 English & Old English languages': '420',
    '430 German & related languages': '430',
    '440 French & related languages': '440',
    '450 Italian, Romanian & related languages': '450',
    '460 Spanish & Portuguese languages': '460',
    '470 Latin & Italic languages': '470',
    '480 Classical & modern Greek languages': '480',
    '490 Other languages': '490',
    '500 Science': '500',
    '510 Mathematics': '510',
    '520 Astronomy': '520',
    '530 Physics': '530',
    '540 Chemistry': '540',
    '550 Earth sciences & geology': '550',
    '560 Fossils & prehistoric life': '560',
    '570 Life sciences; biology': '570',
    '580 Plants (Botany)': '580',
    '590 Animals (Zoology)': '590',
    '600 Technology': '600',
    '610 Medicine & health': '610',
    '620 Engineering': '620',
    '630 Agriculture': '630',
    '640 Home & family management': '640',
    '650 Management & public relations': '650',
    '660 Chemical engineering': '660',
    '670 Manufacturing': '670',
    '680 Manufacture for specific uses': '680',
    '690 Building & construction': '690',
    '700 Arts': '700',
    '710 Landscaping & area planning': '710',
    '720 Architecture': '720',
    '730 Sculpture, ceramics & metalwork': '730',
    '740 Drawing & decorative arts': '740',
    '750 Painting': '750',
    '760 Graphic arts': '760',
    '770 Photography & computer art': '770',
    '780 Music': '780',
    '790 Sports, games & entertainment': '790',
    '800 Literature, rhetoric & criticism': '800',
    '810 American literature in English': '810',
    '820 English & Old English literatures': '820',
    '830 German & related literatures': '830',
    '840 French & related literatures': '840',
    '850 Italian, Romanian & related literatures': '850',
    '860 Spanish & Portuguese literatures': '860',
    '870 Latin & Italic literatures': '870',
    '880 Classical & modern Greek literatures': '880',
    '890 Other literatures': '890',
    '900 History': '900',
    '910 Geography & travel': '910',
    '920 Biography & genealogy': '920',
    '930 History of ancient world (to ca. 499)': '930',
    '940 History of Europe': '940',
    '950 History of Asia': '950',
    '960 History of Africa': '960',
    '970 History of North America': '970',
    '980 History of South America': '980',
    '990 History of other areas': '990',
    // Legacy support for existing entries
    'Science': '500', 'Math': '510', 'Filipino': '820', 'English': '820',
    'Fiction': '800', 'History': '900', 'Biography': '920', 'Technology': '600',
    'Medicine': '610', 'Philosophy': '100', 'Psychology': '150',
    'Social Sciences': '300', 'Religion': '200', 'Art': '700', 'Music': '780',
    'Sports': '790'
  };
  
  // Get DDC code
  const ddcCode = DDC_MAPPING[subject] || '000';
  
  // Get collection type prefix
  const prefixMap = {
    'Filipiniana': 'F',
    'Reference': 'R',
    'Circulation': 'C'
  };
  const prefix = prefixMap[collectionType] || 'C';
  
  // Get cutter number from author
  const cutter = getAuthorCutter(author);
  const publishYear = year || new Date().getFullYear();
  
  return `${prefix}.${ddcCode}-${cutter}-${publishYear}`;
};

const AddBook = ({ onBookAdded }) => {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [categories, setCategories] = useState([
    // DDC Classification System
    '000 Computer science, knowledge & systems',
    '010 Bibliographies',
    '020 Library & information sciences',
    '030 Encyclopedias & books of facts',
    '050 Magazines, journals & serials',
    '060 Associations, organizations & museums',
    '070 News media, journalism & publishing',
    '080 Quotations',
    '090 Manuscripts & rare books',
    '100 Philosophy',
    '110 Metaphysics',
    '120 Epistemology',
    '130 Parapsychology & occultism',
    '140 Philosophical schools of thought',
    '150 Psychology',
    '160 Logic',
    '170 Ethics',
    '180 Ancient, medieval & eastern philosophy',
    '190 Modern western philosophy',
    '200 Religion',
    '210 Philosophy & theory of religion',
    '220 The Bible',
    '230 Christianity & Christian theology',
    '240 Christian practice & observance',
    '250 Christian pastoral practice & religious orders',
    '260 Christian organization, social work & worship',
    '270 History of Christianity',
    '280 Christian denominations',
    '290 Other religions',
    '300 Social sciences, sociology & anthropology',
    '310 Statistics',
    '320 Political science',
    '330 Economics',
    '340 Law',
    '350 Public administration & military science',
    '360 Social problems & social services',
    '370 Education',
    '380 Commerce, communications & transportation',
    '390 Customs, etiquette & folklore',
    '400 Language',
    '410 Linguistics',
    '420 English & Old English languages',
    '430 German & related languages',
    '440 French & related languages',
    '450 Italian, Romanian & related languages',
    '460 Spanish & Portuguese languages',
    '470 Latin & Italic languages',
    '480 Classical & modern Greek languages',
    '490 Other languages',
    '500 Science',
    '510 Mathematics',
    '520 Astronomy',
    '530 Physics',
    '540 Chemistry',
    '550 Earth sciences & geology',
    '560 Fossils & prehistoric life',
    '570 Life sciences; biology',
    '580 Plants (Botany)',
    '590 Animals (Zoology)',
    '600 Technology',
    '610 Medicine & health',
    '620 Engineering',
    '630 Agriculture',
    '640 Home & family management',
    '650 Management & public relations',
    '660 Chemical engineering',
    '670 Manufacturing',
    '680 Manufacture for specific uses',
    '690 Building & construction',
    '700 Arts',
    '710 Landscaping & area planning',
    '720 Architecture',
    '730 Sculpture, ceramics & metalwork',
    '740 Drawing & decorative arts',
    '750 Painting',
    '760 Graphic arts',
    '770 Photography & computer art',
    '780 Music',
    '790 Sports, games & entertainment',
    '800 Literature, rhetoric & criticism',
    '810 American literature in English',
    '820 English & Old English literatures',
    '830 German & related literatures',
    '840 French & related literatures',
    '850 Italian, Romanian & related literatures',
    '860 Spanish & Portuguese literatures',
    '870 Latin & Italic literatures',
    '880 Classical & modern Greek literatures',
    '890 Other literatures',
    '900 History',
    '910 Geography & travel',
    '920 Biography & genealogy',
    '930 History of ancient world (to ca. 499)',
    '940 History of Europe',
    '950 History of Asia',
    '960 History of Africa',
    '970 History of North America',
    '980 History of South America',
    '990 History of other areas',
    // Legacy support
    'Science', 'Math', 'Filipino', 'English', 'Fiction'
  ]);
  const [nextAccessionNumber, setNextAccessionNumber] = useState("Calculating...");
  const [nextCallNumber, setNextCallNumber] = useState("PREFIX.DDD-CCC-YYYY");
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicateBook, setDuplicateBook] = useState(null);

  const [book, setBook] = useState({
    title: "",
    year: "",
    genre: "",
    category: "",
    subject: "",
    stock: "1",
    collectionType: "Circulation",
    sourceOfFunds: "",
    location: {
      shelf: "",
      level: ""
    },
    author: "",
    publisher: "",
    accessionNumber: "",
    callNumber: "",
    image: null
  });

  const [preview, setPreview] = useState(null);
  const [base64Image, setBase64Image] = useState("");

  // Fetch the next accession number when component mounts
  useEffect(() => {
    const fetchNextAccessionNumber = async () => {
      try {
        console.log("📚 Fetching next accession number...");
        
        // Get all books to find the highest accession number
        const response = await fetch("https://paranaque-web-system.onrender.com/api/books/?limit=9999");
        const data = await response.json();
        
        const currentYear = new Date().getFullYear();
        let highestNumber = 0;
        let highestBook = null;
        
        if (data.books && data.books.length > 0) {
          // Loop through ALL books to find the actual highest numeric accession number
          for (const book of data.books) {
            const accession = book.accessionNumber || "";
            if (accession.startsWith(`${currentYear}-`)) {
              const parts = accession.split('-');
              if (parts.length === 2) {
                const sequenceNum = parseInt(parts[1]);
                if (sequenceNum > highestNumber) {
                  highestNumber = sequenceNum;
                  highestBook = accession;
                }
              }
            }
          }
          
          console.log("📚 Highest accession number found:", highestBook || "None");
          
          const nextSequence = highestNumber + 1;
          const nextAccession = `${currentYear}-${String(nextSequence).padStart(4, '0')}`;
          console.log("📚 Next accession number will be:", nextAccession);
          setNextAccessionNumber(nextAccession);
        } else {
          // No books exist yet
          setNextAccessionNumber(`${currentYear}-0001`);
        }
      } catch (err) {
        console.error("❌ Error fetching accession number:", err);
        setNextAccessionNumber("Auto-generated");
      }
    };

    fetchNextAccessionNumber();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];
      
      // Validate file type
      if (file && !file.type.startsWith('image/')) {
        alert("Please select a valid image file");
        return;
      }

      // Validate file size (max 5MB)
      if (file && file.size > 5 * 1024 * 1024) {
        alert("Image size must be less than 5MB");
        return;
      }

      setBook({ ...book, image: file });
      setPreview(URL.createObjectURL(file));

      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          console.log("✅ Image converted to base64, size:", reader.result.length);
          setBase64Image(reader.result);
        }
      };
      reader.onerror = () => {
        console.error("❌ Error reading image file");
        alert("Error reading image file. Please try again.");
      };
      if (file) reader.readAsDataURL(file);

      return;
    }

    const updatedBook = { ...book, [name]: value };
    setBook(updatedBook);
    
    // Auto-update call number preview when subject, author, collectionType, or year changes
    if (name === "subject" || name === "author" || name === "collectionType" || name === "year") {
      const previewCallNumber = generateLibraryCallNumber(
        updatedBook.collectionType || 'Circulation',
        updatedBook.subject,
        updatedBook.author,
        updatedBook.year ? parseInt(updatedBook.year) : new Date().getFullYear()
      );
      setNextCallNumber(previewCallNumber);
    }
  };

  const handleAddCategory = () => {
    if (newCategory.trim()) {
      if (!categories.includes(newCategory.trim())) {
        setCategories([...categories, newCategory.trim()]);
        setBook({ ...book, category: newCategory.trim() });
        setNewCategory("");
        setShowCategoryModal(false);
      } else {
        alert("Category already exists!");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    console.log("📝 Form submitted with data:", {
      title: book.title,
      author: book.author,
      year: book.year,
      category: book.category,
      stock: book.stock,
      shelf: book.location.shelf,
      level: book.location.level
    });
    
    // Validate required fields
    if (!book.title || !book.title.trim()) {
      alert("Book title is required");
      return;
    }
    
    if (!book.author || !book.author.trim()) {
      alert("Author is required");
      return;
    }
    
    if (!book.year || isNaN(book.year) || book.year < 1000 || book.year > new Date().getFullYear() + 10) {
      alert("Please enter a valid year (between 1000 and " + (new Date().getFullYear() + 10) + ")");
      return;
    }
    
    if (!book.subject) {
      alert("Please select a subject");
      return;
    }
    
    if (!book.collectionType) {
      alert("Please select a collection type");
      return;
    }
    
    if (!book.stock || isNaN(book.stock) || book.stock < 1) {
      alert("Please enter a valid stock number (minimum 1)");
      return;
    }
    
    if (book.location.shelf === '' || isNaN(book.location.shelf)) {
      alert("Please enter a shelf number");
      return;
    }
    
    if (book.location.level === '' || isNaN(book.location.level)) {
      alert("Please enter a shelf level");
      return;
    }

    // Check for duplicates before submitting
    await checkDuplicate();
  };

  const checkDuplicate = async () => {
    try {
      console.log("🔍 Checking for duplicate books...");
      const res = await fetch("https://paranaque-web-system.onrender.com/api/books/check-duplicate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: book.title,
          author: book.author
        })
      });

      const data = await res.json();
      
      if (data.isDuplicate) {
        console.log("⚠️  Duplicate book found:", data.message);
        setDuplicateBook(data.existingBook);
        setShowDuplicateModal(true);
      } else {
        console.log("✅ No duplicate found, proceeding with submission...");
        submitBook();
      }
    } catch (err) {
      console.error("❌ Error checking duplicate:", err);
      alert("Error checking for duplicates: " + (err.message || "Network error"));
    }
  };

  const submitBook = async () => {
    setLoading(true);
    console.log("🔄 Starting book submission...");

    const payload = {
      title: book.title,
      year: parseInt(book.year),
      author: book.author,
      publisher: book.publisher || "Unknown",
      category: book.category,
      subject: book.subject,
      collectionType: book.collectionType,
      sourceOfFunds: book.sourceOfFunds || null,
      stock: parseInt(book.stock) || 1,
      callNumber: book.callNumber,
      location: {
        genreCode: book.subject.slice(0, 3).toUpperCase(),
        shelf: parseInt(book.location.shelf),
        level: parseInt(book.location.level)
      },
      image: base64Image,
      userEmail: localStorage.getItem('userEmail') || 'admin'
    };

    console.log("📤 Submitting book with image:", {
      title: payload.title,
      hasImage: !!payload.image,
      imageSize: payload.image ? payload.image.length : 0
    });

    try {
      const res = await fetch("https://paranaque-web-system.onrender.com/api/books", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      setLoading(false);

      if (res.ok) {
        console.log("✅ Book added successfully! Image URL:", data.book?.image);
        setShowSuccessModal(true);
        setShowDuplicateModal(false);
        setBook({
          title: "",
          year: "",
          genre: "",
          category: book.category,  // Keep the selected category
          stock: "1",
          location: { shelf: "", level: "" },
          author: "",
          publisher: "",
          accessionNumber: "",
          callNumber: "",
          image: null
        });
        setPreview(null);
        setBase64Image("");

        if (onBookAdded) onBookAdded();
      } else if (res.status === 409) {
        // Duplicate book error
        console.error("⚠️  Duplicate book error:", data.message);
        setDuplicateBook(data.existingBook);
        setShowDuplicateModal(true);
      } else {
        console.error("❌ Failed to add book:", data.error);
        alert("Failed to add book: " + (data.error || "Unknown error"));
      }
    } catch (err) {
      setLoading(false);
      console.error("❌ Error adding book:", err);
      alert("Error adding book: " + (err.message || "Network error"));
    }
  };

  return (
    <div className="add-book-container" style={styles.container}>
      {console.log("📝 AddBook component rendering")}
      <img src={logo} alt="Library Logo" style={styles.logo} />

      <h2 style={styles.title}>Add a Book</h2>

      <form onSubmit={handleSubmit} style={styles.form} aria-label="Add Book Form">

        <div style={styles.inputGroup}>
          <label style={styles.label}>Call Number (Auto-Generated)</label>
          <input 
            type="text" 
            value={nextCallNumber} 
            disabled 
            style={{...styles.input, backgroundColor: '#f5f5f5', color: '#666', cursor: 'not-allowed'}}
            aria-label="Auto-generated call number"
          />
          <small style={{color: '#999', marginTop: '5px', display: 'block'}}>Format: PREFIX.DDC-CUTTER-YEAR (e.g., F.500-SMI-2020)</small>
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Accession Number (Auto-Generated)</label>
          <input 
            type="text" 
            value={nextAccessionNumber} 
            disabled 
            style={{...styles.input, backgroundColor: '#f5f5f5', color: '#666', cursor: 'not-allowed'}}
            aria-label="Auto-generated accession number"
          />
          <small style={{color: '#999', marginTop: '5px', display: 'block'}}>This book will automatically get this accession number</small>
        </div>

        <Input label="Book Title" name="title" value={book.title} onChange={handleChange} required />

        <Input label="Author" name="author" value={book.author} onChange={handleChange} required />

        <Input label="Publisher (Optional)" name="publisher" value={book.publisher} onChange={handleChange} />

        <Input label="Year Published" type="number" name="year" value={book.year} onChange={handleChange} required />

        <Input label="Number of Copies" type="number" name="stock" min="1" value={book.stock} onChange={(e) => {
          const value = e.target.value;
          if (value === '' || parseInt(value) > 0) {
            setBook({ ...book, stock: value });
          }
        }} required />

        <Select label="Subject" name="subject" value={book.subject} onChange={handleChange} options={categories} required />

        <button type="button" onClick={() => setShowCategoryModal(true)} style={styles.addCategoryBtn}>
          + Add New Subject
        </button>

        <Select 
          label="Collection Type" 
          name="collectionType" 
          value={book.collectionType} 
          onChange={handleChange} 
          options={['Filipiniana', 'Reference', 'Circulation']} 
          required 
        />

        <Select 
          label="Source of Funds" 
          name="sourceOfFunds" 
          value={book.sourceOfFunds} 
          onChange={handleChange} 
          options={['', 'Donation', 'Locally funded', 'National Library of the Philippines']}
        />

        <div style={styles.row}>
          <Input small label="Shelf Number" name="shelf" type="number" min="0" value={book.location.shelf} onChange={(e) => {
            const value = e.target.value;
            if (value === '' || parseInt(value) >= 0) {
              setBook({ ...book, location: { ...book.location, shelf: value } });
            }
          }} required />
          <Input small label="Shelf Level" name="level" type="number" min="0" value={book.location.level} onChange={(e) => {
            const value = e.target.value;
            if (value === '' || parseInt(value) >= 0) {
              setBook({ ...book, location: { ...book.location, level: value } });
            }
          }} required />
        </div>

        <div style={styles.inputGroup}>
          <label style={styles.label}>Book Image</label>
          <input type="file" name="image" accept="image/*" onChange={handleChange} aria-label="Upload Book Image" />
          {preview && <img src={preview} alt="Preview" style={styles.preview} />}
        </div>

        <button type="submit" style={styles.submitBtn} disabled={loading}>
          {loading ? "Adding Book..." : "Add Book"}
        </button>
      </form>

      {showCategoryModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Add New Subject</h3>
            <input
              type="text"
              placeholder="Enter category name"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              style={styles.input}
            />
            <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
              <button onClick={handleAddCategory} style={styles.submitBtn}>
                Add Category
              </button>
              <button onClick={() => { setShowCategoryModal(false); setNewCategory(""); }} style={styles.cancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Book Added Successfully!</h3>
            <button onClick={() => setShowSuccessModal(false)} style={styles.closeModalBtn}>
              Close
            </button>
          </div>
        </div>
      )}

      {showDuplicateModal && duplicateBook && (
        <div style={styles.modalOverlay}>
          <div style={{...styles.modal, maxWidth: '450px', background: '#fff3cd'}}>
            <h3 style={{color: '#856404', marginTop: 0}}>⚠️ Duplicate Book Warning</h3>
            <p style={{color: '#856404', fontSize: '14px', lineHeight: '1.6'}}>
              This book already exists in the library system:
            </p>
            <div style={{
              background: '#fff',
              padding: '15px',
              borderRadius: '5px',
              marginBottom: '15px',
              border: '1px solid #ffeaa7'
            }}>
              <p style={{margin: '8px 0', fontSize: '14px'}}>
                <strong>Title:</strong> {duplicateBook.title}
              </p>
              <p style={{margin: '8px 0', fontSize: '14px'}}>
                <strong>Author:</strong> {duplicateBook.author}
              </p>
              <p style={{margin: '8px 0', fontSize: '14px'}}>
                <strong>Year:</strong> {duplicateBook.year}
              </p>
              <p style={{margin: '8px 0', fontSize: '14px'}}>
                <strong>Accession #:</strong> {duplicateBook.accessionNumber}
              </p>
              <p style={{margin: '8px 0', fontSize: '14px'}}>
                <strong>Current Stock:</strong> {duplicateBook.stock}
              </p>
            </div>
            <p style={{color: '#856404', fontSize: '13px', fontStyle: 'italic'}}>
              Do you want to proceed with adding another copy, or cancel?
            </p>
            <div style={{ display: "flex", gap: "10px", marginTop: "15px", justifyContent: 'center' }}>
              <button 
                onClick={() => {
                  setShowDuplicateModal(false);
                  submitBook();
                }} 
                style={{...styles.submitBtn, background: '#ff9800'}}
                disabled={loading}
              >
                {loading ? "Adding..." : "Proceed Anyway"}
              </button>
              <button 
                onClick={() => { 
                  setShowDuplicateModal(false); 
                  setDuplicateBook(null);
                }} 
                style={styles.cancelBtn}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const Input = ({ label, name, value, onChange, type = "text", required = false, disabled = false, small = false, min = undefined }) => (
  <div style={{ marginBottom: "15px", width: small ? "48%" : "100%" }}>
    <label style={styles.label}>{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      aria-label={label}
      style={styles.input}
      min={min}
    />
  </div>
);

const Select = ({ label, name, value, onChange, options, required = false }) => (
  <div style={styles.inputGroup}>
    <label style={styles.label}>{label}</label>
    <select name={name} value={value} onChange={onChange} required={required} style={styles.input} aria-label={label}>
      <option value="">Select {label}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

const styles = {
  container: { display: "flex", flexDirection: "column", alignItems: "center", padding: "30px", minHeight: "100%", width: "100%", visibility: "visible", opacity: 1 },
  logo: { width: "100px", marginBottom: "15px" },
  title: { fontWeight: "700", marginBottom: "20px" },
  form: { width: "100%", maxWidth: "450px" },
  row: { display: "flex", justifyContent: "space-between", gap: "10px" },
  inputGroup: { marginBottom: "15px", width: "104%" },
  label: { display: "block", marginBottom: "6px", fontWeight: "600" },
  input: { width: "100%", padding: "8px", borderRadius: "5px", border: "1px solid #ccc", visibility: "visible" },
  preview: { width: "100%", marginTop: "10px", borderRadius: "5px" },
  submitBtn: { width: "100%", padding: "12px", backgroundColor: "#1dbf73", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", pointerEvents: "auto", visibility: "visible" },
  addCategoryBtn: { width: "104%", padding: "10px", backgroundColor: "#17a2b8", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", marginTop: "-10px", marginBottom: "15px", pointerEvents: "auto", visibility: "visible" },
  cancelBtn: { flex: 1, padding: "12px", backgroundColor: "#6c757d", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontWeight: "600", pointerEvents: "auto", visibility: "visible" },
  modalOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 2000, visibility: "visible" },
  modal: { background: "#fff", padding: "30px", borderRadius: "8px", textAlign: "center", width: "300px", zIndex: 2001, maxHeight: "90vh", overflowY: "auto", visibility: "visible" },
  closeModalBtn: { marginTop: "15px", padding: "8px 15px", background: "#1dbf73", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", pointerEvents: "auto", visibility: "visible" }
};

export default AddBook;
